"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		module.exports = factory( global, true );
	} else {
		factory( global );
	}

} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

"use strict";

if ( !window.document ) {
	throw new Error( "jQuery requires a window with a document" );
}

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	return typeof obj === "object" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}

function isWindow( obj ) {
	return obj != null && obj === obj.window;
}

function isArrayLike( obj ) {

	var length = !!obj && obj.length,
		type = toType( obj );

	if ( typeof obj === "function" || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}

var document$1 = window.document;

var preservedScriptAttributes = {
	type: true,
	src: true,
	nonce: true,
	noModule: true
};

function DOMEval( code, node, doc ) {
	doc = doc || document$1;

	var i,
		script = doc.createElement( "script" );

	script.text = code;
	for ( i in preservedScriptAttributes ) {
		if ( node && node[ i ] ) {
			script[ i ] = node[ i ];
		}
	}

	if ( doc.head.appendChild( script ).parentNode ) {
		script.parentNode.removeChild( script );
	}
}

var version = "4.0.0",

	rhtmlSuffix = /HTML$/i,

	jQuery = function( selector, context ) {

		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	jquery: version,

	constructor: jQuery,

	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	get: function( num ) {

		if ( num == null ) {
			return slice.call( this );
		}

		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	pushStack: function( elems ) {

		var ret = jQuery.merge( this.constructor(), elems );

		ret.prevObject = this;

		return ret;
	},

	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	}
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	if ( typeof target === "boolean" ) {
		deep = target;

		target = arguments[ i ] || {};
		i++;
	}

	if ( typeof target !== "object" && typeof target !== "function" ) {
		target = {};
	}

	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		if ( ( options = arguments[ i ] ) != null ) {

			for ( name in options ) {
				copy = options[ name ];

				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					target[ name ] = jQuery.extend( deep, clone, copy );

				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	return target;
};

jQuery.extend( {

	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		if ( !proto ) {
			return true;
		}

		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			while ( ( node = elem[ i++ ] ) ) {

				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}


		return ret;
	},


	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	contains: function( a, b ) {
		var bup = b && b.parentNode;

		return a === bup || !!( bup && bup.nodeType === 1 && (

			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		return flat( ret );
	},

	guid: 1,

	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function nodeName( elem, name ) {
	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
}

var pop = arr.pop;

var whitespace = "[\\x20\\t\\r\\n\\f]";

var isIE = document$1.documentMode;

var rbuggyQSA = isIE && new RegExp(

	":enabled|:disabled|" +

	"\\[" + whitespace + "*name" + whitespace + "*=" +
	whitespace + "*(?:''|\"\")"

);

var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);

var identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
	"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+";

var rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" +
	whitespace + ")" + whitespace + "*" );

var rdescend = new RegExp( whitespace + "|>" );

var rsibling = /[+~]/;

var documentElement$1 = document$1.documentElement;

var matches = documentElement$1.matches || documentElement$1.msMatchesSelector;

function createCache() {
	var keys = [];

	function cache( key, value ) {

		if ( keys.push( key + " " ) > jQuery.expr.cacheLength ) {

			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

var attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

	"*([*^$|!~]?=)" + whitespace +

	"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
	whitespace + "*\\]";

var pseudos = ":(" + identifier + ")(?:\\((" +

	"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

	"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

	".*" +
	")\\)|)";

var filterMatchExpr = {
	ID: new RegExp( "^#(" + identifier + ")" ),
	CLASS: new RegExp( "^\\.(" + identifier + ")" ),
	TAG: new RegExp( "^(" + identifier + "|[*])" ),
	ATTR: new RegExp( "^" + attributes ),
	PSEUDO: new RegExp( "^" + pseudos ),
	CHILD: new RegExp(
		"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
		whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
		whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" )
};

var rpseudo = new RegExp( pseudos );


var runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
	"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			return nonHex;
		}

		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	};

function unescapeSelector( sel ) {
	return sel.replace( runescape, funescape );
}

function selectorError( msg ) {
	jQuery.error( "Syntax error, unrecognized expression: " + msg );
}

var rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" );

var tokenCache = createCache();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = jQuery.expr.preFilter;

	while ( soFar ) {

		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		for ( type in filterMatchExpr ) {
			if ( ( match = jQuery.expr.match[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		selectorError( selector ) :

		tokenCache( selector, groups ).slice( 0 );
}

var preFilter = {
	ATTR: function( match ) {
		match[ 1 ] = unescapeSelector( match[ 1 ] );

		match[ 3 ] = unescapeSelector( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" );

		if ( match[ 2 ] === "~=" ) {
			match[ 3 ] = " " + match[ 3 ] + " ";
		}

		return match.slice( 0, 4 );
	},

	CHILD: function( match ) {

		match[ 1 ] = match[ 1 ].toLowerCase();

		if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

			if ( !match[ 3 ] ) {
				selectorError( match[ 0 ] );
			}

			match[ 4 ] = +( match[ 4 ] ?
				match[ 5 ] + ( match[ 6 ] || 1 ) :
				2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
			);
			match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

		} else if ( match[ 3 ] ) {
			selectorError( match[ 0 ] );
		}

		return match;
	},

	PSEUDO: function( match ) {
		var excess,
			unquoted = !match[ 6 ] && match[ 2 ];

		if ( filterMatchExpr.CHILD.test( match[ 0 ] ) ) {
			return null;
		}

		if ( match[ 3 ] ) {
			match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

		} else if ( unquoted && rpseudo.test( unquoted ) &&

			( excess = tokenize( unquoted, true ) ) &&

			( excess = unquoted.indexOf( ")", unquoted.length - excess ) -
				unquoted.length ) ) {

			match[ 0 ] = match[ 0 ].slice( 0, excess );
			match[ 2 ] = unquoted.slice( 0, excess );
		}

		return match.slice( 0, 3 );
	}
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function access( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	} else if ( value !== undefined ) {
		chainable = true;

		if ( typeof value !== "function" ) {
			raw = true;
		}

		if ( bulk ) {

			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
}

var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ];
		}

		if ( value !== undefined ) {
			if ( value === null ||

				( value === false && name.toLowerCase().indexOf( "aria-" ) !== 0 ) ) {

				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = elem.getAttribute( name );

		return ret == null ? undefined : ret;
	},

	attrHooks: {},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

if ( isIE ) {
	jQuery.attrHooks.type = {
		set: function( elem, value ) {
			if ( value === "radio" && nodeName( elem, "input" ) ) {
				var val = elem.value;
				elem.setAttribute( "type", value );
				if ( val ) {
					elem.value = val;
				}
				return value;
			}
		}
	};
}

var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

var sort = arr.sort;

var splice = arr.splice;

var hasDuplicate;

function sortOrder( a, b ) {

	if ( a === b ) {
		hasDuplicate = true;
		return 0;
	}

	var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	if ( compare ) {
		return compare;
	}

	compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
		a.compareDocumentPosition( b ) :

		1;

	if ( compare & 1 ) {

		if ( a == document$1 || a.ownerDocument == document$1 &&
			jQuery.contains( document$1, a ) ) {
			return -1;
		}

		if ( b == document$1 || b.ownerDocument == document$1 &&
			jQuery.contains( document$1, b ) ) {
			return 1;
		}

		return 0;
	}

	return compare & 4 ? -1 : 1;
}

jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	hasDuplicate = false;

	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

var i,
	outermostContext,

	document,
	documentElement,
	documentIsHTML,

	dirruns = 0,
	done = 0,
	classCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),


	rwhitespace = new RegExp( whitespace + "+", "g" ),

	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = jQuery.extend( {

		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	}, filterMatchExpr ),

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		nodeType = context ? context.nodeType : 9;

	results = results || [];

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			if ( nodeType !== 11 && ( match = rquickExpr$1.exec( selector ) ) ) {

				if ( ( m = match[ 1 ] ) ) {

					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {
							push.call( results, elem );
						}
						return results;

					} else {
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							jQuery.contains( context, elem ) ) {

							push.call( results, elem );
							return results;
						}
					}

				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					newContext = rsibling.test( selector ) &&
						testContext( context.parentNode ) ||
						context;

					if ( newContext != context || isIE ) {

						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = jQuery.expando ) );
						}
					}

					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === jQuery.expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

function markFunction( fn ) {
	fn[ jQuery.expando ] = true;
	return fn;
}

function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

function createDisabledPseudo( disabled ) {

	return function( elem ) {

		if ( "form" in elem ) {

			if ( elem.parentNode && elem.disabled === false ) {

				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				return elem.isDisabled === disabled ||

					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		return false;
	};
}

function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : document$1;

	if ( doc == document || doc.nodeType !== 9 ) {
		return;
	}

	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	if ( isIE && document$1 != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
		subWindow.addEventListener( "unload", unloadHandler );
	}
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			return matches.call( elem, expr );
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

jQuery.expr = {

	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	find: {
		ID: function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		},

		TAG: function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			} else {
				return context.querySelectorAll( tag );
			}
		},

		CLASS: function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		}
	},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: preFilter,

	filter: {
		ID: function( id ) {
			var attrId = unescapeSelector( id );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		},

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = unescapeSelector( nodeNameSelector ).toLowerCase();
			return nodeNameSelector === "*" ?

				function() {
					return true;
				} :

				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = jQuery.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						if ( forward && useCache ) {

							outerCache = parent[ jQuery.expando ] ||
								( parent[ jQuery.expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							if ( useCache ) {
								outerCache = elem[ jQuery.expando ] ||
									( elem[ jQuery.expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							if ( diff === false ) {

								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										if ( useCache ) {
											outerCache = node[ jQuery.expando ] ||
												( node[ jQuery.expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			var fn = jQuery.expr.pseudos[ pseudo ] ||
				jQuery.expr.setFilters[ pseudo.toLowerCase() ] ||
				selectorError( "unsupported pseudo: " + pseudo );

			if ( fn[ jQuery.expando ] ) {
				return fn( argument );
			}

			return fn;
		}
	},

	pseudos: {

		not: markFunction( function( selector ) {

			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ jQuery.expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = unescapeSelector( text );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		lang: markFunction( function( lang ) {

			if ( !ridentifier.test( lang || "" ) ) {
				selectorError( "unsupported lang: " + lang );
			}
			lang = unescapeSelector( lang ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === document.activeElement &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			if ( isIE && elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		empty: function( elem ) {

			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !jQuery.expr.pseudos.empty( elem );
		},

		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "text";
		},

		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

jQuery.expr.pseudos.nth = jQuery.expr.pseudos.eq;

for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	jQuery.expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	jQuery.expr.pseudos[ i ] = createButtonPseudo( i );
}

function setFilters() {}
setFilters.prototype = jQuery.expr.pseudos;
jQuery.expr.setFilters = new setFilters();

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ jQuery.expando ] || ( elem[ jQuery.expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							outerCache[ key ] = newCache;

							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ jQuery.expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ jQuery.expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				[] :

				results;

			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = jQuery.expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || jQuery.expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = jQuery.expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = jQuery.expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			if ( matcher[ jQuery.expando ] ) {

				j = ++i;
				for ( ; j < len; j++ ) {
					if ( jQuery.expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				elems = seed || byElement && jQuery.expr.find.TAG( "*", outermost ),

				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 );

			if ( outermost ) {

				outermostContext = context == document || context || outermost;
			}

			for ( ; ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				if ( bySet ) {

					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			matchedCount += i;

			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					setMatched = condense( setMatched );
				}

				push.apply( results, setMatched );

				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match  ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ jQuery.expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		cached.selector = selector;
	}
	return cached;
}

function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	if ( match.length === 1 ) {

		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML &&
				jQuery.expr.relative[ tokens[ 1 ].type ] ) {

			context = ( jQuery.expr.find.ID(
				unescapeSelector( token.matches[ 0 ] ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			if ( jQuery.expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = jQuery.expr.find[ type ] ) ) {

				if ( ( seed = find(
					unescapeSelector( token.matches[ 0 ] ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

setDocument();

jQuery.find = find;

find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

function dir( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
}

function siblings( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
}

var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

function isObviousHtml( input ) {
	return input[ 0 ] === "<" &&
		input[ input.length - 1 ] === ">" &&
		input.length >= 3;
}

function winnow( elements, qualifier, not ) {
	if ( typeof qualifier === "function" ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


var rootjQuery,

	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		if ( !selector ) {
			return this;
		}

		if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		} else if ( typeof selector === "function" ) {
			return rootjQuery.ready !== undefined ?
				rootjQuery.ready( selector ) :

				selector( jQuery );

		} else {

			match = selector + "";
			if ( isObviousHtml( match ) ) {

				match = [ null, selector, null ];

			} else if ( typeof selector === "string" ) {
				match = rquickExpr.exec( selector );
			} else {
				return jQuery.makeArray( selector, this );
			}

			if ( match && ( match[ 1 ] || !context ) ) {

				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document$1,
						true
					) );

					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							if ( typeof this[ match ] === "function" ) {
								this[ match ]( context[ match ] );

							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				} else {
					elem = document$1.getElementById( match[ 2 ] );

					if ( elem ) {

						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			} else {
				return this.constructor( context ).find( selector );
			}
		}

	};

init.prototype = jQuery.fn;

rootjQuery = jQuery( document$1 );

var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	index: function( elem ) {

		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		return indexOf.call( this,

			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );

function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

jQuery.Callbacks = function( options ) {

	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var 
		firing,

		memory,

		fired,

		locked,

		list = [],

		queue = [],

		firingIndex = -1,

		fire = function() {

			locked = locked || options.once;

			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						firingIndex = list.length;
						memory = false;
					}
				}
			}

			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			if ( locked ) {

				if ( memory ) {
					list = [];

				} else {
					list = "";
				}
			}
		},

		self = {

			add: function() {
				if ( list ) {

					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( typeof arg === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			fired: function() {
				return !!fired;
			}
		};

	return self;
};

function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		if ( value && typeof( method = value.promise ) === "function" ) {
			method.call( value ).done( resolve ).fail( reject );

		} else if ( value && typeof( method = value.then ) === "function" ) {
			method.call( value, resolve, reject );

		} else {

			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	} catch ( value ) {
		reject( value );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				catch: function( fn ) {
					return promise.then( null, fn );
				},

				pipe: function(  ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							var fn = typeof fns[ tuple[ 4 ] ] === "function" &&
								fns[ tuple[ 4 ] ];

							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && typeof returned.promise === "function" ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									then = returned &&

										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									if ( typeof then === "function" ) {

										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										} else {

											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									} else {

										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										( special || deferred.resolveWith )( that, args );
									}
								},

								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											if ( depth + 1 >= maxDepth ) {

												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							if ( depth ) {
								process();
							} else {

								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								typeof onProgress === "function" ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								typeof onFulfilled === "function" ?
									onFulfilled :
									Identity
							)
						);

						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								typeof onRejected === "function" ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			promise[ tuple[ 1 ] ] = list.add;

			if ( stateString ) {
				list.add(
					function() {

						state = stateString;
					},

					tuples[ 3 - i ][ 2 ].disable,

					tuples[ 3 - i ][ 3 ].disable,

					tuples[ 0 ][ 2 ].lock,

					tuples[ 0 ][ 3 ].lock
				);
			}

			list.add( tuple[ 3 ].fire );

			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		promise.promise( deferred );

		if ( func ) {
			func.call( deferred, deferred );
		}

		return deferred;
	},

	when: function( singleValue ) {
		var

			remaining = arguments.length,

			i = remaining,

			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			primary = jQuery.Deferred(),

			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			if ( primary.state() === "pending" ||
				typeof( resolveValues[ i ] && resolveValues[ i ].then ) === "function" ) {

				return primary.then();
			}
		}

		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );

var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	if ( error && rerrorNames.test( error.name ) ) {
		window.console.warn(
			"jQuery.Deferred exception",
			error,
			asyncError
		);
	}
};

jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};

var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	isReady: false,

	readyWait: 1,

	ready: function( wait ) {

		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		jQuery.isReady = true;

		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		readyList.resolveWith( document$1, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

function completed() {
	document$1.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

if ( document$1.readyState !== "loading" ) {

	window.setTimeout( jQuery.ready );

} else {

	document$1.addEventListener( "DOMContentLoaded", completed );

	window.addEventListener( "load", completed );
}

var rdashAlpha = /-([a-z])/g;

function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

function camelCase( string ) {
	return string.replace( rdashAlpha, fcamelCase );
}

function acceptData( owner ) {

	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
}

function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		var value = owner[ this.expando ];

		if ( !value ) {
			value = Object.create( null );

			if ( acceptData( owner ) ) {

				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		} else {

			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return value;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		this.set( owner, key, value );

		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			if ( Array.isArray( key ) ) {

				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};

var dataPriv = new Data();

var dataUser = new Data();


var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			if ( elem && value === undefined ) {

				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				return;
			}

			this.each( function() {

				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );

jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.set( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.set( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );

var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

function isHiddenWithinTree( elem, el ) {

	elem = el || elem;

	return elem.style.display === "none" ||
		elem.style.display === "" &&
		jQuery.css( elem, "display" ) === "none";
}

var ralphaStart = /^[a-z]/,

	rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;

function isAutoPx( prop ) {

	return ralphaStart.test( prop ) &&
		rautoPx.test( prop[ 0 ].toUpperCase() + prop.slice( 1 ) );
}

function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( isAutoPx( prop ) ? "px" : "" ),

		initialInUnit = elem.nodeType &&
			( !isAutoPx( prop ) || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		initial = initial / 2;

		unit = unit || initialInUnit[ 3 ];

		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}

var rmsPrefix = /^-ms-/;

function cssCamelCase( string ) {
	return camelCase( string.replace( rmsPrefix, "ms-" ) );
}

var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				dataPriv.set( elem, "display", display );
			}
		}
	}

	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );

var isAttached = function( elem ) {
		return jQuery.contains( elem.ownerDocument, elem ) ||
			elem.getRootNode( composed ) === elem.ownerDocument;
	},
	composed = { composed: true };

if ( !documentElement$1.getRootNode ) {
	isAttached = function( elem ) {
		return jQuery.contains( elem.ownerDocument, elem );
	};
}

var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

var wrapMap = {

	thead: [ "table" ],
	col: [ "colgroup", "table" ],
	tr: [ "tbody", "table" ],
	td: [ "tr", "tbody", "table" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

function getAll( context, tag ) {

	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {

		ret = arr.slice.call( context.getElementsByTagName( tag || "*" ) );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}

var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}

var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			if ( toType( elem ) === "object" && ( elem.nodeType || isArrayLike( elem ) ) ) {
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || arr;

				j = wrap.length;
				while ( --j > -1 ) {
					tmp = tmp.appendChild( context.createElement( wrap[ j ] ) );
				}

				tmp.innerHTML = jQuery.htmlPrefilter( elem );

				jQuery.merge( nodes, tmp.childNodes );

				tmp = fragment.firstChild;

				tmp.textContent = "";
			}
		}
	}

	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		tmp = getAll( fragment.appendChild( elem ), "script" );

		if ( attached ) {
			setGlobalEval( tmp );
		}

		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}

function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function domManip( collection, args, callback, ignored ) {

	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = typeof value === "function";

	if ( valueIsFunction ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			args[ 0 ] = value.call( this, index, self.html() );
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					if ( hasScripts ) {
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				jQuery.map( scripts, restoreScript );

				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.get( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce,
									crossOrigin: node.crossOrigin
								}, doc );
							}
						} else {
							DOMEval( node.textContent, node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

var rcheckableType = /^(?:checkbox|radio)$/i;

var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	if ( typeof types === "object" ) {

		if ( typeof selector !== "string" ) {

			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			fn = data;
			data = undefined;
		} else {

			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

jQuery.event = {

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		if ( !acceptData( elem ) ) {
			return;
		}

		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		if ( selector ) {
			jQuery.find.matchesSelector( documentElement$1, selector );
		}

		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			if ( !type ) {
				continue;
			}

			special = jQuery.event.special[ type ] || {};

			type = ( selector ? special.delegateType : special.bindType ) || type;

			special = jQuery.event.special[ type ] || {};

			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}
		}

	},

	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		if ( delegateCount &&

			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: typeof hook === "function" ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: jQuery.extend( Object.create( null ), {
		load: {

			noBubble: true
		},
		click: {

			setup: function( data ) {

				var el = this || data;

				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click", true );
				}

				return false;
			},
			trigger: function( data ) {

				var el = this || data;

				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				return true;
			},

			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {
				if ( event.result !== undefined ) {

					event.preventDefault();
				}
			}
		}
	} )
};

function leverageNative( el, type, isSetup ) {

	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				if ( !saved.length ) {

					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						event.stopImmediatePropagation();
						event.preventDefault();

						return result && result.value;
					}

				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			} else if ( saved.length ) {

				dataPriv.set( this, type, {
					value: jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					)
				} );

				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		this.isDefaultPrevented = src.defaultPrevented ?
			returnTrue :
			returnFalse;

		this.target = src.target;
		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	} else {
		this.type = src;
	}

	if ( props ) {
		jQuery.extend( this, props );
	}

	this.timeStamp = src && src.timeStamp || Date.now();

	this[ jQuery.expando ] = true;
};

jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {

		var event = jQuery.event.fix( nativeEvent );
		event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
		event.isSimulated = true;

		if ( event.target === event.currentTarget ) {

			dataPriv.get( this, "handle" )( event );
		}
	}

	jQuery.event.special[ type ] = {

		setup: function() {

			leverageNative( this, type, true );

			if ( isIE ) {
				this.addEventListener( delegateType, focusMappedHandler );
			} else {

				return false;
			}
		},
		trigger: function() {

			leverageNative( this, type );

			return true;
		},

		teardown: function() {
			if ( isIE ) {
				this.removeEventListener( delegateType, focusMappedHandler );
			} else {

				return false;
			}
		},

		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );

var

	rnoInnerhtml = /<script|<style|<link/i;

function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var type, i, l,
		events = dataPriv.get( src, "events" );

	if ( dest.nodeType !== 1 ) {
		return;
	}

	if ( events ) {
		dataPriv.remove( dest, "handle events" );
		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	if ( dataUser.hasData( src ) ) {
		dataUser.set( dest, jQuery.extend( {}, dataUser.get( src ) ) );
	}
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		if ( isIE && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {

				if ( nodeName( destElements[ i ], "textarea" ) ) {
					destElements[ i ].defaultValue = srcElements[ i ].defaultValue;
				}
			}
		}

		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				jQuery.cleanData( getAll( elem, false ) );

				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );
			push.apply( ret, elems );
		}

		return this.pushStack( ret );
	};
} );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;

function getStyles( elem ) {

	var view = elem.ownerDocument.defaultView;

	if ( !view ) {
		view = window;
	}

	return view.getComputedStyle( elem );
}

function swap( elem, options, callback ) {
	var ret, name,
		old = {};

	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
}

function curCSS( elem, name, computed ) {
	var ret,
		isCustomProp = rcustomProp.test( name );

	computed = computed || getStyles( elem );

	if ( computed ) {

		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}
	}

	return ret !== undefined ?

		ret + "" :
		ret;
}

var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document$1.createElement( "div" ).style;

function vendorPropName( name ) {

	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function finalPropName( name ) {
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorPropName( name ) || name;
}

var reliableTrDimensionsVal, reliableColDimensionsVal,
	table = document$1.createElement( "table" );

function computeTableStyleTests() {
	if (

		!table ||

		!table.style
	) {
		return;
	}

	var trStyle,
		col = document$1.createElement( "col" ),
		tr = document$1.createElement( "tr" ),
		td = document$1.createElement( "td" );

	table.style.cssText = "position:absolute;left:-11111px;" +
		"border-collapse:separate;border-spacing:0";
	tr.style.cssText = "box-sizing:content-box;border:1px solid;height:1px";
	td.style.cssText = "height:9px;width:9px;padding:0";

	col.span = 2;

	documentElement$1
		.appendChild( table )
		.appendChild( col )
		.parentNode
		.appendChild( tr )
		.appendChild( td )
		.parentNode
		.appendChild( td.cloneNode( true ) );

	if ( table.offsetWidth === 0 ) {
		documentElement$1.removeChild( table );
		return;
	}

	trStyle = window.getComputedStyle( tr );

	reliableColDimensionsVal = isIE || Math.round( parseFloat(
		window.getComputedStyle( col ).width )
	) === 18;

	reliableTrDimensionsVal = Math.round( parseFloat( trStyle.height ) +
		parseFloat( trStyle.borderTopWidth ) +
		parseFloat( trStyle.borderBottomWidth ) ) === tr.offsetHeight;

	documentElement$1.removeChild( table );

	table = null;
}

jQuery.extend( support, {
	reliableTrDimensions: function() {
		computeTableStyleTests();
		return reliableTrDimensionsVal;
	},

	reliableColDimensions: function() {
		computeTableStyleTests();
		return reliableColDimensionsVal;
	}
} );

var cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	var matches = rcssNum.exec( value );
	return matches ?

		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		if ( !isBorderBox ) {

			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		} else {

			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	if ( !isBorderBox && computedVal >= 0 ) {

		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	var styles = getStyles( elem ),

		boxSizingNeeded = isIE || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	if (
		(

			val === "auto" ||

			( isIE && isBorderBox ) ||

			( !support.reliableColDimensions() && nodeName( elem, "col" ) ) ||

			( !support.reliableTrDimensions() && nodeName( elem, "tr" ) )
		) &&

		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	val = parseFloat( val ) || 0;

	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			val
		)
	) + "px";
}

jQuery.extend( {

	cssHooks: {},

	style: function( elem, name, value, extra ) {

		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		var ret, type, hooks,
			origName = cssCamelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		if ( value !== undefined ) {
			type = typeof value;

			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				type = "number";
			}

			if ( value == null || value !== value ) {
				return;
			}

			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( isAutoPx( origName ) ? "px" : "" );
			}

			if ( isIE && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = cssCamelCase( name ),
			isCustomProp = rcustomProp.test( name );

		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				return jQuery.css( elem, "display" ) === "none" ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				isBorderBox = extra &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );

function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( isAutoPx( prop ) ? "px" : "" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			result = jQuery.css( tween.elem, tween.prop, "" );

			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

jQuery.fx.step = {};

var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document$1.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, 13 );
		}

		jQuery.fx.tick();
	}
}

function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	if ( isBox && elem.nodeType === 1 ) {

		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	propTween = false;
	for ( prop in orig ) {

		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.set( elem, "fxshow", { display: restoreDisplay } );
			}

			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			if ( hidden ) {
				showHide( [ elem ], true );
			}

			anim.done( function() {

				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	for ( index in props ) {
		name = cssCamelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				percent = 1 - ( remaining / animation.duration || 0 ),
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			}

			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( typeof result.stop === "function" ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( typeof animation.opts.start === "function" ) {
		animation.opts.start.call( elem, animation );
	}

	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( typeof props === "function" ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || easing ||
			typeof speed === "function" && speed,
		duration: speed,
		easing: fn && easing || easing && typeof easing !== "function" && easing
	};

	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	opt.old = opt.complete;

	opt.complete = function() {
		if ( typeof opt.old === "function" ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			data.finish = true;

			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	_default: 400
};

jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};

var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				var tabindex = elem.getAttribute( "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||

					rclickable.test( elem.nodeName ) && elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

if ( isIE ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {


			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

function stripAndCollapse( value ) {
	var tokens = value.match( rnothtmlwhite ) || [];
	return tokens.join( " " );
}

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( typeof value === "function" ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( typeof value === "function" ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self;

		if ( typeof value === "function" ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {

				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}
			} );
		}

		return this;
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = typeof value === "function";

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				for ( ; i < max; i++ ) {
					option = options[ i ];

					if ( option.selected &&

							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						value = jQuery( option ).val();

						if ( one ) {
							return value;
						}

						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( ( option.selected =
						jQuery.inArray( jQuery( option ).val(), values ) > -1
					) ) {
						optionSet = true;
					}
				}

				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

if ( isIE ) {
	jQuery.valHooks.option = {
		get: function( elem ) {

			var val = elem.getAttribute( "value" );
			return val != null ?
				val :

				stripAndCollapse( jQuery.text( elem ) );
		}
	};
}

jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
} );

var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document$1 ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document$1;

		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			if ( tmp === ( elem.ownerDocument || document$1 ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				if ( ontype && typeof elem[ type ] === "function" && !isWindow( elem ) ) {

					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );

var location = window.location;

var nonce = { guid: Date.now() };

var rquery = /\?/;

jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};

var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				add( prefix, v );

			} else {

				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		add( prefix, obj );
	}
}

jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			var value = typeof valueOrFunction === "function" ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );

var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	prefilters = {},

	transports = {},

	allTypes = "*/".concat( "*" ),

	originAnchor = document$1.createElement( "a" );

originAnchor.href = location.href;

function addToPrefiltersOrTransports( structure ) {

	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( typeof func === "function" ) {

			while ( ( dataType = dataTypes[ i++ ] ) ) {

				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		finalDataType = finalDataType || firstDataType;
	}

	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		dataTypes = s.dataTypes.slice();

	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			if ( current === "*" ) {

				current = prev;

			} else if ( prev !== "*" && prev !== current ) {

				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				if ( !conv ) {
					for ( conv2 in converters ) {

						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								if ( conv === true ) {
									conv = converters[ conv2 ];

								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				if ( conv !== true ) {

					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	active: 0,

	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",


		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		converters: {

			"* text": String,

			"text html": true,

			"text json": JSON.parse,

			"text xml": jQuery.parseXML
		},

		flatOptions: {
			url: true,
			context: true
		}
	},

	ajaxSetup: function( target, settings ) {
		return settings ?

			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	ajax: function( url, options ) {

		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		options = options || {};

		var transport,

			cacheURL,

			responseHeadersString,
			responseHeaders,

			timeoutTimer,

			urlAnchor,

			completed,

			fireGlobals,

			i,

			uncached,

			s = jQuery.ajaxSetup( {}, options ),

			callbackContext = s.context || s,

			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			statusCode = s.statusCode || {},

			requestHeaders = {},
			requestHeadersNames = {},

			strAbort = "canceled",

			jqXHR = {
				readyState: 0,

				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {

								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							jqXHR.always( map[ jqXHR.status ] );
						} else {

							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		deferred.promise( jqXHR );

		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		s.type = options.method || options.type || s.method || s.type;

		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		if ( s.crossDomain == null ) {
			urlAnchor = document$1.createElement( "a" );

			try {
				urlAnchor.href = s.url;

				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				s.crossDomain = true;
			}
		}

		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		if ( completed ) {
			return jqXHR;
		}

		fireGlobals = jQuery.event && s.global;

		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		s.type = s.type.toUpperCase();

		s.hasContent = !rnoContent.test( s.type );

		cacheURL = s.url.replace( rhash, "" );

		if ( !s.hasContent ) {

			uncached = s.url.slice( cacheURL.length );

			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				delete s.data;
			}

			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" +
					( nonce.guid++ ) + uncached;
			}

			s.url = cacheURL + uncached;

		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			return jqXHR.abort();
		}

		strAbort = "abort";

		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			if ( completed ) {
				return jqXHR;
			}

			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				if ( completed ) {
					throw e;
				}

				done( -1, e );
			}
		}

		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			if ( completed ) {
				return;
			}

			completed = true;

			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			transport = undefined;

			responseHeadersString = headers || "";

			jqXHR.readyState = status > 0 ? 4 : 0;

			isSuccess = status >= 200 && status < 300 || status === 304;

			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			response = ajaxConvert( s, response, jqXHR, isSuccess );

			if ( isSuccess ) {

				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				} else if ( status === 304 ) {
					statusText = "notmodified";

				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		if ( typeof data === "function" || data === null ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );

jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		scriptAttrs: options.crossOrigin ? { "crossOrigin": options.crossOrigin } : undefined,

		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};

jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( typeof html === "function" ) {
				html = html.call( this[ 0 ] );
			}

			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( typeof html === "function" ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = typeof html === "function";

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );

jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};

jQuery.ajaxSettings.xhr = function() {
	return new window.XMLHttpRequest();
};

var xhrSuccessStatus = {

	0: 200
};

jQuery.ajaxTransport( function( options ) {
	var callback;

	return {
		send: function( headers, complete ) {
			var i,
				xhr = options.xhr();

			xhr.open(
				options.type,
				options.url,
				options.async,
				options.username,
				options.password
			);

			if ( options.xhrFields ) {
				for ( i in options.xhrFields ) {
					xhr[ i ] = options.xhrFields[ i ];
				}
			}

			if ( options.mimeType && xhr.overrideMimeType ) {
				xhr.overrideMimeType( options.mimeType );
			}

			if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
				headers[ "X-Requested-With" ] = "XMLHttpRequest";
			}

			for ( i in headers ) {
				xhr.setRequestHeader( i, headers[ i ] );
			}

			callback = function( type ) {
				return function() {
					if ( callback ) {
						callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;

						if ( type === "abort" ) {
							xhr.abort();
						} else if ( type === "error" ) {
							complete(

								xhr.status,
								xhr.statusText
							);
						} else {
							complete(
								xhrSuccessStatus[ xhr.status ] || xhr.status,
								xhr.statusText,

								( xhr.responseType || "text" ) === "text" ?
									{ text: xhr.responseText } :
									{ binary: xhr.response },
								xhr.getAllResponseHeaders()
							);
						}
					}
				};
			};

			xhr.onload = callback();
			xhr.onabort = xhr.onerror = xhr.ontimeout = callback( "error" );

			callback = callback( "abort" );

			try {

				xhr.send( options.hasContent && options.data || null );
			} catch ( e ) {

				if ( callback ) {
					throw e;
				}
			}
		},

		abort: function() {
			if ( callback ) {
				callback();
			}
		}
	};
} );

function canUseScriptTag( s ) {

	return s.scriptAttrs || (
		!s.headers &&
		(
			s.crossDomain ||

			( s.async && jQuery.inArray( "json", s.dataTypes ) < 0 )
		)
	);
}

jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}

	if ( canUseScriptTag( s ) ) {
		s.type = "GET";
	}
} );

jQuery.ajaxTransport( "script", function( s ) {
	if ( canUseScriptTag( s ) ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				document$1.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

jQuery.ajaxPrefilter( "jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	callbackName = s.jsonpCallback = typeof s.jsonpCallback === "function" ?
		s.jsonpCallback() :
		s.jsonpCallback;

	if ( jsonProp ) {
		s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
	} else if ( s.jsonp !== false ) {
		s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
	}

	s.converters[ "script json" ] = function() {
		if ( !responseContainer ) {
			jQuery.error( callbackName + " was not called" );
		}
		return responseContainer[ 0 ];
	};

	s.dataTypes[ 0 ] = "json";

	overwritten = window[ callbackName ];
	window[ callbackName ] = function() {
		responseContainer = arguments;
	};

	jqXHR.always( function() {

		if ( overwritten === undefined ) {
			jQuery( window ).removeProp( callbackName );

		} else {
			window[ callbackName ] = overwritten;
		}

		if ( s[ callbackName ] ) {

			s.jsonpCallback = originalSettings.jsonpCallback;

			oldCallbacks.push( callbackName );
		}

		if ( responseContainer && typeof overwritten === "function" ) {
			overwritten( responseContainer[ 0 ] );
		}

		responseContainer = overwritten = undefined;
	} );

	return "script";
} );

jQuery.ajaxPrefilter( function( s, origOptions ) {

	if ( typeof s.data !== "string" && !jQuery.isPlainObject( s.data ) &&
			!Array.isArray( s.data ) &&

			!( "processData" in origOptions ) ) {
		s.processData = false;
	}

	if ( s.data instanceof window.FormData ) {
		s.contentType = false;
	}
} );

jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" && !isObviousHtml( data + "" ) ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var parsed, scripts;

	if ( !context ) {

		context = ( new window.DOMParser() )
			.parseFromString( "", "text/html" );
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};

jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	if ( typeof params === "function" ) {

		callback = params;
		params = undefined;

	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			response = arguments;

			self.html( selector ?

				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				responseText );

		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};

jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( typeof options === "function" ) {

			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	offset: function( options ) {

		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				offsetParent !== doc.documentElement &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.offsetParent || doc.documentElement;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 &&
				jQuery.css( offsetParent, "position" ) !== "static" ) {

				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement$1;
		} );
	}
} );

jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					jQuery.css( elem, type, extra ) :

					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );

jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );

jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);

jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	if ( typeof fn !== "function" ) {
		return undefined;
	}

	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};

jQuery.expr[ ":" ] = jQuery.expr.filters = jQuery.expr.pseudos;



if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}

var

	_jQuery = window.jQuery,

	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;

} );
(function(e,t){typeof exports==`object`&&typeof module<`u`?t(exports):typeof define==`function`&&define.amd?define([`exports`],t):(e=typeof globalThis<`u`?globalThis:e||self,t(e.window=e.window||{}))})(this,function(e){Object.defineProperty(e,Symbol.toStringTag,{value:`Module`});let t=e=>typeof e==`object`&&!!e&&e.constructor===Object&&Object.prototype.toString.call(e)===`[object Object]`,n=e=>typeof e==`string`,r=e=>e&&e!==null&&e instanceof Element&&`nodeType`in e,i=function(e){var t=new DOMParser().parseFromString(e,`text/html`).body;if(t.childElementCount>1){for(var n=document.createElement(`div`);t.firstChild;)n.appendChild(t.firstChild);return n}let r=t.firstChild;if(r&&!(r instanceof HTMLElement)){var n=document.createElement(`div`);return n.appendChild(r),n}return r},a=function(e){if(!(e&&e instanceof Element&&e.offsetParent))return!1;let t=!1,n=!1;if(e.scrollWidth>e.clientWidth){let n=window.getComputedStyle(e).overflowX,r=n.indexOf(`hidden`)!==-1,i=n.indexOf(`clip`)!==-1,a=n.indexOf(`visible`)!==-1;t=!r&&!i&&!a}if(e.scrollHeight>e.clientHeight){let t=window.getComputedStyle(e).overflowY,r=t.indexOf(`hidden`)!==-1,i=t.indexOf(`clip`)!==-1,a=t.indexOf(`visible`)!==-1;n=!r&&!i&&!a}return t||n},o=function(e,t=void 0){return!e||e===document.body||t&&e===t?null:a(e)?e:o(e.parentElement,t)},s=(e=!0,t=`--f-scrollbar-compensate`,n=`--f-body-margin`,r=`hide-scrollbar`)=>{let i=document,a=i.body,o=i.documentElement;if(e){if(a.classList.contains(r))return;let e=window.innerWidth-o.getBoundingClientRect().width;e<0&&(e=0),o.style.setProperty(t,`${e}px`);let i=parseFloat(window.getComputedStyle(a).marginRight);i&&a.style.setProperty(n,`${i}px`),a.classList.add(r)}else a.classList.remove(r),a.style.setProperty(n,``),i.documentElement.style.setProperty(t,``)},c=(e,...n)=>{let r=n.length;for(let i=0;i<r;i++){let r=n[i]||{};Object.entries(r).forEach(([n,r])=>{let i=Array.isArray(r)?[]:{};e[n]||Object.assign(e,{[n]:i}),t(r)?Object.assign(e[n],c(e[n],r)):Array.isArray(r)?Object.assign(e,{[n]:[...r]}):Object.assign(e,{[n]:r})})}return e};function l(){return!!(typeof window<`u`&&window.document&&window.document.createElement)}let u=function(e=0,t=0,n=0){return Math.max(Math.min(t,n),e)},d=function(e=0,t=0,n=0,r=0,i=0,a=!1){let o=(e-t)/(n-t)*(i-r)+r;return a?r<i?u(r,o,i):u(i,o,r):o},f=(e,t=``)=>{e&&e.classList&&t.split(` `).forEach(t=>{t&&e.classList.add(t)})},p=(e,t=``)=>{e&&e.classList&&t.split(` `).forEach(t=>{t&&e.classList.remove(t)})},m=(e,t=``,n)=>{e&&e.classList&&t.split(` `).forEach(t=>{t&&e.classList.toggle(t,n||!1)})};function h(e){return t(e)||Array.isArray(e)}function g(e,t){let n=Object.keys(e),r=Object.keys(t);return n.length===r.length&&n.every(n=>{let r=e[n],i=t[n];return typeof r==`function`?`${r}`==`${i}`:!h(r)||!h(i)?r===i:g(r,i)})}let _=function(e){for(let t of x)t.getState()===v.Running&&t.tick(C?e-C:0);C=e,S=window.requestAnimationFrame(_)};var v;(function(e){e[e.Initializing=0]=`Initializing`,e[e.Running=1]=`Running`,e[e.Paused=2]=`Paused`,e[e.Completed=3]=`Completed`,e[e.Destroyed=4]=`Destroyed`})(v||={});var y;(function(e){e[e.Spring=0]=`Spring`,e[e.Ease=1]=`Ease`})(y||={});var b;(function(e){e[e.Loop=0]=`Loop`,e[e.Reverse=1]=`Reverse`})(b||={});let x=new Set,S=null,C=0;function ee(){let e=v.Initializing,t=y.Ease,n=0,r=0,i=ee.Easings.Linear,a=500,o=0,s=0,c=0,l=0,d=1/0,f=.01,p=.01,m=!1,h={},C=null,w={},T={},E={},D=0,O=0,k=b.Loop,A=ee.Easings.Linear,j=new Map;function M(e,t){j.set(e,[...j.get(e)||[],t])}function te(e,t){j.has(e)&&j.set(e,j.get(e).filter(e=>e!==t))}function N(e,...t){for(let n of j.get(e)||[])n(...t)}function P(e){return r=0,e?C=setTimeout(()=>{ne()},e):ne(),R}function ne(){e=v.Running,N(`start`,w,T)}function F(){return C&&=(clearTimeout(C),null),e===v.Running&&(e=v.Paused,N(`pause`,w)),R}function I(n){n>50&&(n=50),r+=n;let _=0,x=!1;if(e!==v.Running)return R;if(t===y.Ease){_=u(0,r/a,1),x=_===1;let e=k===b.Reverse?A:i;for(let t in w)w[t]=h[t]+(T[t]-h[t])*e(_)}if(t===y.Spring){let e=n*.001,t=0;for(let n in w){let r=T[n],i=w[n];if(typeof r!=`number`||isNaN(r)||typeof i!=`number`||isNaN(i))continue;if(Math.abs(r-i)<=p){w[n]=r,E[n]=0;continue}E[n]||(typeof o==`object`&&typeof o[n]==`number`?E[n]=o[n]:typeof o==`number`?E[n]=o:E[n]=0);let a=E[n];a=u(Math.abs(d)*-1,a,Math.abs(d));let h=a*s*l,g=Math.abs(r-i)*c,_=((i>r?-1:1)*g-h)/s;a+=_*e,i+=a*e;let v=w[n]>r?i<r:i>r,y=Math.abs(a)<f&&Math.abs(r-i)<=p;m&&v&&(y=!0),y?(i=r,a=0):t++,w[n]=i,E[n]=a}x=!t}let S={...T};return N(`step`,w,h,T,_),x&&e===v.Running&&g(T,S)&&(e=v.Completed,L()),R}function L(){if(e=v.Completed,E={},N(`end`,w),e===v.Completed){if(n<D){if(n++,k===b.Reverse){let e={...h};h={...T},T=e}P(O)}else n=0}return R}let R={getState:function(){return e},easing:function(e){return i=e,t=y.Ease,E={},R},duration:function(e){return a=e,R},spring:function(e={}){t=y.Spring;let{velocity:n,mass:r,tension:i,friction:a,restDelta:u,restSpeed:h,maxSpeed:g,clamp:_}={velocity:0,mass:1,tension:170,friction:26,restDelta:.1,restSpeed:.1,maxSpeed:1/0,clamp:!0,...e};return o=n,s=r,c=i,l=a,p=u,f=h,d=g,m=_,E={},R},isRunning:function(){return e===v.Running},isSpring:function(){return t===y.Spring},from:function(e){return w={...e},R},to:function(e){return T=e,R},repeat:function(e,t=0,n=b.Loop,r){return D=e,O=t,k=n,A=r||i,R},on:function(e,t){return M(e,t),R},off:function(e,t){return te(e,t),R},start:function(t){return g(w,T)||(e=v.Initializing,h={...w},x.add(this),S||=window.requestAnimationFrame(_),P(t)),R},pause:F,end:L,tick:I,getStartValues:function(){return h},getCurrentValues:function(){return w},getCurrentVelocities:function(){return E},getEndValues:function(){return T},destroy:function(){e=v.Destroyed,C&&=(clearTimeout(C),null),h=w=T={},x.delete(this)}};return R}ee.destroy=()=>{for(let e of x)e.destroy();S&&=(cancelAnimationFrame(S),null)},ee.Easings={Linear:function(e){return e},EaseIn:function(e){return e===0?0:2**(10*e-10)},EaseOut:function(e){return e===1?1:1-2**(-10*e)},EaseInOut:function(e){return e===0?0:e===1?1:e<.5?2**(20*e-10)/2:(2-2**(-20*e+10))/2}};function w(e){return typeof TouchEvent<`u`&&e instanceof TouchEvent}function T(e,t){let n=[],r=w(e)?e[t]:e instanceof MouseEvent&&(t===`changedTouches`||e.type!==`mouseup`)?[e]:[];for(let e of r)n.push({x:e.clientX,y:e.clientY,ts:Date.now()});return n}function E(e){return T(e,`touches`)}function D(e){return T(e,`targetTouches`)}function O(e){return T(e,`changedTouches`)}function k(e){let t=e[0],n=e[1]||t;return{x:(t.x+n.x)/2,y:(t.y+n.y)/2,ts:n.ts}}function A(e){let t=e[0],n=e[1]||e[0];return t&&n?Math.sqrt((n.x-t.x)*(n.x-t.x)+(n.y-t.y)*(n.y-t.y))*-1:0}let j=e=>{e.cancelable&&e.preventDefault()},M={passive:!1},te={panThreshold:5,swipeThreshold:3,ignore:[`textarea`,`input`,`select`,`[contenteditable]`,`[data-selectable]`,`[data-draggable]`]},N=!1,P=!0,ne=(e,t)=>{let n={...te,...t},r=!0,i,a=[],o=[],s=[],c=!1,l=!1,u=!1,d=!1,f=0,p=0,m,h=0,g=0,_=0,v=0,y=0,b=0,x=0,S,C=[],ee,w,T=new Map;function ne(e,t){T.set(e,[...T.get(e)||[],t])}function F(e){let t=A(o),n=A(s),r=t&&n?t/n:0,u={srcEvent:i,isPanRecognized:c,isSwipeRecognized:l,firstTouch:a,previousTouch:s,currentTouch:o,deltaX:h,deltaY:g,offsetX:_,offsetY:v,velocityX:y,velocityY:b,velocity:Math.abs(y)>Math.abs(b)?y:b,angle:x,axis:S,scale:r,center:m};for(let t of T.get(e)||[])t(u)}function I(e){let t=e.target,r=e.composedPath()[0],i=n.ignore.join(`,`),a=e=>e&&e instanceof HTMLElement&&(e.matches(i)||e.closest(i));if(a(t)||a(r))return!1}function L(e){let t=Date.now();if(C=C.filter(e=>!e.ts||e.ts>t-100),e&&C.push(e),y=0,b=0,C.length>3){let e=C[0],t=C[C.length-1];if(e&&t){let n=t.x-e.x,r=t.y-e.y,i=e.ts&&t.ts?t.ts-e.ts:0;i>0&&(y=Math.abs(n)>3?n/(i/30):0,b=Math.abs(r)>3?r/(i/30):0)}}}function R(e){if(!r||I(e)===!1)return;if(typeof MouseEvent<`u`&&e instanceof MouseEvent){if(N)return}else N=!0;if(typeof MouseEvent<`u`&&e instanceof MouseEvent){if(!e.buttons||e.button!==0)return;j(e)}e instanceof MouseEvent&&(window.addEventListener(`mousemove`,z),window.addEventListener(`mouseup`,B)),window.addEventListener(`blur`,V),i=e,o=D(e),a=[...o],s=[],p=o.length,m=k(o),p===1&&(c=!1,l=!1,u=!1),p&&L(k(o));let t=Date.now(),n=t-(f||t);d=n>0&&n<=250&&p===1,f=t,clearTimeout(ee),F(`start`)}function z(e){if(!a.length||e.defaultPrevented||I(e)===!1)return;i=e,s=[...o],o=E(e);let t=k(s),r=k(E(e));if(L(r),p=o.length,m=r,s.length===o.length?(h=r.x-t.x,g=r.y-t.y):(h=0,g=0),a.length){let e=k(a);_=r.x-e.x,v=r.y-e.y}if(o.length>1){let e=A(o),t=A(s);Math.abs(e-t)>=.1&&(u=!0,F(`pinch`))}c||(c=Math.abs(_)>=n.panThreshold||Math.abs(v)>=n.panThreshold,c&&(P=!1,clearTimeout(w),w=void 0,x=Math.abs(Math.atan2(v,_)*180/Math.PI),S=x>45&&x<135?`y`:`x`,a=[...o],s=[...o],_=0,v=0,h=0,g=0,window.getSelection()?.removeAllRanges(),F(`panstart`))),c&&(h||g)&&F(`pan`),F(`move`)}function B(e){if(i=e,!a.length)return;let t=D(e),r=O(e);if(p=t.length,m=k(r),r.length&&L(k(r)),s=[...o],o=[...t],a=[...t],p>0)F(`end`),c=!1,l=!1,C=[];else{let e=n.swipeThreshold;(Math.abs(y)>e||Math.abs(b)>e)&&(l=!0),c&&F(`panend`),l&&F(`swipe`),!c&&!l&&!u&&(F(`tap`),d?F(`doubleTap`):ee=setTimeout(function(){F(`singleTap`)},250)),F(`end`),H()}}function V(){clearTimeout(ee),H(),c&&F(`panend`),F(`end`)}function H(){N=!1,c=!1,l=!1,d=!1,p=0,C=[],o=[],s=[],a=[],h=0,g=0,_=0,v=0,y=0,b=0,x=0,S=void 0,window.removeEventListener(`mousemove`,z),window.removeEventListener(`mouseup`,B),window.removeEventListener(`blur`,V),!P&&!w&&(w=setTimeout(()=>{P=!0,w=void 0},100))}function U(e){let t=e.target;N=!1,t&&!e.defaultPrevented&&(P||(j(e),e.stopPropagation()))}function re(){return e&&(e.addEventListener(`click`,U,M),e.addEventListener(`mousedown`,R,M),e.addEventListener(`touchstart`,R,M),e.addEventListener(`touchmove`,z,M),e.addEventListener(`touchend`,B),e.addEventListener(`touchcancel`,B)),ie}let ie={init:re,on:function(e,t){return ne(e,t),ie},off:function(e,t){return T.has(e)&&T.set(e,T.get(e).filter(e=>e!==t)),ie},enable:function(){return r=!0,ie},disable:function(){return r=!1,a.length&&(l=!1,y=0,b=0,h=0,g=0,F(`end`)),H(),ie},isPointerDown:()=>p>0,destroy:function(){clearTimeout(ee),clearTimeout(w),w=void 0,e&&(e.removeEventListener(`click`,U,M),e.removeEventListener(`mousedown`,R,M),e.removeEventListener(`touchstart`,R,M),e.removeEventListener(`touchmove`,z,M),e.removeEventListener(`touchend`,B),e.removeEventListener(`touchcancel`,B)),e=null,H()}};return ie};ne.isClickAllowed=()=>P;let F={IMAGE_ERROR:`This image couldn't be loaded. <br /> Please try again later.`,MOVE_UP:`Move up`,MOVE_DOWN:`Move down`,MOVE_LEFT:`Move left`,MOVE_RIGHT:`Move right`,ZOOM_IN:`Zoom in`,ZOOM_OUT:`Zoom out`,TOGGLE_FULL:`Toggle zoom level`,TOGGLE_1TO1:`Toggle zoom level`,ITERATE_ZOOM:`Toggle zoom level`,ROTATE_CCW:`Rotate counterclockwise`,ROTATE_CW:`Rotate clockwise`,FLIP_X:`Flip horizontally`,FLIP_Y:`Flip vertically`,RESET:`Reset`,TOGGLE_FS:`Toggle fullscreen`},I=1e4,L=e=>{e.cancelable&&e.preventDefault()},R=(e,t=I)=>(e=parseFloat(e+``)||0,Math.round((e+2**-52)*t)/t),z=e=>e instanceof HTMLImageElement;var B;(function(e){e.Reset=`reset`,e.Zoom=`zoom`,e.ZoomIn=`zoomIn`,e.ZoomOut=`zoomOut`,e.ZoomTo=`zoomTo`,e.ToggleCover=`toggleCover`,e.ToggleFull=`toggleFull`,e.ToggleMax=`toggleMax`,e.IterateZoom=`iterateZoom`,e.Pan=`pan`,e.Swipe=`swipe`,e.Move=`move`,e.MoveLeft=`moveLeft`,e.MoveRight=`moveRight`,e.MoveUp=`moveUp`,e.MoveDown=`moveDown`,e.RotateCCW=`rotateCCW`,e.RotateCW=`rotateCW`,e.FlipX=`flipX`,e.FlipY=`flipY`,e.ToggleFS=`toggleFS`})(B||={});var V;(function(e){e.Cover=`cover`,e.Full=`full`,e.Max=`max`})(V||={});let H={x:0,y:0,scale:1,angle:0,flipX:1,flipY:1};var U;(function(e){e[e.Init=0]=`Init`,e[e.Loading=1]=`Loading`,e[e.Error=2]=`Error`,e[e.Ready=3]=`Ready`,e[e.Destroyed=4]=`Destroyed`})(U||={});let re={bounds:!0,classes:{container:`f-panzoom`,wrapper:`f-panzoom__wrapper`,content:`f-panzoom__content`,viewport:`f-panzoom__viewport`},clickAction:B.ToggleFull,dblClickAction:!1,gestures:{},height:`auto`,l10n:F,maxScale:4,minScale:1,mouseMoveFactor:1,panMode:`drag`,protected:!1,singleClickAction:!1,spinnerTpl:`<div class="f-spinner"></div>`,wheelAction:B.Zoom,width:`auto`},ie=0,ae,W=0,oe=0,se=(e,t={},a={})=>{let s=0,c={...re,...t},l={},d,h,_,v,y={...H},b={...H},x,S,C,w,T=[];function E(e){let t=c[e];return t&&typeof t==`function`?t(Xe):t}function D(e,t=[]){let n=E(`l10n`)||{};e=String(e).replace(/\{\{(\w+)\}\}/g,(e,t)=>n[t]||e);for(let n=0;n<t.length;n++)e=e.split(t[n][0]).join(t[n][1]);return e=e.replace(/\{\{(.*?)\}\}/g,(e,t)=>t),e}function A(){return e&&e.parentElement&&d&&s===3}let j=new Map;function M(e,t){for(let n of e instanceof Array?e:[e])j.set(n,[...j.get(n)||[],t]);return Xe}function te(e,t){for(let n of e instanceof Array?e:[e])j.has(n)&&j.set(n,j.get(n).filter(e=>e!==t));return Xe}function N(e,...t){let n=[...j.get(e)||[]];c.on&&n.push(c.on[e]);for(let e of n)e&&typeof e==`function`&&e(Xe,...t);e!==`*`&&N(`*`,e,...t)}function P(){return s=0,N(`init`),F(),V(),U(),se(),Xe}function F(){for(let[e,t]of Object.entries({...a,...c.plugins||{}}))if(e&&!l[e]&&t instanceof Function){let n=t();n.init(Xe),l[e]=n}N(`initPlugins`)}function V(){let t={...re.classes,...E(`classes`)},n=t.content?.split(` `).shift(),r=t.wrapper?.split(` `).shift(),i=t.viewport?.split(` `).shift();if(n&&r&&i&&e&&(f(e,t.container),h=e.querySelector(`.${n}:not(.is-clone)`),h)){if(h.setAttribute(`draggable`,`false`),d=e.querySelector(`.${r}`),d||(d=document.createElement(`div`),f(d,t.wrapper),h.insertAdjacentElement(`beforebegin`,d),d.insertAdjacentElement(`afterbegin`,h)),v=e.querySelector(`.${i}`),v||(v=document.createElement(`div`),f(v,t.viewport),d.insertAdjacentElement(`beforeend`,v)),v.contains(h)||v.insertAdjacentElement(`afterbegin`,h),_=e.querySelector(`.${n}.is-clone`),_||(_=h.cloneNode(!0),_.removeAttribute(`id`),f(_,`is-clone`),d.insertAdjacentElement(`afterbegin`,_)),h instanceof HTMLPictureElement&&(h=h.querySelector(`img`)),_ instanceof HTMLPictureElement&&(_=_.querySelector(`img`)),v instanceof HTMLPictureElement&&(v=v.querySelector(`img`)),v&&(v.style.visibility=`hidden`,E(`protected`))){v.addEventListener(`contextmenu`,e=>{L(e)});let e=document.createElement(`div`);f(e,`f-panzoom__protected`),v.appendChild(e)}N(`initLayout`)}}function U(){if(e&&d&&!C){let e=null;C=new ResizeObserver(()=>{A()&&(e||=requestAnimationFrame(()=>{A()&&(J(),Oe(),N(`refresh`)),e=null}))}),C.observe(d),T.push(()=>{C?.disconnect(),C=void 0,e&&=(cancelAnimationFrame(e),null)})}}function se(){if(!e||!h)return;if(!(z(h)&&z(_))){ge();return}let t=()=>{h&&z(h)&&h.decode().then(()=>{ge()}).catch(()=>{ge()})};if(s=1,e.classList.add(`is-loading`),N(`loading`),_.src&&_.complete){t();return}me(),_.addEventListener(`load`,t,!1),_.addEventListener(`error`,t,!1),T.push(()=>{_?.removeEventListener(`load`,t,!1),_?.removeEventListener(`error`,t,!1)})}function ce(){S=ee().on(`start`,(e,t)=>{t.angle!==void 0&&(t.angle=Math.round(t.angle/90)*90),t.flipX!==void 0&&(t.flipX=t.flipX>0?1:-1),t.flipY!==void 0&&(t.flipY=t.flipY>0?1:-1),b={...H,...t},J(),N(`animationStart`)}).on(`pause`,e=>{b={...H,...e}}).on(`step`,e=>{if(!A()){S?.end();return}if(y={...H,...e},K()||!E(`bounds`)||Ge()||b.scale>y.scale||b.scale<q()){ke();return}let t=De(b.scale),n=!1,r=!1,i=!1,a=!1;y.x<t.x[0]&&(n=!0),y.x>t.x[1]&&(r=!0),y.y<t.y[0]&&(a=!0),y.y>t.y[1]&&(i=!0);let o=!1,s=!1,c=!1,l=!1;b.x<t.x[0]&&(o=!0),b.x>t.x[1]&&(s=!0),b.y<t.y[0]&&(l=!0),b.y>t.y[1]&&(c=!0);let d=!1;(r&&s||n&&o)&&(b.x=u(t.x[0],b.x,t.x[1]),d=!0),(i&&c||a&&l)&&(b.y=u(t.y[0],b.y,t.y[1]),d=!0),d&&S&&S.spring({tension:94,friction:17,maxSpeed:555*b.scale,restDelta:.1,restSpeed:.1,velocity:S.getCurrentVelocities()}).from(y).to(b).start(),ke()}).on(`end`,()=>{x?.isPointerDown()||Oe(),S?.isRunning()||(J(),N(`animationEnd`))})}function G(){let e=E(`gestures`);if(!e||!v||!h)return;let t=!1;x=ne(v,e).on(`start`,e=>{if(!E(`gestures`)||!S||!A()||K())return;let n=e.srcEvent;(y.scale>1||We(y.angle)||e.currentTouch.length>1)&&(n?.stopPropagation(),S.pause(),t=!0),e.currentTouch.length===1&&N(`touchStart`)}).on(`move`,e=>{t&&(b.scale!==1||We(b.angle)||e.currentTouch.length>1)&&(L(e.srcEvent),e.srcEvent?.stopPropagation())}).on(`pan`,e=>{if(!t)return;let n=e.srcEvent;(b.scale!==1||We(b.angle)||e.currentTouch.length>1)&&(L(n),Y(B.Pan,e))}).on(`swipe`,e=>{t&&(b.scale>1||We(b.angle))&&Y(B.Swipe,e)}).on(`tap`,e=>{N(`click`,e)}).on(`singleTap`,e=>{N(`singleClick`,e)}).on(`doubleTap`,e=>{N(`dblClick`,e)}).on(`pinch`,e=>{t&&(e.scale>q()?Y(B.ZoomIn,e):e.scale<q()?Y(B.ZoomOut,e):Y(B.Pan,e))}).on(`end`,e=>{t&&(e.currentTouch.length?(e.srcEvent.stopPropagation(),L(e.srcEvent),S?.end()):(t=!1,J(),Oe(),N(`touchEnd`)))}).init()}function le(){v&&(v.addEventListener(`wheel`,ue,{passive:!1}),T.push(()=>{v?.removeEventListener(`wheel`,ue,{passive:!1})}))}function ue(e){if(!A())return;let t=e.target;if(o(t))return;let n=Date.now(),r=[-e.deltaX||0,-e.deltaY||0,-e.detail||0].reduce(function(e,t){return Math.abs(t)>Math.abs(e)?t:e}),i=u(-1,r,1);N(`wheel`,e,i);let a=E(`wheelAction`);if(!a||e.defaultPrevented)return;let s=b.scale,c=s*(i>0?1.5:.5);if(a===B.Zoom){let t=Math.abs(e.deltaY)<100&&Math.abs(e.deltaX)<100?200:45;if(n-W<t){L(e);return}W=n;let r=Ce(),a=Ee();if(R(c)<R(r)&&R(s)<=R(r)?(oe+=Math.abs(i),c=r):R(c)>R(a)&&R(s)>=R(a)?(oe+=Math.abs(i),c=a):(oe=0,c=u(r,c,a)),oe>7)return}switch(L(e),a){case B.Pan:Y(a,{srcEvent:e,deltaX:-e.deltaX*2,deltaY:-e.deltaY*2});break;case B.Zoom:Y(B.ZoomTo,{srcEvent:e,scale:c,center:{x:e.clientX,y:e.clientY}});break;default:Y(a,{srcEvent:e})}}function de(t){let n=t.composedPath()[0];if(!ne.isClickAllowed()||!r(n)||t.defaultPrevented||!e?.contains(n)||n.hasAttribute(`disabled`)||n.hasAttribute(`aria-disabled`)||n.hasAttribute(`data-carousel-go-prev`)||n.hasAttribute(`data-carousel-go-next`))return;let i=n.closest(`[data-panzoom-action]`),a=i?.dataset?.panzoomAction,o=i?.dataset?.panzoomValue||``;if(a){switch(L(t),a){case B.ZoomTo:case B.ZoomIn:case B.ZoomOut:Y(a,{scale:parseFloat(o||``)||void 0});break;case B.MoveLeft:case B.MoveRight:Y(a,{deltaX:parseFloat(o||``)||void 0});break;case B.MoveUp:case B.MoveDown:Y(a,{deltaY:parseFloat(o||``)||void 0});break;case B.ToggleFS:Je();break;default:Y(a)}return}if(!d?.contains(n))return;let s={srcEvent:t};if(Y(E(`clickAction`),s),E(`dblClickAction`)){let e=Date.now(),t=e-(ie||e),n=t>0&&t<=250;ie=e,n?(ae&&=(clearTimeout(ae),void 0),Y(E(`dblClickAction`),s)):ae=setTimeout(()=>{Y(E(`singleClickAction`),s)},250)}}function fe(e){if(w=e,!A()||!K()||y.scale<=1||b.scale<=1||(d?.dataset.animationName||``).indexOf(`zoom`)>-1)return;let t=xe(b.scale);if(!t)return;let{x:n,y:r}=t;Y(B.Pan,{deltaX:n-b.x,deltaY:r-b.y})}function pe(){e?.addEventListener(`click`,de),document?.addEventListener(`mousemove`,fe),T.push(()=>{e?.removeEventListener(`click`,de),document?.removeEventListener(`mousemove`,fe)})}function me(){if(!e||e?.querySelector(`.f-spinner`))return;let t=E(`spinnerTpl`),n=i(t);n&&(n.classList.add(`f-spinner`),e.classList.add(`is-loading`),d?.insertAdjacentElement(`afterbegin`,n))}function he(){e&&(p(e,`is-loading`),e.querySelector(`.f-spinner`)?.remove())}function ge(){if(!e||!h)return;if(he(),z(h)&&!(h.complete&&h.naturalWidth)){s=2,d?.classList.add(`has-error`),N(`error`);return}N(`loaded`);let{width:t,height:n}=ye();z(h)&&(h.setAttribute(`width`,t+``),h.setAttribute(`height`,n+``)),d&&(p(d,`has-error`),z(h)&&(d.setAttribute(`width`,t+``),d.setAttribute(`height`,n+``),d.style.aspectRatio=`${t/n||``}`)),ce(),G(),le(),pe();let r=_e();y={...r},b={...r},s=3,ke(),J(),N(`ready`),requestAnimationFrame(()=>{s===3&&(he(),v&&(v.style.visibility=``))})}function _e(){let e={...E(`startPos`)||{}},t=e.scale,n=1;n=typeof t==`string`?Se(t):typeof t==`number`?t:q();let r={...H,...e,scale:n},i=K()?xe(n):void 0;if(i){let{x:e,y:t}=i;r.x=e,r.y=t}return r}function ve(){let e={top:0,left:0,width:0,height:0};if(d){let t=d.getBoundingClientRect();We(b.angle)?(e.top=t.top+t.height*.5-t.width*.5,e.left=t.left+t.width*.5-t.height*.5,e.width=t.height,e.height=t.width):(e.top=t.top,e.left=t.left,e.width=t.width,e.height=t.height)}return e}function ye(){let e=E(`width`),t=E(`height`);if(h&&e===`auto`){let t=h.getAttribute(`width`);e=t?parseFloat(t+``):h.dataset.width===void 0?z(v)?v.naturalWidth:z(h)?h.naturalWidth:d?.getBoundingClientRect().width||0:parseFloat(h.dataset.width+``)}else e=n(e)?parseFloat(e):e;if(h&&t===`auto`){let e=h.getAttribute(`height`);t=e?parseFloat(e+``):h.dataset.height===void 0?z(v)?v.naturalHeight:z(h)?h.naturalHeight:d?.getBoundingClientRect().height||0:parseFloat(h.dataset.height+``)}else t=n(t)?parseFloat(t):t;return{width:e,height:t}}function be(){let e=ve();return{width:e.width,height:e.height}}function K(){return E(`panMode`)===`mousemove`&&matchMedia(`(hover: hover)`).matches}function xe(e){let t=w||E(`event`),n=d?.getBoundingClientRect();if(!t||!n||e<=1)return{x:0,y:0};let r=(t.clientX||0)-n.left,i=(t.clientY||0)-n.top,{width:a,height:o}=be(),s=De(e);if(e>1){let t=E(`mouseMoveFactor`);t>1&&(e*=t)}let c=a*e,l=o*e,f=(c-a)*.5-(c-a)*(r/a*100/100),p=(l-o)*.5-(l-o)*(i/o*100/100);return f=u(s.x[0],f,s.x[1]),p=u(s.y[0],p,s.y[1]),{x:f,y:p}}function Se(t){if(!t)return b.scale;if(!e)return 1;let n=e.getBoundingClientRect(),r=ve(),{width:i,height:a}=ye(),o=e=>{if(typeof e==`number`)return e;switch(e){case`min`:return 1;case`base`:return 1;case`cover`:return Math.max(n.height/r.height,n.width/r.width)||1;case`full`:case`max`:{let e=We(b.angle)?a:i;return e&&r.width?e/r.width:1}}},s=E(`minScale`),c=E(`maxScale`),l=Math.min(o(`full`),o(s)),d=typeof c==`number`?o(`full`)*c:Math.min(o(`full`),o(c));switch(t){case`min`:return l;case`base`:return u(l,1,d);case`cover`:return o(`cover`);case`full`:return Math.min(d,o(`full`));case`max`:return d}}function Ce(){return Se(`min`)}function q(){return Se(`base`)}function we(){return Se(`cover`)}function Te(){return Se(`full`)}function Ee(){return Se(`max`)}function De(t){let n={x:[0,0],y:[0,0]},r=e?.getBoundingClientRect();if(!r)return n;let i=ve(),a=r.width,o=r.height,s=i.width,c=i.height;t=t===void 0?b.scale:t;let l=t,u=t;if(K()&&t>1){let e=E(`mouseMoveFactor`);e>1&&(s*t>a+.01&&(l*=e),c*t>o+.01&&(u*=e))}if(s*=l,c*=u,s>a){n.x[0]=(a-s)*.5,n.x[1]=(s-a)*.5;let e=(i.left-r.left)*.5,t=(i.left+i.width-r.right)*.5;n.x[0]-=e+t,n.x[1]-=e+t}if(c>o){n.y[0]=(o-c)*.5,n.y[1]=(c-o)*.5;let e=(i.top-r.top)*.5,t=(i.top+i.height-r.bottom)*.5;n.y[0]-=e+t,n.y[1]-=e+t}return n}function Oe(){if(!A()||!E(`bounds`)||!S)return;let e=Ce(),t=Ee(),n=u(e,b.scale,t);if(b.scale<e-.01||b.scale>t+.01){Y(B.ZoomTo,{scale:n});return}if(S.isRunning()||Ge())return;let r=De(n);b.x<r.x[0]||b.x>r.x[1]||b.y<r.y[0]||b.y>r.y[1]?(b.x=u(r.x[0],b.x,r.x[1]),b.y=u(r.y[0],b.y,r.y[1]),S.spring({tension:170,friction:17,restDelta:.001,restSpeed:.001,maxSpeed:1/0,velocity:S.getCurrentVelocities()}),S.from(y).to(b).start()):ke()}function J(t){if(!A())return;let n=Ue(),r=Ge(),i=Ke(),a=qe(),o=Re(),s=ze();m(d,`is-fullsize`,a),m(d,`is-expanded`,i),m(d,`is-dragging`,r),m(d,`can-drag`,n),m(d,`will-zoom-in`,o),m(d,`will-zoom-out`,s);let c=Ve(),l=He(),u=Be(),f=!A();for(let n of(t||e)?.querySelectorAll(`[data-panzoom-action]`)||[]){let e=n.dataset.panzoomAction,t=!1;if(f)t=!0;else switch(e){case B.ZoomIn:c||(t=!0);break;case B.ZoomOut:u||(t=!0);break;case B.ToggleFull:{l||u||(t=!0);let e=n.querySelector(`g`);e&&(e.style.display=a&&!t?`none`:``);break}case B.IterateZoom:{c||u||(t=!0);let e=n.querySelector(`g`);e&&(e.style.display=!c&&!t?`none`:``);break}case B.ToggleCover:case B.ToggleMax:c||u||(t=!0)}t?(n.setAttribute(`aria-disabled`,``),n.setAttribute(`tabindex`,`-1`)):(n.removeAttribute(`aria-disabled`),n.removeAttribute(`tabindex`))}}function Y(t,n){if(!t||!e||!h||!S||!A()||t===B.Swipe&&Math.abs(S.getCurrentVelocities().scale)>.01)return;let r={...b},i={...b},a=De(K()?r.scale:y.scale),o=S.getCurrentVelocities(),s=ve();n||={};let c=(n.currentTouch?.length||0)>1,l=n.velocityX||0,d=n.velocityY||0,f=n.center;n.srcEvent&&(f=k(O(n.srcEvent)));let p=n.deltaX||0,m=n.deltaY||0;switch(t){case B.MoveRight:p=n.deltaX||100;break;case B.MoveLeft:p=n.deltaX||-100;break;case B.MoveUp:m=n.deltaY||-100;break;case B.MoveDown:m=n.deltaY||100}let _=[];if(typeof t==`number`)i.scale=t;else switch(t){case B.Reset:i={...H},i.scale=q();break;case B.ZoomTo:case B.ZoomIn:case B.ZoomOut:case B.ToggleCover:case B.ToggleFull:case B.ToggleMax:case B.IterateZoom:case B.Zoom:i.scale=Le(t,n);break;case B.Pan:case B.Move:case B.MoveLeft:case B.MoveRight:case B.MoveUp:case B.MoveDown:if(Ge()){let e=1,t=1;i.x<=a.x[0]&&l<=0&&(e=Math.max(.01,1-Math.abs(1/s.width*Math.abs(i.x-a.x[0]))),e*=.2),i.x>=a.x[1]&&l>=0&&(e=Math.max(.01,1-Math.abs(1/s.width*Math.abs(i.x-a.x[1]))),e*=.2),i.y<=a.y[0]&&d<=0&&(t=Math.max(.01,1-Math.abs(1/s.height*Math.abs(i.y-a.y[0]))),t*=.2),i.y>=a.y[1]&&d>=0&&(t=Math.max(.01,1-Math.abs(1/s.height*Math.abs(i.y-a.y[1]))),t*=.2),i.x+=p*e,i.y+=m*t}else i.x=u(a.x[0],i.x+p,a.x[1]),i.y=u(a.y[0],i.y+m,a.y[1]);break;case B.Swipe:let e=(e=0)=>Math.sign(e)*Math.abs(e)**1.5;i.x+=u(-1e3,e(l),1e3),i.y+=u(-1e3,e(d),1e3),d&&!l&&(i.x=u(a.x[0],i.x,a.x[1])),!d&&l&&(i.y=u(a.y[0],i.y,a.y[1])),o.x=l,o.y=d;break;case B.RotateCW:i.angle+=90;break;case B.RotateCCW:i.angle-=90;break;case B.FlipX:i.flipX*=-1;break;case B.FlipY:i.flipY*=-1}if(y.angle!==void 0&&Math.abs(y.angle)>=360&&(i.angle-=Math.floor(y.angle/360)*360,y.angle-=Math.floor(y.angle/360)*360),_.length){let e=_.findIndex(e=>e>i.scale+1/I);i.scale=_[e]||_[0]}if(c&&(i.scale=u(Ce()*(c?.8:1),i.scale,Ee()*(c?1.6:1))),K()){let e=xe(i.scale);if(e){let{x:t,y:n}=e;i.x=t,i.y=n}}else if(Math.abs(i.scale-r.scale)>1e-4){let t=0,n=0;if(f)t=f.x,n=f.y;else{let r=e.getBoundingClientRect();t=r.x+r.width*.5,n=r.y+r.height*.5}let o=t-s.left,l=n-s.top;o-=s.width*.5,l-=s.height*.5;let d=(o-r.x)/r.scale,p=(l-r.y)/r.scale;i.x=o-d*i.scale,i.y=l-p*i.scale,!c&&E(`bounds`)&&(a=De(i.scale),i.x=u(a.x[0],i.x,a.x[1]),i.y=u(a.y[0],i.y,a.y[1]))}if(t===B.Swipe){let e=500*i.scale,t=o;S.spring({tension:94,friction:17,maxSpeed:e,restDelta:.1,restSpeed:.1,velocity:t})}else t===B.Pan||c?S.spring({tension:900,friction:17,restDelta:.01,restSpeed:.01,maxSpeed:1}):S.spring({tension:170,friction:17,restDelta:.001,restSpeed:.001,maxSpeed:1/0,velocity:o});if(n.velocity===0||g(y,i))y={...i},b={...i},S.end(),ke(),J();else{if(g(b,i))return;S.from(y).to(i).start()}N(`action`,t)}function ke(){if(!h||!d||!v)return;let{width:e,height:t}=ye();Object.assign(d.style,{maxWidth:`min(${e}px, 100%)`,maxHeight:`min(${t}px, 100%)`});let{x:n,y:r,width:i,height:a,scale:o,angle:s,flipX:c,flipY:l}=Ae(),u=`translate(${R(n,100)}px, ${R(r,100)}px)`;u+=c!==1||l!==1?` scaleX(${R(o*c)}) scaleY(${R(o*l)})`:` scale(${R(o)})`,s!==0&&(u+=` rotate(${s}deg)`),v.style.width=`${R(i)}px`,v.style.height=`${R(a)}px`,v.style.transform=`${u}`,N(`render`)}function Ae(){let{width:t,height:n}=ye(),{width:r,height:i}=be();if(!e)return{x:0,y:0,width:0,height:0,scale:0,flipX:0,flipY:0,angle:0,fitWidth:r,fitHeight:i,fullWidth:t,fullHeight:n};let{x:a,y:o,scale:s,angle:c,flipX:l,flipY:u}=y,d=1/Te(),f=t,p=n,m=y.scale*d,h=b.scale*d,g=Math.max(r,i),_=Math.min(r,i);t>n?(f=g,p=_):(f=_,p=g),m=t>n?g*s/t||1:g*s/n||1;let v=f?t*h:0,x=p?n*h:0,S=f&&p?t*m/v:0;return a=a+f*.5-v*.5,o=o+p*.5-x*.5,{x:a,y:o,width:v,height:x,scale:S,flipX:l,flipY:u,angle:c,fitWidth:r,fitHeight:i,fullWidth:t,fullHeight:n}}function je(){return S}function Me(){return x}function Ne(){return e}function Pe(){return h}function Fe(){return d}function X(){return v}function Ie(){N(`destroy`);for(let e of Object.values(l))e?.destroy(Xe);for(let e of T)e();return d&&(d.style.aspectRatio=``,d.style.maxWidth=``,d.style.maxHeight=``),v&&(v.style.width=``,v.style.height=``,v.style.transform=``),d=void 0,h=void 0,v=void 0,y={...H},b={...H},S?.destroy(),S=void 0,x?.destroy(),x=void 0,s=4,Xe}function Le(e=E(`clickAction`),t={}){let n=b.scale,r=q(),i=[];if(typeof e==`number`)r=e;else if(e){switch(e){case B.ZoomTo:r=t.scale||1;break;case B.ZoomIn:r=n*(t.scale||2);break;case B.ZoomOut:r=n*(t.scale||.5);break;case B.ToggleCover:i=[q(),we()];break;case B.ToggleFull:i=[q(),Te()];break;case B.ToggleMax:i=[q(),Ee()];break;case B.IterateZoom:i=[q(),Te(),Ee()];break;case B.Zoom:{let e=Te();r=n>=e-.05?q():Math.min(e,n*(t.scale||2));break}}i.length&&(r=i.find(e=>e>n+1/I)??q())}return e!==B.ZoomTo&&(r=u(Ce(),r,Ee())),r}function Re(){return!!(A()&&Le()>b.scale)}function ze(){return!!(A()&&Le()<b.scale)}function Be(){return!!(A()&&b.scale>Ce())}function Ve(){return!!(A()&&b.scale<Ee())}function He(){return!!(A()&&b.scale<Te())}function Ue(){return!!(A()&&(Ke()||We(b.angle))&&x&&!K())}function We(e){return Math.abs(e%180)===90}function Ge(){return!!(A()&&x?.isPointerDown()&&!K())}function Ke(){return!!(A()&&b.scale>q())}function qe(){return!!(A()&&b.scale>=Te())}function Je(){let t=`in-fullscreen`,n=`with-panzoom-in-fullscreen`;e?.classList.toggle(t);let r=e?.classList.contains(t);r?(document.documentElement.classList.add(n),document.addEventListener(`keydown`,Ye,!0)):(document.documentElement.classList.remove(n),document.removeEventListener(`keydown`,Ye,!0)),ke(),N(r?`enterFS`:`exitFS`)}function Ye(e){e.key===`Escape`&&!e.defaultPrevented&&Je()}let Xe={canDrag:Ue,canZoomIn:Ve,canZoomOut:Be,canZoomToFull:He,destroy:Ie,emit:N,execute:Y,getBoundaries:De,getContainer:Ne,getContent:Pe,getFullDim:ye,getGestures:Me,getMousemovePos:xe,getOptions:function(){return c},getPlugins:function(){return l},getScale:Se,getStartPosition:_e,getState:function(){return s},getTransform:function(e){return e===!0?b:y},getTween:je,getViewport:X,getWrapper:Fe,init:P,isDragging:Ge,isExpanded:Ke,isFullsize:qe,isMousemoveMode:K,localize:D,off:te,on:M,toggleFS:Je,updateControls:J,version:`6.1.15`,willZoomIn:Re,willZoomOut:ze};return Xe};se.l10n={en_EN:F},se.getDefaults=()=>re;let ce=(e,t)=>{let n=[];return e.childNodes.forEach(e=>{e.nodeType===Node.ELEMENT_NODE&&(!t||e.matches(t))&&n.push(e)}),n},G={...F,ERROR:`Something went wrong. <br /> Please try again later.`,NEXT:`Next page`,PREV:`Previous page`,GOTO:`Go to page #%d`,DOWNLOAD:`Download`,TOGGLE_FULLSCREEN:`Toggle full-screen mode`,TOGGLE_EXPAND:`Toggle full-size mode`,TOGGLE_THUMBS:`Toggle thumbnails`,TOGGLE_AUTOPLAY:`Toggle slideshow`};var le;(function(e){e[e.Init=0]=`Init`,e[e.Ready=1]=`Ready`,e[e.Destroyed=2]=`Destroyed`})(le||={});var ue;(function(e){e[e.Loading=0]=`Loading`,e[e.Loaded=1]=`Loaded`,e[e.Error=2]=`Error`})(ue||={});let de=e=>{e.cancelable&&e.preventDefault()},fe={adaptiveHeight:!1,center:!0,classes:{container:`f-carousel`,isEnabled:`is-enabled`,isLTR:`is-ltr`,isRTL:`is-rtl`,isHorizontal:`is-horizontal`,isVertical:`is-vertical`,hasAdaptiveHeight:`has-adaptive-height`,viewport:`f-carousel__viewport`,slide:`f-carousel__slide`,isSelected:`is-selected`},dragFree:!1,enabled:!0,errorTpl:`<div class="f-html">{{ERROR}}</div>`,fill:!0,infinite:!0,initialPage:0,l10n:G,rtl:!1,slides:[],slidesPerPage:`auto`,spinnerTpl:`<div class="f-spinner"></div>`,transition:`fade`,tween:{clamp:!0,mass:1,tension:160,friction:25,restDelta:1,restSpeed:1,velocity:0},vertical:!1},pe=0,me,he,ge=e=>document.getElementById(`${e.split(`#`).pop()}`),_e=(e,a={},s={})=>{pe++;let l=0,h={...fe},g={...fe},_={},v,y,b,x=null,S=null,C=0,T=0,E=0,D=!1,O=!1,k=!1,A=`height`,j=0,M=!0,te,N=0,P=0,F=0,I=0,L,R=`*`,z=[],B=[],V=new Set,H=[],U=[],re=0,ie=0,ae=0;function W(e,...t){let n=g[e];return n&&n instanceof Function?n(Z,...t):n}function oe(e,t=[]){let n=W(`l10n`)||{};e=String(e).replace(/\{\{(\w+)\}\}/g,(e,t)=>n[t]||e);for(let n=0;n<t.length;n++)e=e.split(t[n][0]).join(t[n][1]);return e=e.replace(/\{\{(.*?)\}\}/g,(e,t)=>t),e}let se=new Map;function G(e,...t){let n=[...se.get(e)||[]];g.on&&n.push(g.on[e]);for(let e of n)e&&e instanceof Function&&e(Z,...t);e===`click`&&Ye(t[0]),e!==`*`&&G(`*`,e,...t)}function le(e,t){for(let n of e instanceof Array?e:[e])se.set(n,[...se.get(n)||[],t]);return Z}function ue(e,t){for(let n of e instanceof Array?e:[e])se.has(n)&&se.set(n,se.get(n).filter(e=>e!==t));return Z}function ve(){if(!e||!r(e))throw Error(`No Element found`);return l!==0&&(ot(),l=0),x=e,h=a,window.removeEventListener(`resize`,be),h.breakpoints&&window.addEventListener(`resize`,be),be(),Z}function ye(e={},n){return ot(),l=0,L=void 0,R=`*`,a=e,h=e,t(n)&&(s=n),be(),Z}function be(){let e=c({},fe,h),t=``,n=h.breakpoints||{};for(let[r,i]of Object.entries(n))window.matchMedia(r).matches&&(t+=r,c(e,i));if(L===void 0||t!==L){if(L=t,l!==0){let t=U[N]?.slides[0]?.index;t===void 0&&(t=g.initialSlide),e.initialSlide=t,e.slides=[];for(let t of z)t.isVirtual&&e.slides.push(t)}ot(),g=e,W(`enabled`)!==!1&&K()}}function K(){l=0,G(`init`),xe(),Se(),Ce(),We(),l=1,f(x,(W(`classes`)||{}).isEnabled||``),at(),Ae(),Ee(),Oe(),q(),G(`ready`)}function xe(){for(let[e,t]of Object.entries({...s,...g.plugins||{}}))if(e&&!_[e]&&t instanceof Function){let n=t();n.init(Z,_e),_[e]=n}G(`initPlugins`)}function Se(){if(!x)return;let e=W(`classes`)||{};f(x,e.container);let n=W(`style`);if(n&&t(n))for(let[e,t]of Object.entries(n))x.style.setProperty(e,t);S=Array.from(x.querySelectorAll(`.${e.viewport}`)).filter(t=>t.closest(`.${e.container}`)===x).pop()||null,S||(S=document.createElement(`div`),f(S,e.viewport),S.append(...ce(x,`.${e.slide}`)),x.insertAdjacentElement(`afterbegin`,S)),x.carousel=Z,G(`initLayout`)}function Ce(){if(!S)return;let e=W(`classes`)||{};z=[],[...ce(S,`.${e.slide}`)].forEach(e=>{if(e.parentElement){let t=ze({el:e,isVirtual:!1,...e.dataset||{}});G(`createSlide`,t),z.push(t)}}),Ue();for(let e of z)G(`addSlide`,e);Re(W(`slides`));for(let e of z){let t=e.el;t?.parentElement===S&&(f(t,g.classes.slide),f(t,e.class),et(e),G(`attachSlideEl`,e))}G(`initSlides`)}function q(){if(!x||!S)return;x.addEventListener(`click`,Je),document.addEventListener(`mousemove`,we),he||(he=function(e){let t=e.target;if(!(t instanceof Element))return;let n=t.closest(`[data-carousel-target]`)?.dataset?.carouselTarget;n&&(ge(n)?.carousel)?.emit(`click`,e)},document.addEventListener(`click`,he));let e=S.getBoundingClientRect();if(re=e.height,ie=e.width,!b){let e=null;b=new ResizeObserver(()=>{e||=requestAnimationFrame(()=>{Te(),e=null})}),b.observe(S)}}function we(e){me=e}function Te(){if(l!==1||!S)return;let e=U.length,t=S.getBoundingClientRect(),n=t.height,r=t.width;e>1&&(k&&Math.abs(n-re)<.5||!k&&Math.abs(r-ie)<.5)||(We(),Oe(),re=n,ie=r,!(k&&!re||!k&&!ie)&&x&&S&&(e!==U.length||!v?.isPointerDown())&&(W(`dragFree`)&&(D||j>F&&j<I)?(ke(),at()):nt(N,{transition:!1})))}function Ee(){y=ee().on(`start`,()=>{(!v||!v.isPointerDown())&&(ke(),at())}).on(`step`,e=>{let t=j;j=e.pos,j!==t&&(M=!1,at())}).on(`end`,e=>{v?.isPointerDown()||(j=e.pos,y&&!D&&(j<F||j>I)?y.spring({clamp:!0,mass:1,tension:200,friction:25,velocity:0,restDelta:1,restSpeed:1}).from({pos:j}).to({pos:u(F,j,I)}).start():M||(M=!0,G(`settle`)))})}function De(){let e=W(`gestures`);!v&&e!==!1&&S&&(v=ne(S,e).on(`start`,e=>{if(!y||W(`gestures`,e)===!1)return;let{srcEvent:t}=e;k&&w(t)&&!o(t.target)&&de(t),y.pause(),y.getCurrentVelocities().pos=0;function n(e){let t=window.getComputedStyle(e),n=new DOMMatrixReadOnly(t.transform);return{width:n.m41||0,height:n.m42||0}}let r=U[N]?.slides[0],i=r?.el;r&&V.has(r.index)&&i&&(j=r.offset||0,j+=(n(i)[A]||0)*(O&&!k?1:-1)),Ke(),D||(j<F||j>I)&&y.spring({clamp:!0,mass:1,tension:500,friction:25,velocity:y.getCurrentVelocities()?.pos||0,restDelta:1,restSpeed:1}).from({pos:j}).to({pos:u(F,j,I)}).start()}).on(`move`,e=>{if(W(`gestures`,e)===!1)return;let{srcEvent:t,axis:n,deltaX:r,deltaY:i}=e;if(w(t)&&t.touches?.length>1)return;let a=t.target,s=o(a),c=s?s.scrollHeight>s.clientHeight?`y`:`x`:void 0;if(s&&s!==S&&(!n||n===c))return;if(!n){de(t),t.stopPropagation(),t.stopImmediatePropagation();return}if(n===`y`&&!k||n===`x`&&k||(de(t),t.stopPropagation(),!y))return;let l=O&&!k?1:-1,u=k?i:r,d=y?.isRunning()?y.getEndValues().pos:j,f=1;D||(d<=F&&u*l<0?(f=Math.max(.01,1-(Math.abs(1/Pe()*Math.abs(d-F))||0)),f*=.2):d>=I&&u*l>0&&(f=Math.max(.01,1-(Math.abs(1/Pe()*Math.abs(d-I))||0)),f*=.2)),d+=u*f*l,y.spring({clamp:!0,mass:1,tension:700,friction:25,velocity:y.getCurrentVelocities()?.pos||0,restDelta:1,restSpeed:1}).from({pos:j}).to({pos:d}).start()}).on(`panstart`,e=>{W(`gestures`,e)!==!1&&e?.axis===(k?`y`:`x`)&&f(S,`is-dragging`)}).on(`panend`,e=>{W(`gestures`,e)!==!1&&p(S,`is-dragging`)}).on(`end`,e=>{if(W(`gestures`,e)===!1)return;let{srcEvent:t,axis:n,velocityX:r,velocityY:i,currentTouch:a}=e;if(a.length>0||!y)return;let s=t.target,c=o(s),l=c?c.scrollHeight>c.clientHeight?`y`:`x`:void 0,d=c&&(!n||n===l);k&&w(t)&&!n&&Je(t);let f=U.length,p=W(`dragFree`);if(!f)return;let m=d?0:W(`vertical`)?i:r;n!==(k?`y`:`x`)&&(m=0);let h=y?.isRunning()?y.getEndValues().pos:j,g=O&&!k?1:-1;if(d||(h+=m*(p?5:1)*g),!D&&(m*g<=0&&h<F||m*g>=0&&h>I)){let e=0;Math.abs(m)>0&&(e=Math.abs(m)*2,e=Math.min(Pe()*.3,e)),h=u(F+e*-1,h,I+e),y.spring({clamp:!0,mass:1,tension:380,friction:25,velocity:m*-1,restDelta:1,restSpeed:1}).from({pos:j}).to({pos:h}).start();return}if(p||_.Autoscroll?.isEnabled()){Math.abs(m)>10?y.spring({clamp:!0,mass:1,tension:150,friction:25,velocity:m*-1,restDelta:1,restSpeed:1}).from({pos:j}).to({pos:h}).start():y.isRunning()||M||(M=!0,G(`settle`));return}if(!(p||_.Autoscroll?.isEnabled())&&(!(e.offsetX||e.offsetY)||n===`y`&&!k||n===`x`&&k)){nt(N,{transition:`tween`});return}let v=Me(h);Math.abs(m)>10&&v===N&&(v+=m>0?O&&!k?1:-1:O&&!k?-1:1),nt(v,{transition:`tween`,tween:{velocity:m*-1}})}).init())}function Oe(){W(`gestures`)===!1?v&&=(v.destroy(),void 0):v||De(),m(S,`is-draggable`,!!v&&U.length>0)}function J(e=`*`){let t=[];for(let n of z)(e===`*`||n.class&&n.class.includes(e)||n.el&&n.el?.classList.contains(e))&&t.push(n);te=void 0,R=e,B=[...t]}function Y(){te=void 0,N=W(`initialPage`);let e=W(`initialSlide`)||void 0;e!==void 0&&(N=Z.getPageIndex(e)||0),N=u(0,N,U.length-1),j=U[N]?.pos||0,P=j}function ke(){if(!y)return;let e=Me(y?.isRunning()?y.getEndValues().pos:j);e!==N&&(te=N,N=e,et(),Ae(),je(),G(`change`,N,te))}function Ae(){if(!x)return;for(let e of x.querySelectorAll(`[data-carousel-index]`))e.innerHTML=N+``;for(let e of x.querySelectorAll(`[data-carousel-page]`))e.innerHTML=N+1+``;for(let e of x.querySelectorAll(`[data-carousel-pages]`))e.innerHTML=U.length+``;let e=W(`classes`)||{},t=Array.from(x.querySelectorAll(`[data-carousel-go-to]`)).filter(t=>t.closest(`.${e.container}`)===x);for(let e of t)parseInt(e.dataset?.carouselGoTo||`-1`,10)===N?e.setAttribute(`aria-current`,`true`):e.removeAttribute(`aria-current`);for(let e of x.querySelectorAll(`[data-carousel-go-prev]`))e.toggleAttribute(`aria-disabled`,!st()),st()?e.removeAttribute(`tabindex`):e.setAttribute(`tabindex`,`-1`);for(let e of x.querySelectorAll(`[data-carousel-go-next]`))e.toggleAttribute(`aria-disabled`,!ct()),ct()?e.removeAttribute(`tabindex`):e.setAttribute(`tabindex`,`-1`);let n=!1,r=U[N]?.slides[0];r&&(r.downloadSrc||r.type===`image`&&r.src)&&(n=!0);for(let e of x.querySelectorAll(`[data-carousel-download]`))e.toggleAttribute(`aria-disabled`,!n)}function je(e){e||=U[N]?.slides[0];let t=e?.el;if(t)for(let n of t.querySelectorAll(`[data-slide-index]`))n.innerHTML=e.index+1+``}function Me(e){if(!U.length)return 0;let t=X(),n=e;D?n-=Math.floor((e-U[0]?.pos)/t)*t||0:n=u(U[0]?.pos,e,U[U.length-1]?.pos);let r=new Map,i=0;for(let e of U){let a=Math.abs(e.pos-n),o=Math.abs(e.pos-n-t),s=Math.abs(e.pos-n+t),c=Math.min(a,o,s);r.set(i,c),i++}let a=r.size>0?[...r.entries()].reduce((e,t)=>t[1]<e[1]?t:e):[N,0];return parseInt(a[0])}function Ne(){return ae}function Pe(){return C}function Fe(){let e=0;if(S){let t=document.createElement(`div`);t.style.display=`block`,f(t,g.classes.slide),S.appendChild(t),e=t.getBoundingClientRect()[A],t.remove(),t=void 0}return e}function X(e=!0){return B.length?B.reduce((e,t)=>e+t.dim,0)+(B.length-(D&&e?0:1))*ae:0}function Ie(e){let t=X(),n=Pe();if(!t||!S||!n)return[];let r=[];e=e===void 0?j:e,D&&(e-=Math.floor(e/t)*t||0);let i=0;for(let a of B){let o=(t=0)=>{r.indexOf(a)>-1||(a.pos=i-e+t||0,a.offset+t>e-a.dim-T+.51&&a.offset+t<e+n+E-.51&&r.push(a))};a.offset=i,D&&(o(t),o(t*-1)),o(),i+=a.dim+ae}return r}function Le(){if(!x)return;let e=Pe(),t=X(!1),n=W(`slidesPerPage`);n=n===`auto`?1/0:parseFloat(n+``),U=[];let r=0,i=0;for(let t of B)(!U.length||r+t.dim-e>.05||i>=n)&&(U.push({index:U.length,slides:[],dim:0,offset:0,pos:0}),r=0,i=0),U[U.length-1]?.slides.push(t),r+=t.dim+ae,i++;let a=W(`center`),o=W(`fill`),s=0;for(let n of U){n.dim=(n.slides.length-1)*ae;for(let e of n.slides)n.dim+=e.dim;n.offset=s,n.pos=s,a!==!1&&(n.pos-=(e-n.dim)*.5),o&&!D&&t>e&&(n.pos=u(0,n.pos,t-e)),s+=n.dim+ae}let c=[],l;for(let e of U){let t={...e};l&&Math.abs(t.pos-l.pos)<.1?(l.dim+=t.dim,l.slides=[...l.slides,...t.slides]):(l=t,t.index=c.length,c.push(t))}U=c,N=u(0,N,U.length-1)}function Re(e,t){let n=[];for(let t of Array.isArray(e)?e:[e]){let e=ze({...t,isVirtual:!0});e.el||=document.createElement(`div`),G(`createSlide`,e),n.push(e)}z.splice(t===void 0?z.length:t,0,...n),Ue();for(let e of n)G(`addSlide`,e),Be(e);return J(R),n}function ze(e){return(n(e)||e instanceof HTMLElement)&&(e={html:e}),{index:-1,el:void 0,class:``,isVirtual:!0,dim:0,pos:0,offset:0,html:``,src:``,...e}}function Be(e){let t=e.el;if(!e||!t)return;let n=e.html?e.html instanceof HTMLElement?e.html:i(e.html):void 0;n&&(f(n,`f-html`),e.htmlEl=n,f(t,`has-html`),t.append(n),G(`contentReady`,e))}function Ve(e){if(!S||!e)return;let t=e.el;if(t){if(t.setAttribute(`index`,e.index+``),t.parentElement!==S){f(t,g.classes.slide),f(t,e.class),et(e);let n;for(let t of z)if(t.index>e.index){n=t.el;break}S.insertBefore(t,n&&S.contains(n)?n:null),G(`attachSlideEl`,e)}return je(e),t}}function He(e){let t=e?.el;t&&(t.remove(),Ge(t),G(`detachSlideEl`,e))}function Ue(){for(let e=0;e<z.length;e++){let t=z[e],n=t.el;n&&(t.index!==e&&Ge(n),n.setAttribute(`index`,`${e}`)),t.index=e}}function We(){if(!x||!S)return;O=W(`rtl`),k=W(`vertical`),A=k?`height`:`width`;let e=W(`classes`);if(m(x,e.isLTR,!O),m(x,e.isRTL,O),m(x,e.isHorizontal,!k),m(x,e.isVertical,k),m(x,e.hasAdaptiveHeight,W(`adaptiveHeight`)),C=0,T=0,E=0,ae=0,S){S.childElementCount||(S.style.display=`grid`);let e=S.getBoundingClientRect();C=S.getBoundingClientRect()[A]||0;let t=window.getComputedStyle(S);ae=parseFloat(t.getPropertyValue(`--f-carousel-gap`))||0,t.getPropertyValue(`overflow-`+(k?`y`:`x`))===`visible`&&(T=Math.abs(e[k?`top`:`left`]),E=Math.abs(window[k?`innerHeight`:`innerWidth`]-e[k?`bottom`:`right`])),S.style.display=``}if(!C)return;let t=Fe();for(let e of B){let n=e.el,i=0;if(e.isVirtual||!n||!r(n))i=t;else{let e=!1;(!n.parentElement||n.parentElement!==S)&&(S.appendChild(n),e=!0),i=n.getBoundingClientRect()[A],e&&n.parentElement?.removeChild(n)}e.dim=i}if(D=!1,W(`infinite`)){D=!0;let e=X(),t=C+T+E;for(let n=0;n<B.length;n++){let r=B[n]?.dim+ae;if(e-r<t&&e-r-t<r){D=!1;break}}}Le(),F=U[0]?.pos||0,I=U[U.length-1]?.pos||0,l===0?Y():P=U[N||0]?.pos||0,G(`refresh`),Ae()}function Ge(e){if(!e||!r(e))return;let t=parseInt(e.getAttribute(`index`)||`-1`),n=``;for(let t of Array.from(e.classList)){let e=t.match(/^f-(\w+)(Out|In)$/);e&&e[1]&&(n=e[1]+``)}if(!e||!n)return;let i=[`f-${n}Out`,`f-${n}In`,`to-prev`,`to-next`,`from-prev`,`from-next`];e.removeEventListener(`animationend`,qe),p(e,i.join(` `)),V.delete(t)}function Ke(){if(!S)return;let e=V.size>0;for(let e of B)Ge(e.el);V.clear(),e&&at()}function qe(e){e.animationName?.substring(0,2)===`f-`&&(Ge(e.target),V.size||(p(x,`in-transition`),!M&&Math.abs(Z.getPosition(!0)-P)<.5&&(M=!0,G(`settle`))),at())}function Je(e){Ye(e),G(`click`,e)}function Ye(e){if(e.defaultPrevented)return;let t=e.composedPath()[0],n=t.closest(`[data-carousel-target]`)?.dataset?.carouselTarget;if(n&&ge(n)!==x)return;if(t.closest(`[data-carousel-go-prev]`)){de(e),Z.prev();return}if(t.closest(`[data-carousel-go-next]`)){de(e),Z.next();return}let r=t.closest(`[data-carousel-go-to]`);if(r){de(e),Z.goTo(parseFloat(r.dataset.carouselGoTo||``)||0);return}if(t.closest(`[data-carousel-download]`)){de(e);let t=U[N]?.slides[0];if(t&&(t.downloadSrc||t.type===`image`&&t.src)){let e=t.downloadFilename,n=document.createElement(`a`),r=t.downloadSrc||t.src||``;n.href=r,n.target=`_blank`,n.download=e||r,n.click()}return}}function Xe(e){let t=e.el,n=t?.querySelector(`.f-spinner`);if(!t||n)return Z;let r=W(`spinnerTpl`),a=i(r);return a&&(f(a,`f-spinner`),t.insertAdjacentElement(`beforeend`,a)),Z}function Ze(e){let t=e.el;t&&t.querySelector(`.f-spinner`)?.remove()}function Qe(e,t){if(l===1){Ze(e),$e(e);let n=e.el;if(n){let r=document.createElement(`div`);f(r,`f-html`),f(r,`is-error`),r.innerHTML=oe(t||`<p>{{ERROR}}</p>`),e.htmlEl=r,f(n,`has-html has-error`),n.insertAdjacentElement(`afterbegin`,r),G(`contentReady`,e)}}return Z}function $e(e){let t=e.el;t&&(t.querySelector(`.f-html.is-error`)?.remove(),p(t,`has-error`))}function et(e){e||=U[N]?.slides[0];let t=e?.el;if(!t)return;let r=W(`formatCaption`,e);r===void 0&&(r=e.caption),r||=``;let i=W(`captionEl`);if(i&&i instanceof HTMLElement){if(e.index!==N)return;if(n(r)&&(i.innerHTML=oe(r+``)),r instanceof HTMLElement){if(r.parentElement===i)return;i.innerHTML=``,r.parentElement&&(r=r.cloneNode(!0)),i.append(r)}return}if(!r)return;let a=e.captionEl||t.querySelector(`.f-caption`);!a&&r instanceof HTMLElement&&r.classList.contains(`f-caption`)&&(a=r),a||(a=document.createElement(`div`),f(a,`f-caption`),n(r)?a.innerHTML=oe(r+``):r instanceof HTMLElement&&(r.parentElement&&(r=r.cloneNode(!0)),a.append(r)));let o=`f-caption-${pe}_${e.index}`;a.setAttribute(`id`,o),a.dataset.selectable=`true`,f(t,`has-caption`),t.setAttribute(`aria-labelledby`,o),e.captionEl=a,t.insertAdjacentElement(`beforeend`,a)}function tt(e,t){if(!x||!C||!y||!t||!n(t)||t===`tween`)return!1;for(let e of H)if(C-e.dim>.5)return!1;if(T>.5||E>.5)return;let r=U.length,i=e>N?1:-1;e=D?(e%r+r)%r:u(0,e,r-1),O&&(i*=-1);let a=U[N]?.slides[0],o=a?.index,s=U[e]?.slides[0],c=s?.index,l=U[e]?.pos;if(c===void 0||o===void 0||o===c||j===l||Math.abs(C-(s?.dim||0))>1)return!1;M=!1,y.pause(),Ke(),f(x,`in-transition`),j=P=l;let d=Ve(a),m=Ve(s);return ke(),d&&(V.add(o),d.style.transform=``,d.addEventListener(`animationend`,qe),p(d,g.classes.isSelected),d.inert=!1,f(d,`f-${t}Out to-${i>0?`next`:`prev`}`)),m&&(V.add(c),m.style.transform=``,m.addEventListener(`animationend`,qe),f(m,g.classes.isSelected),m.inert=!1,f(m,`f-${t}In from-${i>0?`prev`:`next`}`)),at(),!0}function nt(e,n={}){let{transition:r,tween:i}={transition:g.transition,tween:g.tween,...n||{}};if(!x||!y)return;let a=U.length;if(!a||tt(e,r))return;e=D?(e%a+a)%a:u(0,e,a-1),P=U[e||0]?.pos||0;let o=y.isRunning()?y.getEndValues().pos:j;if(Math.abs(P-o)<1){j=P,N!==e&&(et(),te=N,N=e,Ae(),je(),G(`change`,N,te)),at(),M||(M=!0,G(`settle`));return}if(y.pause(),Ke(),D){let e=X(),t=Math.floor((o-U[0]?.pos)/e)||0,n=P+t*e,r=n-e;P=[n+e,n,r].reduce(function(e,t){return Math.abs(t-o)<Math.abs(e-o)?t:e})}if(r!==!1&&t(i)){y.spring(c({},g.tween,i)).from({pos:j}).to({pos:P}).start();return}j=P,ke(),at(),M||(M=!0,G(`settle`))}function rt(e){let t=j;if(D&&e!==!0){let e=X(),n=Math.floor((j-U[0]?.pos||0)/e)||0;t-=n*e}return t}function it(e){j=e,ke(),at()}function at(){if(!x||!S)return;H=Ie();let e=new Set,t=[],n=U[N],r=g.setTransform,i;for(let r of B){let a=V.has(r.index),o=H.indexOf(r)>-1,s=n?.slides?.indexOf(r)>-1;if(r.isVirtual&&!a&&!o)continue;let c=Ve(r);if(c&&(t.push(r),s&&e.add(c),W(`adaptiveHeight`)&&s)){let e=(c.lastElementChild||c).getBoundingClientRect().height;i=i==null?e:Math.max(i,e)}}S&&i&&(S.style.height=`${i}px`),[...ce(S,`.${g.classes.slide}`)].forEach(t=>{m(t,g.classes.isSelected,e.has(t));let n=z[parseInt(t.getAttribute(`index`)||`-1`)];if(!n){t.remove(),Ge(t);return}let i=V.has(n.index),a=H.indexOf(n)>-1;if(n.isVirtual&&!i&&!a){He(n);return}if(t.inert=!a,r===!1)return;let o=n.pos?Math.round(n.pos*1e4)/1e4:0,s=0,c=0,l=0,u=0;i||(s=k?0:O?o*-1:o,c=k?o:0,l=d(s,0,n.dim,0,100),u=d(c,0,n.dim,0,100)),r instanceof Function&&!i?r(Z,n,{x:s,y:c,xPercent:l,yPercent:u}):t.style.transform=s||c?`translate3d(${l}%, ${u}%,0)`:``}),G(`render`,t)}function ot(){x?.removeEventListener(`click`,Je),document.removeEventListener(`mousemove`,we),V.clear(),b?.disconnect(),b=void 0;for(let e of z){let t=e.el;t&&r(t)&&(e.state=void 0,Ze(e),$e(e),e.isVirtual?(He(e),e.el=void 0):(Ge(t),t.style.transform=``,S&&!S.contains(t)&&S.appendChild(t)))}for(let e of Object.values(_))e?.destroy();_={},v?.destroy(),v=void 0,y?.destroy(),y=void 0;for(let[e,t]of Object.entries(g.classes||{}))e!==`container`&&p(x,t);p(S,`is-draggable`)}function st(){return D||N>0}function ct(){return D||N<U.length-1}let Z={add:function(e,t){let n=j,r=N,i=X(),a=y?.isRunning()?y.getEndValues().pos:j,o=i&&Math.floor((a-(U[0]?.pos||0))/i)||0;return Re(e,t),J(R),We(),y&&i&&(r===N&&(n-=o*i),n===P?j=P:y.spring({clamp:!0,mass:1,tension:300,friction:25,restDelta:1,restSpeed:1}).from({pos:n}).to({pos:P}).start()),at(),Z},canGoPrev:st,canGoNext:ct,destroy:function(){return G(`destroy`),window.removeEventListener(`resize`,be),ot(),se.clear(),x=null,U=[],z=[],g={...fe},_={},B=[],L=void 0,R=`*`,l=2,Z},emit:G,filter:function(e=`*`){return J(e),We(),j=u(F,j,I),at(),G(`filter`,e),Z},getContainer:function(){return x},getGapDim:Ne,getGestures:function(){return v},getLastMouseMove:function(){return me},getOption:function(e){return W(e)},getOptions:function(){return g},getPage:function(){return U[N]},getPageIndex:function(e){if(e!==void 0){for(let t of U||[])for(let n of t.slides)if(n.index===e)return t.index;return-1}return N},getPageIndexFromPosition:Me,getPageProgress:function(e,t){e===void 0&&(e=N);let n=U[e];if(!n)return e>N?-1:1;let r=X(),i=Ne(),a=n.pos,o=rt();if(D&&t!==!0){let e=Math.floor((o-U[0]?.pos)/r)||0;o-=e*r,a=[a+r,a,a-r].reduce(function(e,t){return Math.abs(t-o)<Math.abs(e-o)?t:e})}return(o-a)/(n.dim+i)||0},getPageVisibility:function(e){e===void 0&&(e=N);let t=U[e];if(!t)return e>N?-1:1;let n=rt(),r=Pe(),i=t.pos;if(D){let e=X(),t=Math.floor((n-U[0]?.pos)/e)||0,r=i+t*e,a=r-e;i=[r+e,r,a].reduce(function(e,t){return Math.abs(t-n)<Math.abs(e-n)?t:e})}return i>n&&i+t.dim<n+r?1:i<n?(i+t.dim-n)/t.dim||0:i+t.dim>n+r&&(n+r-i)/t.dim||0},getPages:function(){return U},getPlugins:function(){return _},getPosition:rt,getSlides:function(){return z},getState:function(){return l},getTotalSlideDim:X,getTween:function(){return y},getViewport:function(){return S},getViewportDim:Pe,getVisibleSlides:function(e){return e===void 0?H:Ie(e)},goTo:nt,hasNavigated:function(){return te!==void 0},hideError:$e,hideLoading:Ze,init:ve,isInfinite:function(){return D},isInTransition:function(){return V.size>0},isRTL:function(){return O},isSettled:function(){return M},isVertical:function(){return k},localize:oe,next:function(e={}){return nt(N+1,e),Z},off:ue,on:le,prev:function(e={}){return nt(N-1,e),Z},reInit:ye,remove:function(e){e===void 0&&(e=z.length-1);let t=z[e];return t&&(G(`removeSlide`,t),t.el&&=(Ge(t.el),t.el.remove(),void 0),z.splice(e,1),J(R),We(),j=u(F,j,I),at()),Z},setPosition:it,showError:Qe,showLoading:Xe,version:`6.1.15`};return Z};_e.l10n={en_EN:G},_e.getDefaults=()=>fe;let ve=function(e=``,t=``,n=``){return e.split(t).join(n)},ye={tpl:e=>`<img class="f-panzoom__content" 
    ${e.srcset?`data-lazy-srcset="{{srcset}}"`:``} 
    ${e.sizes?`data-lazy-sizes="{{sizes}}"`:``} 
    data-lazy-src="{{src}}" alt="{{alt}}" />`},be=()=>{let e;function r(n,r){let i=e?.getOptions().Zoomable,a=(t(i)?{...ye,...i}:ye)[n];return a&&typeof a==`function`&&r?a(r):a}function i(){e&&e.getOptions().Zoomable!==!1&&(e.on(`addSlide`,s),e.on(`removeSlide`,c),e.on(`attachSlideEl`,l),e.on(`click`,o),e.on(`change`,a),e.on(`ready`,a))}function a(){u();let t=e?.getVisibleSlides()||[];if(t.length>1||e?.getOption(`transition`)===`slide`)for(let n of t){let t=n.panzoomRef;t&&(e?.getPage().slides||[]).indexOf(n)<0&&t.execute(B.ZoomTo,{...t.getStartPosition()})}}function o(e,t){let n=t.target;n&&!t.defaultPrevented&&n.dataset.panzoomAction&&d(n.dataset.panzoomAction)}function s(t,i){let a=i.el;if(!e||!a||i.panzoomRef)return;let o=i.src||i.lazySrc||``,s=i.alt||i.caption||`Image #${i.index}`,c=i.srcset||i.lazySrcset||``,l=i.sizes||i.lazySizes||``;if(o&&n(o)&&!i.html&&(!i.type||i.type===`image`)){i.type=`image`,i.thumbSrc=i.thumbSrc||o;let e=r(`tpl`,i);e=ve(e,`{{src}}`,o+``),e=ve(e,`{{srcset}}`,c+``),e=ve(e,`{{sizes}}`,l+``),a.insertAdjacentHTML(`afterbegin`,e)}let d=a.querySelector(`.f-panzoom__content`);if(!d)return;d.setAttribute(`alt`,s+``);let f=i.width&&i.width!==`auto`?parseFloat(i.width+``):`auto`,p=i.height&&i.height!==`auto`?parseFloat(i.height+``):`auto`,m=se(a,{width:f,height:p,classes:{container:`f-zoomable`},event:()=>e?.getLastMouseMove(),spinnerTpl:()=>e?.getOption(`spinnerTpl`)||``,...r(`Panzoom`)});m.on(`*`,(t,n,...r)=>{e&&(n===`loading`&&(i.state=0),n===`loaded`&&(i.state=1),n===`error`&&(i.state=2,e?.showError(i,`{{IMAGE_ERROR}}`)),e.emit(`panzoom:${n}`,i,...r),n===`loading`&&e.emit(`contentLoading`,i),n===`ready`&&e.emit(`contentReady`,i),i.index===e?.getPageIndex()&&u())}),i.panzoomRef=m}function c(e,t){t.panzoomRef&&=(t.panzoomRef.destroy(),void 0)}function l(e,t){let n=t.panzoomRef;if(n)switch(n.getState()){case 0:n.init();break;case 3:n.execute(B.ZoomTo,{...n.getStartPosition(),velocity:0})}}function u(){let t=e?.getContainer()||void 0,n=e?.getPage()?.slides[0]?.panzoomRef;if(t){if(n)n.updateControls(t);else for(let e of t.querySelectorAll(`[data-panzoom-action]`)||[])e.setAttribute(`aria-disabled`,``),e.setAttribute(`tabindex`,`-1`)}}function d(t,...n){e?.getPage().slides[0].panzoomRef?.execute(t,...n)}return{init:function(t){e=t,e.on(`initPlugins`,i)},destroy:function(){if(e){e.off(`initPlugins`,i),e.off(`addSlide`,s),e.off(`removeSlide`,c),e.off(`attachSlideEl`,l),e.off(`click`,o),e.off(`change`,a),e.off(`ready`,a);for(let t of e.getSlides())c(e,t)}e=void 0},execute:d}},K={syncOnChange:!1,syncOnClick:!0,syncOnHover:!1},xe=()=>{let e,n;function r(){let n=e?.getOptions().Sync;return t(n)?{...K,...n}:K}function i(t){e&&t&&(n=t,e.getOptions().classes={...e.getOptions().classes,isSelected:``},e.getOptions().initialSlide=n.getPage()?.slides[0]?.index||0,r().syncOnChange&&e.on(`change`,l),r().syncOnClick&&e.on(`click`,d),r().syncOnHover&&e.getViewport()?.addEventListener(`mouseover`,f),a())}function a(){e&&n&&(e.on(`ready`,c),e.on(`refresh`,p),n.on(`change`,u),n.on(`filter`,m))}function o(){e?.off(`ready`,c),e?.off(`refresh`,p),e?.off(`change`,l),e?.off(`click`,d),e?.getViewport()?.removeEventListener(`mouseover`,f),n?.off(`change`,u),n?.off(`filter`,m),n=void 0}function s(){let t=r().target;e&&t&&i(t)}function c(){h()}function l(){if(e&&n){let t=e.getPage()?.slides||[],r=n.getPageIndex(t[0].index||0);r>-1&&n.goTo(r,e.hasNavigated()?void 0:{tween:!1,transition:!1}),h()}}function u(){if(e&&n){let t=e.getPageIndex(n.getPage()?.slides[0].index||0);t>-1&&e.goTo(t,n.hasNavigated()?void 0:{tween:!1,transition:!1}),h()}}function d(t,r){if(!e||!n||e.getTween()?.isRunning())return;let i=e?.getOptions().classes.slide;if(!i)return;let a=r.target.closest(`.${i}`);if(a){let e=parseInt(a.getAttribute(`index`)||``)||0,t=n.getPageIndex(e);n.goTo(t)}}function f(t){e&&d(e,t)}function p(){if(e&&n){let t=e.getPageIndex(n.getPage()?.slides[0].index||0);t>-1&&e.goTo(t,{tween:!1,transition:!1}),h()}}function m(t,r){e&&n&&(e.filter(r),u())}function h(){if(!n)return;let t=n.getPage()?.slides[0]?.index||0;for(let n of e?.getSlides()||[])n.el?.classList.toggle(`is-selected`,n.index===t)}return{init:function(t){e=t,e.on(`initSlides`,s)},destroy:function(){o(),e?.off(`initSlides`,s),e=void 0},getTarget:function(){return n}}},Se={showLoading:!0,preload:1},Ce=`is-lazyloading`,q=`is-lazyloaded`,we=`has-lazyerror`,Te=()=>{let e;function n(){let n=e?.getOptions().Lazyload;return t(n)?{...Se,...n}:Se}function r(t){let r=t.el;if(!r)return;let i=n(),a=`[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]`,o=Array.from(r.querySelectorAll(a));r.matches(a)&&o.push(r);for(let n of o){let r=n.dataset.lazySrc,a=n.dataset.lazySrcset,o=n.dataset.lazySizes,s=n.dataset.lazyBg,c=(n instanceof HTMLImageElement||n instanceof HTMLSourceElement)&&(r||a),l=!!s;if(!(c||l))continue;let u=r||a||s;if(u){if(c){let s=n.parentElement?.classList.contains(`f-panzoom__wrapper`);i.showLoading&&e?.showLoading(t),n.addEventListener(`load`,()=>{e?.hideLoading(t),p(n,we),n instanceof HTMLImageElement?n.decode().finally(()=>{p(n,Ce),f(n,q)}).catch(()=>void 0):(p(n,Ce),f(n,q)),s||e?.emit(`lazyLoad:loaded`,t,n,u)}),n.addEventListener(`error`,()=>{e?.hideLoading(t),p(n,Ce),f(n,we),s||e?.emit(`lazyLoad:error`,t,n,u)}),n.classList.add(`f-lazyload`),n.classList.add(Ce),s||e?.emit(`lazyLoad:load`,t,n,u),r&&(n.src=r),a&&(n.srcset=a),o&&(n.sizes=o)}else l&&(n.style.backgroundImage=`url('${s}')`);delete n.dataset.lazySrc,delete n.dataset.lazySrcset,delete n.dataset.lazySizes,delete n.dataset.lazyBg}}}function i(){if(!e)return;let t=[...e.getVisibleSlides()],i=n().preload;if(i>0){let n=e.getPosition(),r=e.getViewportDim();t.push(...e.getVisibleSlides(n+r*i),...e.getVisibleSlides(n-r*i))}for(let e of t)r(e)}return{init:function(t){e=t,e.on(`render`,i)},destroy:function(){e?.off(`render`,i),e=void 0}}},Ee={prevTpl:`<svg width="24" height="24" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg>`,nextTpl:`<svg width="24" height="24" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg>`},De=()=>{let e;function n(){let n=e?.getOptions().Arrows;return t(n)?{...Ee,...n}:Ee}let r,a;function o(){if(!e)return;let t=e.getViewport();t&&(r||(r=s(`prev`),r&&t.insertAdjacentElement(`beforebegin`,r)),a||(a=s(`next`),a&&t.insertAdjacentElement(`afterend`,a)),m(e.getContainer(),`has-arrows`,!0))}function s(t){let r=n(),a=`<button data-carousel-go-${t} tabindex="0" class="f-button is-arrow is-${t}" title="{{${t.toUpperCase()}}}">`+r[`${t}Tpl`]+`</button>`,o=i(e.localize(a))||void 0;return o&&f(o,r[`${t}Class`]),o}function c(){r?.remove(),r=void 0,a?.remove(),a=void 0,e?.getContainer()?.classList.remove(`has-arrows`)}function l(){e&&(r?.toggleAttribute(`aria-disabled`,!e.canGoPrev()),a?.toggleAttribute(`aria-disabled`,!e.canGoNext()))}function u(){e&&e.getOptions().Arrows!==!1&&e.getPages().length>1?(o(),l()):c()}return{init:function(t){e=t.on([`change`,`refresh`],u)},destroy:function(){c(),e?.off([`change`,`refresh`],u),e=void 0}}},Oe=`<circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/>`,J=`<g><line x1="11" y1="8" x2="11" y2="14"></line></g>`+Oe,Y={moveLeft:[`moveLeft`,`MOVE_LEFT`,`<path d="M5 12h14M5 12l6 6M5 12l6-6"/>`],moveRight:[`moveRight`,`MOVE_RIGHT`,`<path d="M5 12h14M13 18l6-6M13 6l6 6"/>`],moveUp:[`moveUp`,`MOVE_UP`,`<path d="M12 5v14M18 11l-6-6M6 11l6-6"/>`],moveDown:[`moveDown`,`MOVE_DOWN`,`<path d="M12 5v14M18 13l-6 6M6 13l6 6"/>`],zoomOut:[`zoomOut`,`ZOOM_OUT`,Oe],zoomIn:[`zoomIn`,`ZOOM_IN`,J],toggleFull:[`toggleFull`,`TOGGLE_FULL`,J],iterateZoom:[`iterateZoom`,`ITERATE_ZOOM`,J],toggle1to1:[`toggleFull`,`TOGGLE_FULL`,`<path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/>`],rotateCCW:[`rotateCCW`,`ROTATE_CCW`,`<path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/>`],rotateCW:[`rotateCW`,`ROTATE_CW`,`<path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/>`],flipX:[`flipX`,`FLIP_X`,`<path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/>`],flipY:[`flipY`,`FLIP_Y`,`<path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/>`],reset:[`reset`,`RESET`,`<path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>`],toggleFS:[`toggleFS`,`TOGGLE_FS`,`<g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g>`]},ke={};for(let e of Object.keys(Y)){let t=Y[e];ke[e]={tpl:`<button data-panzoom-action="${t[0]}" class="f-button" title="{{${t[1]}}}"><svg>${t[2]}</svg></button>`}}var Ae;(function(e){e.Left=`left`,e.middle=`middle`,e.right=`right`})(Ae||={});let je={counter:{tpl:`<div class="f-counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>`},download:{tpl:`<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>`},autoplay:{tpl:`<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>`},thumbs:{tpl:`<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>`},...ke},Me={absolute:!1,display:{left:[],middle:[`zoomIn`,`zoomOut`,`toggle1to1`,`rotateCCW`,`rotateCW`,`flipX`,`flipY`,`reset`],right:[]},enabled:`auto`,items:{}},Ne=()=>{let e,r;function a(n){let r=e?.getOptions().Toolbar,i=(t(r)?{...Me,...r}:Me)[n];return i&&typeof i==`function`&&e?i(e):i}function o(){if(!e||r||e?.getOptions().Toolbar===!1)return;let o=e.getContainer();if(!o)return;let s=a(`enabled`);if(!s)return;let l=a(`absolute`),u=e.getSlides().length>1,d=!1,p=!1;for(let t of e.getSlides())t.panzoomRef&&(d=!0),(t.downloadSrc||t.type===`image`&&t.src)&&(p=!0);let m=e.getPlugins().Thumbs?.isEnabled()||!1,h=u&&e.getPlugins().Autoplay||!1,g=e.getPlugins().Fullscreen&&(document.fullscreenEnabled||document.webkitFullscreenEnabled);if(s===`auto`&&(s=d),!s)return;r=o.querySelector(`.f-carousel__toolbar`)||void 0,r||(r=document.createElement(`div`),f(r,`f-carousel__toolbar`));let _=a(`display`),v=c({},je,a(`items`));for(let a of[`left`,`middle`,`right`]){let o=_[a]||[],s=document.createElement(`div`);f(s,`f-carousel__toolbar__column is-${a}`);for(let r of o){let a;if(n(r)){if(r===`counter`&&!u||r===`autoplay`&&!h||Object.prototype.hasOwnProperty.call(ke,r)&&!d||r===`fullscreen`&&!g||r===`thumbs`&&!m||r===`download`&&!p)continue;a=v[r]}if(t(r)&&(a=r),a&&a.tpl){let t=e.localize(a.tpl);t=t.split(`<svg>`).join(`<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">`);let n=i(t);n&&(typeof a.click==`function`&&e&&n.addEventListener(`click`,t=>{t.preventDefault(),t.stopPropagation(),typeof a.click==`function`&&e&&a.click(e,t)}),s.append(n))}}r.append(s)}if(r.childElementCount){if(l&&f(r,`is-absolute`),!r.parentElement){let e=a(`parentEl`);e?e.insertAdjacentElement(`afterbegin`,r):o.insertAdjacentElement(`afterbegin`,r)}o.contains(r)&&(f(o,`has-toolbar`),l&&f(o,`has-absolute-toolbar`))}}return{init:function(t){e=t,e?.on(`initSlides`,o)},destroy:function(){e?.off(`initSlides`,o),p(e?.getContainer(),`has-toolbar has-absolute-toolbar`),r?.remove(),r=void 0},add:function(e,t){je[e]=t},isEnabled:function(){return!!r}}},Pe={autoStart:!0,pauseOnHover:!0,showProgressbar:!0,timeout:2e3},Fe=()=>{let e,n,r=!1,i=!1,a=!1,o=null;function s(n){let r=e?.getOptions().Autoplay,i=(t(r)?{...Pe,...r}:Pe)[n];return i&&typeof i==`function`&&e?i(e):i}function c(){let t=e?.getPage()?.slides||[];for(let e of t)if(e.state===0)return!0;return!1}function l(){clearTimeout(n),n=void 0}function u(){if(!e||!r||a||i||n||!e.isSettled()||c())return;m();let t=s(`timeout`);n=setTimeout(()=>{if(e&&r&&!i){if(!e.isInfinite()&&e.getPageIndex()===e.getPages().length-1){e.goTo(0);return}e.next()}},t)}function d(){if(!e||e.getPages().length<2||e.getOptions().Autoplay===!1||r)return;r=!0,e.emit(`autoplay:start`,s(`timeout`)),f(e.getContainer(),`has-autoplay`),e.getTween()?.on(`start`,x);let t=e?.getContainer();t&&s(`pauseOnHover`)&&matchMedia(`(hover: hover)`).matches&&(t.addEventListener(`mouseenter`,S,!1),t.addEventListener(`mouseleave`,C,!1)),e.on(`change`,y),e.on(`settle`,b),e.on(`contentReady`,_),e.on(`panzoom:touchStart`,p),e.on(`panzoom:wheel`,p),e.isSettled()&&u()}function p(){if(l(),h(),e){if(r){e.emit(`autoplay:end`),e.getTween()?.off(`start`,x);let t=e.getContainer();t&&(t.classList.remove(`has-autoplay`),t.removeEventListener(`mouseenter`,S,!1),t.removeEventListener(`mouseleave`,C,!1))}e.off(`change`,y),e.off(`settle`,b),e.off(`contentReady`,_),e.off(`panzoom:touchStart`,p),e.off(`panzoom:wheel`,p)}r=!1,i=!1}function m(){if(!e||(h(),!s(`showProgressbar`)))return;let t=s(`progressbarParentEl`);if(!t&&e.getPlugins().Toolbar?.isEnabled()&&(t=e.getContainer()),!t&&e.getPlugins().Toolbar?.isEnabled()!==!0){let n=e.getPages()[0]?.slides||[],r=e.getPage()?.slides||[];n.length===1&&r.length===1&&(t=r[0].el)}if(t||=e.getViewport(),!t)return;o=document.createElement(`div`),f(o,`f-progressbar`),t.prepend(o);let n=s(`timeout`)||1e3;o.style.animationDuration=`${n}ms`}function h(){o&&=(o.remove(),null)}function g(){e&&e.getPages().length>1&&s(`autoStart`)&&d()}function _(){u()}function v(e,t){let n=t.target;n&&!t.defaultPrevented&&n.dataset.autoplayAction===`toggle`&&ee.toggle()}function y(){!e||!e?.isInfinite()&&e.getPageIndex()===e.getPages().length-1?p():(l(),h())}function b(){u()}function x(){l(),h()}function S(){a=!0,r&&(l(),h())}function C(){a=!1,r&&!i&&e?.isSettled()&&u()}let ee={init:function(t){e=t,e.on(`ready`,g),e.on(`click`,v)},destroy:function(){p(),e?.off(`ready`,g),e?.off(`click`,v),e=void 0},isEnabled(){return r},pause:function(){i=!0,l(),h()},resume:function(){i=!1,r&&!a&&u()},start(){d()},stop(){p()},toggle(){r?p():d()}};return ee},X={Carousel:{Lazyload:{showLoading:!1}},minCount:2,showOnStart:!0,thumbTpl:`<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>`,type:`modern`},Ie,Le=()=>{let e,n,r,a,o=0,s=0,l=!0,d;function p(n){let r=e?.getOptions().Thumbs,i=(t(r)?{...X,...r}:X)[n];return i&&typeof i==`function`&&e?i(e):i}function m(){if(!e||e?.getOptions().Thumbs===!1)return!1;let t=0;for(let n of e.getSlides())n.thumbSrc&&t++;return t>=p(`minCount`)}function h(){return p(`type`)===`modern`}function g(){return p(`type`)===`scrollable`}function _(){let t=[],n=e?.getSlides()||[];for(let e of n)t.push({index:e.index,class:e.thumbClass,html:v(e)});return t}function v(e){let t=e.thumb?e.thumb instanceof HTMLImageElement?e.thumb.src:e.thumb:e.thumbSrc||void 0,n=e.thumbAlt===void 0?`Thumbnail #${(e.index||0)+1}`:e.thumbAlt+``,r=p(`thumbTpl`);return r=ve(r,`{{alt}}`,n),r=ve(r,`{{src}}`,t+``),r=ve(r,`{{index}}`,`${e.index||0}`),r=ve(r,`{{page}}`,`${(e.index||0)+1}`),r}function y(e){return`<div index="${e.index||0}" class="f-thumbs__slide ${e.class||``}">${e.html||``}</div>`}function b(t=!1){let n=e?.getContainer();if(!e||!n||r||!m())return;let i=p(`Carousel`)?.classes||{};if(i.container=i.container||`f-thumbs`,!r){let e=n.nextElementSibling;e?.classList.contains(i.container)&&(r=e)}if(!r){r=document.createElement(`div`);let e=p(`parentEl`);e?e.insertAdjacentElement(`beforeend`,r):n.insertAdjacentElement(`afterend`,r)}f(r,i.container),f(r,`f-thumbs`),f(r,`is-${p(`type`)}`),t&&f(r,`is-hidden`)}function x(){if(!r||!g())return;a=document.createElement(`div`),f(a,`f-thumbs__viewport`);let t=``;for(let e of _())typeof(e.html||``)==`string`&&(t+=y(e));a.innerHTML=t,r.append(a),r.addEventListener(`click`,t=>{t.preventDefault();let n=t.target.closest(`[index]`),r=parseInt(n?.getAttribute(`index`)||`-1`);e&&r>-1&&e.goTo(r)}),d=new IntersectionObserver(e=>{e.forEach(e=>{e.isIntersecting&&e.target instanceof HTMLImageElement&&(e.target.src=e.target.getAttribute(`data-lazy-src`)+``,e.target.removeAttribute(`data-lazy-src`),d?.unobserve(e.target))})},{root:a,rootMargin:`100px`}),r.querySelectorAll(`[data-lazy-src]`).forEach(e=>{d?.observe(e)}),e?.emit(`thumbs:ready`)}function S(){if(!Ie||!e||!r||g()||n)return;let t=_();if(!t.length)return;let i=c({},{Sync:{target:e},Lazyload:{preload:1},slides:t,classes:{container:`f-thumbs`,viewport:`f-thumbs__viewport`,slide:`f-thumbs__slide`},center:!0,fill:!h(),infinite:!1,dragFree:!0,rtl:e.getOptions().rtl||!1,slidesPerPage:e=>{let t=0;return h()&&(te(),t=(o-s)*4),e&&e.getTotalSlideDim()<=e.getViewportDim()-t?1/0:1}},X.Carousel||{},p(`Carousel`)||{});n=Ie(r,i,{Sync:xe,Lazyload:Te}),n.on(`ready`,()=>{f(r,`is-syncing`),e?.emit(`thumbs:ready`),h()&&e?.on(`render`,E)}),n.on(`destroy`,()=>{e?.emit(`thumbs:destroy`)}),n.init(),n.getGestures()?.on(`start`,()=>{l=!1}),n.on(`click`,(e,t)=>{let n=t.target;if(n){let e=n.matches(`button`)?n:n.firstElementChild;e&&e.matches(`button`)&&(t.preventDefault(),e.focus({preventScroll:!0}))}}),f(e.getContainer(),`has-thumbs`),P()}function C(){r||(b(!0),x(),S()),r&&r.classList.toggle(`is-hidden`)}function ee(){m()&&p(`showOnStart`)&&(b(),x())}function w(){m()&&(S(),e?.on(`addSlide`,O),e?.on(`removeSlide`,k),e?.on(`click`,A),e?.on(`refresh`,j),e?.getGestures()?.on(`start`,T),M(!0))}function T(){l=!0,document.activeElement?.closest(`.f-thumbs`)&&document.activeElement?.blur()}function E(){r?.classList.toggle(`is-syncing`,e?.hasNavigated()===!1||e?.getTween()?.isRunning()),P(),e?.getGestures()?.isPointerDown()&&N()}function D(){l=!0,M()}function O(e,t){let r={html:v(t)};if(n)n.add(r,t.index);else if(a){let e=i(y(r));if(e){a.append(e);let t=e.querySelector(`img`);t&&d?.observe(t)}}}function k(e,t){n?n.remove(t.index):a&&a.querySelector(`[index="${t.index}"]`)?.remove()}function A(e,t){let n=t.target;!t.defaultPrevented&&n?.dataset?.thumbsAction===`toggle`&&C()}function j(){M()}function M(t=!1){if(!e||!a||!g())return;let n=e.getPageIndex();a.querySelectorAll(`.is-selected`).forEach(e=>{e.classList.remove(`is-selected`)});let r=a.querySelector(`[index="${n}"]`);if(r){r.classList.add(`is-selected`);let e=a.getBoundingClientRect(),n=r.getBoundingClientRect(),i=r.offsetTop-a.offsetTop-e.height*.5+n.height*.5,o=r.scrollLeft-a.scrollLeft-e.width*.5+n.width*.5;a.scrollTo({top:i,left:o,behavior:t?`instant`:`smooth`})}}function te(){if(!h()||!r)return;let e=e=>r&&parseFloat(getComputedStyle(r).getPropertyValue(`--f-thumb-`+e))||0;o=e(`width`),s=e(`clip-width`)}function N(){if(!h()||!e||!n||!l)return;let t=n.getTween(),r=n.getPages(),i=e.getPageIndex()||0,a=e.getPageProgress()||0;if(!e||!r||!r[i]||!t)return;let c=t.isRunning()?t.getCurrentValues().pos:n.getPosition();if(c===void 0)return;let d=r[i].pos+a*(o-s);d=u(r[0].pos,d,r[r.length-1].pos),t.from({pos:c}).to({pos:d}).start()}function P(){if(!h()||!e||!n)return;let t=n?.getSlides()||[],r=o*-.5;for(let n of t){let t=n.el;if(!t)continue;let i=e.getPageProgress(n.index)||0;i=Math.max(-1,Math.min(1,i)),i>-1&&i<1&&(r+=o*.5*(1-Math.abs(i))),i=Math.round(i*1e4)/1e4,r=Math.round(r*1e4)/1e4,t.style.setProperty(`--progress`,`${Math.abs(i)}`),t.style.setProperty(`--shift`,`${e?.isRTL()?r*-1:r}px`),i>-1&&i<1&&(r+=o*.5*(1-Math.abs(i)))}}return{init:function(t,n){Ie=n,e=t,e.on(`ready`,w),e.on(`initSlides`,ee),e.on(`change`,D)},destroy:function(){g()&&e?.emit(`thumbs:destroy`),e?.off(`ready`,w),e?.off(`initSlides`,ee),e?.off(`change`,D),e?.off(`render`,E),e?.off(`addSlide`,O),e?.off(`click`,A),e?.off(`refresh`,j),e?.getGestures()?.off(`start`,T),e?.getContainer()?.classList.remove(`has-thumbs`),e=void 0,n?.destroy(),n=void 0,r?.remove(),r=void 0},getCarousel:function(){return n},getContainer:function(){return r},getType:function(){return p(`type`)},isEnabled:m}},Re={autosize:!1,iframeAttr:{allow:`autoplay; fullscreen`,scrolling:`auto`},preload:!1},ze=()=>{let e;function r(){let n=e?.getOptions().Html;return t(n)?c({},Re,n):Re}function i(){return e?.getOptions().Html!==!1}function a(e){return e.type===`iframe`||e.type===`pdf`||e.type===`gmap`}function o(e){let t=`${e}`;return t.match(/^\d+$/)?`${t}px`:t}function s(e){if(e===void 0||e===``)return;let t=`${e}`.trim();if(!t.match(/^\d+(\.\d+)?(px)?$/))return;let n=parseFloat(t);return Number.isFinite(n)?n:void 0}function l(e,t){let n=e[t]??r()[t];return n===`true`||n!==`false`&&n}function u(e,t){if(!i())return;let r=t.type,a=t.src;if(!r&&n(a)){if(a.charAt(0)===`#`?r=`inline`:a.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i)?r=`image`:a.match(/\.(pdf)((\?|#).*)?$/i)?r=`pdf`:a.match(/\.(html|php)((\?|#).*)?$/i)&&(r=`iframe`),!r){let e=a.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+\.?\d+?)z))|(?:\?ll=))(.*)?/i);e&&(a=`https://maps.google.${e[1]}/?ll=${(e[2]?e[2]+`&z=`+Math.floor(parseFloat(e[3]))+(e[4]?e[4].replace(/^\//,`&`):``):e[4]+``).replace(/\?/,`&`)}&output=${e[4]&&e[4].indexOf(`layer=c`)>0?`svembed`:`embed`}`,r=`gmap`)}if(!r){let e=a.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);e&&(a=`https://maps.google.${e[1]}/maps?q=${e[2].replace(`query=`,`q=`).replace(`api=1`,``)}&output=embed`,r=`gmap`)}r&&(t.src=a,t.type=r)}}function d(e,t){i()&&a(t)&&_(t)}function m(t,n){if(a(n)){let t=n.el;e?.hideError(n),n.contentEl?.remove(),n.contentEl=void 0,n.htmlEl?.remove(),n.htmlEl=void 0,t&&(p(t,`has-html has-iframe has-pdf has-gmap`),p(t,`is-loading`))}}function h(){for(let t of e?.getSlides()||[])a(t)&&(g(t),t.state===1&&v(t))}function g(e){let t=e.htmlEl;if(t&&a(e)&&(t.style.aspectRatio=``,t.style.width=``,t.style.height=``,t.style.maxWidth=``,t.style.maxHeight=``,e.width&&(t.style.maxWidth=o(e.width)),e.height&&(t.style.maxHeight=o(e.height)),e.aspectRatio)){let n=e.aspectRatio.split(`/`),r=parseFloat(n[0].trim()),i=n[1]?parseFloat(n[1].trim()):0,a=r&&i?r/i:r;t.offsetHeight;let o=t.getBoundingClientRect(),s=a<(o.width||1)/(o.height||1);t.style.aspectRatio=`${e.aspectRatio}`,t.style.width=s?`auto`:``,t.style.height=s?``:`auto`}}function _(t){let n=t.el,i=t.src;if(!e||!n||!i)return;let a=document.createElement(`iframe`);f(a,`f-iframe`);for(let[e,t]of Object.entries(r().iframeAttr||{}))a.setAttribute(e,t);a.onerror=()=>{t.state=2,e?.showError(t,`{{IFRAME_ERROR}}`)};let o=document.createElement(`div`);f(o,`f-html`),o.append(a),t.htmlEl=o,t.contentEl=a,f(n,`has-html has-iframe has-${t.type}`),n.prepend(o),g(t);let s=l(t,`preload`),c=l(t,`autosize`);t.type===`iframe`&&(s||c)?(t.state=0,e.showLoading(t),f(n,`is-loading`),a.onload=()=>{if(!e||e.getState()===2||!a.src.length||t.contentEl!==a||!a.isConnected)return;t.state=1;let r=a.dataset.ready!==`true`;a.dataset.ready=`true`,v(t),e.hideLoading(t),r&&e.emit(`contentReady`,t),p(n,`is-loading`)},a.src=`${i}`):(a.src=`${i}`,e.emit(`contentReady`,t))}function v(e){let t=e.contentEl,n=t?.parentElement,r=n?.style,i=l(e,`autosize`),a=s(e.width)||0,o=s(e.height)||0;if(a&&o&&(i=!1),t&&n&&r&&i){try{let e=window.getComputedStyle(n),i=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight),s=parseFloat(e.paddingTop)+parseFloat(e.paddingBottom),c=t.contentWindow;if(c){let e=c.document,t=e.getElementsByTagName(`html`)[0],n=e.body;r.width=``;let l=window.getComputedStyle(n),u=parseFloat(l.marginLeft)+parseFloat(l.marginRight),d=n.style.overflow||``;n.style.overflow=`hidden`,a||=n.scrollWidth+u+i,r.flex=`0 0 auto`,r.width=`${a}px`,r.height=`${n.scrollHeight}px`,n.style.overflow=d,o=Math.max(t.scrollHeight,Math.ceil(t.getBoundingClientRect().height))+s}}catch{}(a||o)&&Object.assign(r,{flex:`0 1 auto`,width:a?`${a}px`:``,height:o?`${o}px`:``})}}return{init:function(t){e=t,e.on(`addSlide`,u),e.on(`attachSlideEl`,d),e.on(`detachSlideEl`,m),e.on(`refresh`,h)},destroy:function(){e?.off(`addSlide`,u),e?.off(`attachSlideEl`,d),e?.off(`detachSlideEl`,m),e?.off(`refresh`,h),e=void 0}}},Be=(e,t={})=>{let n=new URL(e),r=new URLSearchParams(n.search),i=new URLSearchParams;for(let[e,n]of[...r,...Object.entries(t)]){let t=n+``;if(e===`t`){let e=t.match(/((\d*)m)?(\d*)s?/);e&&i.set(`start`,parseInt(e[2]||`0`)*60+parseInt(e[3]||`0`)+``)}else i.set(e,t)}let a=i+``,o=e.match(/#t=((.*)?\d+s)/);return o&&(a+=`#t=${o[1]}`),a},Ve={autoplay:!1,html5videoTpl:`<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">
    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn't support embedded videos.</video>`,iframeAttr:{allow:`autoplay; fullscreen`,scrolling:`no`,referrerPolicy:`strict-origin-when-cross-origin`,credentialless:``},vimeo:{byline:1,color:`00adef`,controls:1,dnt:1,muted:0},youtube:{controls:1,enablejsapi:1,nocookie:1,rel:0,fs:1}},He=()=>{let e,r=!1;function a(){let n=e?.getOptions().Video;return t(n)?{...Ve,...n}:Ve}function o(){return e?.getPage()?.slides[0]}let s=t=>{try{let n=JSON.parse(t.data);if(t.origin===`https://player.vimeo.com`){if(n.event===`ready`)for(let n of Array.from(e?.getContainer()?.getElementsByClassName(`f-iframe`)||[]))n instanceof HTMLIFrameElement&&n.contentWindow===t.source&&(n.dataset.ready=`true`)}else if(t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/)&&n.event===`onReady`){let e=document.getElementById(n.id);e&&(e.dataset.ready=`true`)}}catch{}};function c(){let e=o(),t=e?.el;if(t&&e?.type===`html5video`)try{let e=t.querySelector(`video`);if(e){let t=e.play();t!==void 0&&t.then(()=>{}).catch(t=>{e.muted=!0,e.play()})}}catch{}let n=e?.htmlEl;n instanceof HTMLIFrameElement&&n.contentWindow?.postMessage(`{"event":"command","func":"stopVideo","args":""}`,`*`)}function l(){let e=o(),t=e?.type;if(!e?.el||t!==`youtube`&&t!==`vimeo`)return;let n=()=>{if(e.contentEl&&e.contentEl instanceof HTMLIFrameElement&&e.contentEl.contentWindow){let t;if(e.contentEl.dataset.ready===`true`){t=e.type===`youtube`?{event:`command`,func:`playVideo`}:{method:`play`,value:`true`},t&&e.contentEl.contentWindow.postMessage(JSON.stringify(t),`*`),e.poller=void 0;return}e.type===`youtube`&&(t={event:`listening`,id:e.contentEl.getAttribute(`id`)},e.contentEl.contentWindow.postMessage(JSON.stringify(t),`*`))}e.poller=setTimeout(n,250)};n()}function u(t){let r=t.el,o=t.src;if(!e||!r||!o)return;let s=t.html5videoTpl||a().html5videoTpl,c=t.html5videoFormat||a().html5videoFormat;if(!s)return;let l=t.poster||(t.thumb&&n(t.thumb)?t.thumb:``),u=i(s.replace(/\{\{src\}\}/gi,o+``).replace(/\{\{format\}\}/gi,c||``).replace(/\{\{poster\}\}/gi,l+``));if(!u)return;let d=document.createElement(`div`);f(d,`f-html`),d.append(u),t.contentEl=u,t.htmlEl=d,f(r,`has-${t.type}`),r.prepend(d),v(t),e.emit(`contentReady`,t)}function d(t){let n=t.el,r=t.src;if(!e||!n||!r)return;let i=document.createElement(`iframe`);f(i,`f-iframe`),i.setAttribute(`id`,`f-iframe_${t.videoId}`);for(let[e,t]of Object.entries(a().iframeAttr||{}))i.setAttribute(e,t);t.type===`youtube`&&(i.onload=()=>{e?.getState()===1&&i.contentWindow?.postMessage(JSON.stringify({event:`listening`,id:i.getAttribute(`id`)}),`*`)}),i.onerror=()=>{e?.showError(t,`{{IFRAME_ERROR}}`)};let o=document.createElement(`div`);f(o,`f-html`),o.append(i),t.contentEl=i,t.htmlEl=o,f(n,`has-html has-iframe has-${t.type}`),i.src=`${t.src}`,n.prepend(o),v(t),e.emit(`contentReady`,t)}function p(e,t){let r=t.src;if(!n(r))return;let i=t.type;if(!i||i===`html5video`){let e=r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);e&&(i=`html5video`,t.html5videoFormat=t.html5videoFormat||`video/`+(e[1]===`ogv`?`ogg`:e[1]))}if(!i||i===`youtube`){let e=r.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);if(e){let n={...a().youtube,...t.youtube||{}},o=`www.youtube${n.nocookie?`-nocookie`:``}.com`,s=Be(r,n),c=encodeURIComponent(e[2]);t.videoId=c,t.src=`https://${o}/embed/${c}?${s}`,t.thumb=t.thumb||`https://i.ytimg.com/vi/${c}/mqdefault.jpg`,i=`youtube`}}if(!i||i===`vimeo`){let e=r.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);if(e){let n={...a().vimeo,...t.vimeo||{}},o=Be(r,n),s=encodeURIComponent(e[2]),c=e[5]||``;t.videoId=s,t.src=`https://player.vimeo.com/video/${s}?${c?`h=${c}${o?`&`:``}`:``}${o}`,i=`vimeo`}}t.type=i}function m(e,t){t.type===`html5video`&&u(t),(t.type===`youtube`||t.type===`vimeo`)&&d(t)}function h(e,t){(t.type===`html5video`||t.type===`youtube`||t.type===`vimeo`)&&(t.contentEl?.remove(),t.contentEl=void 0,t.htmlEl?.remove(),t.htmlEl=void 0),t.poller&&clearTimeout(t.poller)}function g(){r=!1}function _(){if(r)return;r=!0;let e=o();(e&&e.autoplay!==void 0?e.autoplay:a().autoplay)&&(c(),l())}function v(e){let t=e?.htmlEl;if(e&&t&&(e.type===`html5video`||e.type===`youtube`||e.type===`vimeo`)){if(t.style.aspectRatio=``,t.style.width=``,t.style.height=``,t.style.maxWidth=``,t.style.maxHeight=``,e.width){let n=`${e.width}`;n.match(/^\d+$/)&&(n+=`px`),t.style.maxWidth=`${n}`}if(e.height){let n=`${e.height}`;n.match(/^\d+$/)&&(n+=`px`),t.style.maxHeight=`${n}`}if(e.aspectRatio){let n=e.aspectRatio.split(`/`),r=parseFloat(n[0].trim()),i=n[1]?parseFloat(n[1].trim()):0,a=r&&i?r/i:r;t.offsetHeight;let o=t.getBoundingClientRect(),s=a<(o.width||1)/(o.height||1);t.style.aspectRatio=`${e.aspectRatio}`,t.style.width=s?`auto`:``,t.style.height=s?``:`auto`}}}function y(){v(o())}return{init:function(t){e=t,e.on(`addSlide`,p),e.on(`attachSlideEl`,m),e.on(`detachSlideEl`,h),e.on(`ready`,_),e.on(`change`,g),e.on(`settle`,_),e.on(`refresh`,y),window.addEventListener(`message`,s)},destroy:function(){e?.off(`addSlide`,p),e?.off(`attachSlideEl`,m),e?.off(`detachSlideEl`,h),e?.off(`ready`,_),e?.off(`change`,g),e?.off(`settle`,_),e?.off(`refresh`,y),window.removeEventListener(`message`,s),e=void 0}}},Ue={autoStart:!1,btnTpl:`<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>`},We=`in-fullscreen-mode`,Ge=()=>{let e;function n(n){let r=e?.getOptions().Fullscreen,i=(t(r)?{...Ue,...r}:Ue)[n];return i&&typeof i==`function`&&e?i(e):i}function r(){e?.getPlugins().Toolbar?.add(`fullscreen`,{tpl:n(`btnTpl`)})}function i(){if(n(`autoStart`)){let e=o();e&&c(e)}}function a(e,t){let n=t.target;n&&!t.defaultPrevented&&n.dataset.fullscreenAction===`toggle`&&u()}function o(){return n(`el`)||e?.getContainer()||void 0}function s(){let e=document;return e.fullscreenEnabled?!!e.fullscreenElement:e.webkitFullscreenEnabled?!!e.webkitFullscreenElement:!1}function c(e){let t=document;e||=t.documentElement;let n;return t.fullscreenEnabled?n=e.requestFullscreen():t.webkitFullscreenEnabled&&(n=e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)),n&&n.then(()=>{e.classList.add(We)}),n}function l(){let e=document,t;return e.fullscreenEnabled?t=e.fullscreenElement&&e.exitFullscreen():e.webkitFullscreenEnabled&&(t=e.webkitFullscreenElement&&e.webkitExitFullscreen()),t&&t.then(()=>{o()?.classList.remove(We)}),t}function u(){if(s())l();else{let e=o();e&&c(e)}}return{init:function(t){e=t,e.on(`initPlugins`,r),e.on(`ready`,i),e.on(`click`,a)},destroy:function(){e?.off(`initPlugins`,r),e?.off(`ready`,i),e?.off(`click`,a)},exit:l,inFullscreen:s,request:c,toggle:u}};function Ke(){if(window.parent===window)return!1;try{var e=window.frameElement}catch{e=null}return e===null?location.protocol===`data:`:e.hasAttribute(`sandbox`)}let qe,Je=!1,Ye=!1,Xe=!1,Ze=!1,Qe,$e=()=>{let e=new URL(document.URL).hash,t=e.slice(1).split(`-`),n=t[t.length-1],r=n&&/^\+?\d+$/.test(n)&&parseInt(t.pop()||`1`,10)||1;return{urlHash:e,urlSlug:t.join(`-`),urlIndex:r}},et=()=>{let e=qe?.getInstance(),t=e?.getState();return!(!e||t!==0&&t!==1)},tt=()=>{if(!qe||et())return;let{urlSlug:e,urlIndex:t}=$e();if(!e)return;let n=document.querySelector(`[data-slug="${e}"]`);n&&qe.fromTriggerEl(n),et()||(n=document.querySelectorAll(`[data-fancybox="${e}"]`)[t-1],n&&qe.fromTriggerEl(n,{startIndex:t-1})),et()&&n&&!n.closest(`[inert]`)&&n.scrollIntoView({behavior:`instant`,block:`center`,inline:`center`})},nt=e=>{let n=e.getOptions().Hash,r=e.getSlide();return r&&(r.slug||r.fancybox||(t(n)?n.slug:``))||``},rt=e=>{let t=nt(e),n=e.getSlide();if(!n||!t)return``;let r=parseInt(n.index+``,10)+1,i=n.slug?`#${n.slug}`:`#${t}-${r}`;return(e.getCarousel()?.getPages()?.length||0)<2&&(i=`#${t}`),i},it=()=>{if(!qe||Xe)return;let e=qe?.getInstance(),n=e?.getCarousel(),{urlSlug:r,urlIndex:i}=$e(),a=e?.getOptions().Hash;if(a!==!1){if(e&&e.getState()===1&&n){let o=n.getSlides();for(let e of o||[])if(e.slug===r||(e.fancybox===r||t(a)&&a.slug===r)&&e.index===i-1){Ye=!1,n.goTo(e.index);return}Ze=!0,e.close(),Ze=!1}tt()}},at=()=>{qe&&(Qe=setTimeout(()=>{Je=!0,tt(),Je=!1},300),window.addEventListener(`hashchange`,it,!1))},ot;function st(){history.scrollRestoration&&ot&&(history.scrollRestoration=ot,ot=void 0)}let ct=()=>{let e,t=``;function n(){if(!e||!e.isTopMost()||e.getOptions().Hash===!1)return;if(Je){let t=e.getOptions().sync;t&&t.goTo(e?.getCarousel()?.getPageIndex()||0,{transition:!1,tween:!1})}let n=e.getCarousel();if(!n||!e.getSlide())return;let i=nt(e);if(!i)return;let{urlHash:a,urlSlug:o}=$e(),s=rt(e);a!==s&&(t=a),history.scrollRestoration&&!ot&&(ot=history.scrollRestoration,history.scrollRestoration=`manual`,window.addEventListener(`beforeunload`,st)),n.on(`change`,r);let c=i!==o;try{window.history[c?`pushState`:`replaceState`]({},document.title,window.location.pathname+window.location.search+s),c&&(Ye=!0)}catch{}}function r(){if(!e||!e.isTopMost()||e.getOptions().Hash===!1||!e.getSlide()||!nt(e))return;let t=rt(e);Xe=!0;try{window.history.replaceState({},document.title,window.location.pathname+window.location.search+t)}catch{}Xe=!1}function i(){if(e&&e.isTopMost()&&e.getOptions().Hash!==!1&&!Ze&&nt(e)){Xe=!0;try{Ye&&!Ke()&&document.activeElement?.nodeName!==`IFRAME`?window.history.back():window.history.replaceState({},document.title,window.location.pathname+window.location.search+t)}catch{}Xe=!1}}return{init:function(t){clearTimeout(Qe),e=t,e.on(`ready`,n),e.on(`close`,i)},destroy:function(){e?.off(`ready`,n),e?.off(`close`,i);let t=e?.getCarousel();t&&t.off(`change`,r),e=void 0,qe?.getInstance()||(st(),window.removeEventListener(`beforeunload`,st))}}};ct.getInfoFromURL=$e,ct.startFromUrl=tt,ct.setup=function(e){qe||(qe=e,l()&&(/complete|interactive|loaded/.test(document.readyState)?at():document.addEventListener(`DOMContentLoaded`,at)))};let Z={...G,CLOSE:`Close`,NEXT:`Next`,PREV:`Previous`,MODAL:`You can close this modal content with the ESC key`,ELEMENT_NOT_FOUND:`HTML Element Not Found`,IFRAME_ERROR:`Error Loading Page`,NO_CAPTION:`No Caption`,TOGGLE_SIDEBAR:`Toggle sidebar`},lt=`<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24"><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>`;Ne().add(`close`,{tpl:lt});let ut=e=>{e.cancelable&&e.preventDefault()},dt=e=>{let t=e.getBoundingClientRect(),n=e.closest(`[style]`),r=n?.parentElement;if(n&&n.style.transform&&r){let e=r.getBoundingClientRect();if(t.left<e.left||t.left>e.left+e.width-t.width||t.top<e.top||t.top>e.top+e.height-t.height)return!1}let i=Math.max(document.documentElement.clientHeight,window.innerHeight),a=Math.max(document.documentElement.clientWidth,window.innerWidth);return!(t.bottom<0||t.top-i>=0||t.right<0||t.left-a>=0)};function ft(e){var t=e.getBoundingClientRect();return t.bottom>0&&t.right>0&&t.left<(window.innerWidth||document.documentElement.clientWidth)&&t.top<(window.innerHeight||document.documentElement.clientHeight)}let pt=(e,t,n,r,i=`contain`)=>{if(i===`contain`||e>n||t>r){let i=n/e,a=r/t,o=Math.min(i,a);e*=o,t*=o}return{width:e,height:t}},mt=(e=null,t=``,n)=>{if(!e||!e.parentElement||!t){n&&n();return}ht(e);let r=i=>{i.target===e&&e.dataset.animationName&&(e.removeEventListener(`animationend`,r),delete e.dataset.animationName,n&&n(),e.classList.remove(t))};e.dataset.animationName=t,e.addEventListener(`animationend`,r),f(e,t)},ht=e=>{e&&e.dispatchEvent(new CustomEvent(`animationend`,{bubbles:!1,cancelable:!0,currentTarget:e}))};var Q;(function(e){e[e.Init=0]=`Init`,e[e.Ready=1]=`Ready`,e[e.Closing=2]=`Closing`,e[e.Destroyed=3]=`Destroyed`})(Q||={});let gt={ajax:null,backdropClick:`close`,Carousel:{},closeButton:`auto`,closeButtonTpl:lt,closeExisting:!1,delegateEl:void 0,dragToClose:!0,fadeEffect:!0,groupAll:!1,groupAttr:`data-fancybox`,hideClass:`f-fadeOut`,hideScrollbar:!0,id:void 0,idle:!1,keyboard:{Escape:`close`,Delete:`close`,Backspace:`close`,PageUp:`next`,PageDown:`prev`,ArrowUp:`prev`,ArrowDown:`next`,ArrowRight:`next`,ArrowLeft:`prev`},l10n:Z,mainClass:``,mainStyle:{},mainTpl:`<dialog class="fancybox__dialog">
    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">
      <div class="fancybox__backdrop"></div>
      <div class="fancybox__carousel"></div>
    </div>
  </dialog>`,modal:!0,on:{},parentEl:void 0,placeFocusBack:!0,showClass:`f-zoomInUp`,startIndex:0,sync:void 0,theme:`dark`,triggerEl:void 0,triggerEvent:void 0,zoomEffect:!0},_t=new Map,vt=0,yt=`with-fancybox`,bt=()=>{let e=Q.Init,a={...gt},l=-1,u={},h=[],g,_,v,y,b,x,S,C=!1,T=!0,E=0,D;function O(e,...t){let n=a[e];return n&&typeof n==`function`?n(Ie,...t):n}function k(e,t=[]){let n=O(`l10n`)||{};e=String(e).replace(/\{\{(\w+)\}\}/g,(e,t)=>n[t]||e);for(let n=0;n<t.length;n++)e=e.split(t[n][0]).join(t[n][1]);return e=e.replace(/\{\{(.*?)\}\}/g,(e,t)=>t),e}let A=new Map;function j(e,...t){let n=[...A.get(e)||[]];for(let[t,r]of Object.entries(a.on||{}))(t===e||t.split(` `).indexOf(e)>-1)&&n.push(r);for(let e of n)e&&typeof e==`function`&&e(Ie,...t);e!==`*`&&j(`*`,e,...t)}function M(t=[],n={}){e!==Q.Init&&(Ie.destroy(),e=Q.Init),a=c({},gt,n),l=O(`id`)||`fancybox-${++vt}`;let r=_t.get(l);if(r&&r.destroy(),_t.set(l,Ie),j(`init`),N(),P(t),F(),I(),g&&_){if(O(`closeExisting`))for(let[e,t]of _t.entries())e!==l&&t.close();O(`fadeEffect`)?(setTimeout(()=>{te()},500),f(_,`is-revealing`)):te(),_.classList.add(`is-ready`),e=Q.Ready,j(`ready`)}}function te(){p(_,`is-revealing`);try{document.activeElement===g&&(_?.querySelector(`[autofocus]`)||_).focus()}catch{}}function N(){for(let[e,t]of Object.entries({...$.Plugins,...a.plugins||{}}))if(e&&!u[e]&&t instanceof Function){let n=t();n.init(Ie),u[e]=n}j(`initPlugins`)}function P(e=[]){j(`initSlides`,e),h=[...e]}function F(){let e=O(`parentEl`)||document.body;if(!(e&&e instanceof HTMLElement))return;let n=k(O(`mainTpl`)||``);if(g=i(n)||void 0,!g||(_=g.querySelector(`.fancybox__container`),!(_&&_ instanceof HTMLElement)))return;let r=O(`mainClass`);r&&f(_,r);let a=O(`mainStyle`);if(a&&t(a))for(let[e,t]of Object.entries(a))_.style.setProperty(e,t);let c=O(`theme`),u=c===`auto`?window.matchMedia(`(prefers-color-scheme:light)`).matches:c===`light`;_.setAttribute(`theme`,u?`light`:`dark`),g.setAttribute(`id`,`${l}`),g.addEventListener(`keydown`,e=>{e.key===`Escape`&&ut(e)}),g.addEventListener(`wheel`,e=>{let t=e.target,n=O(`wheel`,e);t.closest(`.f-thumbs`)&&(n=`slide`);let r=n===`slide`,i=[-e.deltaX||0,-e.deltaY||0,-e.detail||0].reduce(function(e,t){return Math.abs(t)>Math.abs(e)?t:e}),a=Math.max(-1,Math.min(1,i)),s=Date.now();if(E&&s-E<300){r&&ut(e);return}E=s,j(`wheel`,e,a),!e.defaultPrevented&&(n===`close`?Me(e):n===`slide`&&y&&!o(t)&&(ut(e),y[a>0?`prev`:`next`]()))},{capture:!0,passive:!1}),g.addEventListener(`cancel`,e=>{Me(e)}),e.append(g),_t.size===1&&(O(`hideScrollbar`)&&s(!0),document.documentElement.classList.add(yt)),j(`initLayout`),g instanceof HTMLDialogElement&&(O(`modal`)?g.showModal():g.show())}function I(){if(v=g?.querySelector(`.fancybox__carousel`)||void 0,!v)return;v.fancybox=Ie;let e=c({},{Autoplay:{autoStart:!1,pauseOnHover:!1,progressbarParentEl:e=>{let t=e.getContainer();return t?.querySelector(`.f-carousel__toolbar [data-autoplay-action]`)||t}},Fullscreen:{el:_},Toolbar:{absolute:!0,items:{counter:{tpl:`<div class="f-counter"><span data-fancybox-page></span>/<span data-fancybox-pages></span></div>`}},display:{left:[`counter`],right:[`toggleFull`,`autoplay`,`fullscreen`,`thumbs`,`close`]}},Video:{autoplay:!0},Thumbs:{minCount:2,Carousel:{classes:{container:`fancybox__thumbs`}}},classes:{container:`fancybox__carousel`,viewport:`fancybox__viewport`,slide:`fancybox__slide`},spinnerTpl:`<div class="f-spinner" data-fancybox-close></div>`,dragFree:!1,slidesPerPage:1,plugins:{Sync:xe,Arrows:De,Lazyload:Te,Zoomable:be,Html:ze,Video:He,Autoplay:Fe,Fullscreen:Ge,Thumbs:Le,Toolbar:Ne}},O(`Carousel`)||{},{slides:h,enabled:!0,initialPage:O(`startIndex`)||0,l10n:O(`l10n`)});y=_e(v,e),j(`initCarousel`,y),y.on(`*`,(e,t,...n)=>{j(`Carousel.${t}`,e,...n)}),y.on(`attachSlideEl`,L),y.on(`detachSlideEl`,R),y.on(`contentLoading`,ie),y.on(`contentReady`,ae),y.on(`ready`,U),y.on(`change`,V),y.on(`settle`,re),y.on(`thumbs:ready`,W),y.on(`thumbs:destroy`,W),y.init()}function L(e,t){he(t),se(),t.el?.addEventListener(`click`,z),(t.type===`inline`||t.type===`clone`)&&q(t),t.type===`ajax`&&we(t)}function R(e,t){ge(t),t.el?.removeEventListener(`click`,z),(t.type===`inline`||t.type===`clone`)&&Ee(t),t.xhr&&=(t.xhr.abort(),void 0)}function z(t){if(!ye())return;if(e!==Q.Ready){ut(t),t.stopPropagation();return}if(t.defaultPrevented||!ne.isClickAllowed())return;let n=t.composedPath()[0];n.closest(`.fancybox__carousel`)&&n.classList.contains(`fancybox__slide`)&&le(t)}function V(){T=!1,_&&y&&_.classList.remove(`is-revealing`),se();let e=O(`sync`);if(y&&e){let t=e.getPageIndex(y.getPageIndex())||0;e.goTo(t,{transition:!1,tween:!1})}}function U(){me(),oe(),se(),J();let e=O(`sync`);y&&e&&e.getTween()?.start(),ve(K())}function re(){y?.canGoNext()?J():Ae()}function ie(e,t){he(t)}function ae(e,t){he(t),ve(t)}function W(){let e=y?.getPlugins().Thumbs;m(_,`has-thumbs`,e?.isEnabled()||!1),m(_,`has-vertical-thumbs`,e?e.getType()===`scrollable`||e.getCarousel()?.isVertical()===!0:!1)}function oe(){document.body.addEventListener(`click`,fe),document.body.addEventListener(`pointerdown`,ce,{capture:!0}),document.body.addEventListener(`keydown`,de,{passive:!1,capture:!0})}function se(){if(!_)return;let e=y?.getPages().length||0,t=y?.getPageIndex()||0,n=_.querySelectorAll(`[data-fancybox-index],[data-fancybox-page],[data-fancybox-pages]`);for(let r of n)r.textContent=r.hasAttribute(`data-fancybox-index`)?String(t):r.hasAttribute(`data-fancybox-page`)?String(t+1):String(e)}function ce(e){pe(),D={x:e.clientX,y:e.clientY}}function G(e){if(!D)return!1;let t=`clientX`in e?e:e.changedTouches[0];return t?Math.abs(t.clientX-D.x)>10||Math.abs(t.clientY-D.y)>10:!1}function le(e){if(e.composedPath()[0].closest(`[data-fancybox-close]`)){Me(e);return}G(e)||(j(`backdropClick`,e),!e.defaultPrevented&&O(`backdropClick`)&&Me(e))}function ue(){ke()}function de(t){if(!ye()||e!==Q.Ready)return;let n=t.key,i=O(`keyboard`);if(!i||t.ctrlKey||t.altKey||t.shiftKey)return;let a=t.composedPath()[0];if(!r(a)||n!==`Escape`&&(e=>{let t=[`input`,`textarea`,`select`,`option`,`video`,`iframe`,`[contenteditable]`,`[data-selectable]`,`[data-draggable]`].join(`,`);return e.matches(t)||e.closest(t)})(a)||(j(`keydown`,t),t.defaultPrevented))return;let o=i[n];if(o)switch(o){case`close`:Me(t);break;case`next`:ut(t),y?.next();break;case`prev`:ut(t),y?.prev()}}function fe(t){if(!ye()||e!==Q.Ready||(ke(),t.defaultPrevented))return;let n=t.composedPath()[0],r=!!n.closest(`[data-fancybox-close]`),i=n.classList.contains(`fancybox__backdrop`);(r||i)&&le(t)}function pe(){b&&(O(`dragToClose`)?b.enable():b.disable())}function me(){let t=y?.getViewport();if(!y||!t||(b=ne(t).init(),!b))return;pe();let n=!1,r=0,i=0,a={},s=1;function c(){x?.spring({clamp:!0,mass:1,tension:i===0?140:960,friction:17,restDelta:.1,restSpeed:.1,maxSpeed:1/0}).from({y:r}).to({y:i}).start();let e=y?.getViewport()?.getBoundingClientRect().height||0,t=K()?.panzoomRef;if(e&&t){if(i===0)t.execute(B.Reset);else{let n=d(Math.abs(r),0,e*.33,s,s*.77,!1);t.execute(B.ZoomTo,{scale:n})}}}let l=e=>{let t=e.srcEvent,n=t.target;return O(`dragToClose`)&&y&&!(w(t)&&t.touches?.length>1)&&n&&!o(n)};x=ee().on(`step`,n=>{if(_&&t&&e===Q.Ready){let e=t.getBoundingClientRect().height;r=Math.min(e,Math.max(e*-1,n.y));let i=d(Math.abs(r),0,e*.65,1,.2,!0);_.style.setProperty(`--f-drag-opacity`,i+``),_.style.setProperty(`--f-drag-offset`,r+`px`)}}),b.on(`start`,function(){n||(x?.pause(),i=r)}).on(`panstart`,e=>{if(!n&&l(e)&&e.axis===`y`){ut(e.srcEvent),n=!0,je(),y?.getViewport()?.classList.add(`is-dragging`);let t=K()?.panzoomRef;if(t){s=t.getTransform().scale||1;let e=t.getOptions();a={...e},e.bounds=!1,e.gestures=!1}}else n=!1}).on(`pan`,function(e){n&&l(e)&&(ut(e.srcEvent),e.srcEvent.stopPropagation(),e.axis===`y`&&(i+=e.deltaY,c()))}).on(`end`,t=>{if(y?.getViewport()?.classList.remove(`is-dragging`),n){let e=K()?.panzoomRef;if(e){e.getTween()?.end();let t=e.getOptions();t.bounds=a.bounds||!1,t.gestures=a.gestures||!1}l(t)&&t.axis===`y`&&(Math.abs(t.velocityY)>5||Math.abs(r)>50)&&Me(t.srcEvent,`f-throwOut`+(t.velocityY>0?`Down`:`Up`))}n=!1,e===Q.Ready&&r!==0&&(i=0,c())})}function he(e){let{el:t,htmlEl:n,panzoomRef:r,closeButtonEl:a}=e,o=r?r.getWrapper():n;if(!t||!t.parentElement||!o)return;let s=O(`closeButton`);if(s===`auto`&&(s=y?.getPlugins().Toolbar?.isEnabled()!==!0),!s){ge(e);return}if(!a){let n=i(k(O(`closeButtonTpl`)));n&&(f(n,`is-close-button`),e.closeButtonEl=o.insertAdjacentElement(`afterbegin`,n),f(t,`has-close-btn`))}}function ge(e){e.closeButtonEl&&=(e.closeButtonEl.remove(),void 0),p(e.el,`has-close-btn`)}function ve(e){if(!(T&&y&&y.getState()===1&&e&&e.index===y.getOptions().initialPage&&e.el&&e.el.parentElement)||e.state!==void 0&&e.state!==1)return;T=!1;let t=e.panzoomRef,n=t?.getTween(),r=O(`zoomEffect`)&&n?Ce(e):void 0;if(t&&n&&r){let{x:e,y:i,scale:a}=t.getStartPosition();n.spring({tension:215,friction:25,restDelta:.001,restSpeed:.001,maxSpeed:1/0}).from(r).to({x:e,y:i,scale:a}).start();return}let i=t?.getContent()||e.htmlEl;i&&mt(i,O(`showClass`,e))}function ye(){return $.getInstance()?.getId()===l}function K(){return y?.getPage()?.slides[0]}function Se(){let e=K();return e?e.triggerEl||O(`triggerEl`):void 0}function Ce(e){let t=e.thumbEl;if(!t||!dt(t))return;let n=e.panzoomRef?.getWrapper()?.getBoundingClientRect(),r=n?.width,i=n?.height;if(!r||!i)return;let a=t.getBoundingClientRect(),o=a.width,s=a.height,c=a.left,l=a.top;if(a&&o&&s){if(t instanceof HTMLImageElement){let e=window.getComputedStyle(t).getPropertyValue(`object-fit`);if(e===`contain`||e===`scale-down`){let{width:n,height:r}=pt(t.naturalWidth,t.naturalHeight,o,s,e);c+=(o-n)*.5,l+=(s-r)*.5,o=n,s=r}}if(!(Math.abs(r/i-o/s)>.1))return{x:c+o*.5-(n.left+r*.5),y:l+s*.5-(n.top+i*.5),scale:o/r}}}function q(e){if(!y||!e||!e.el)return;let t=null;if(n(e.src)){let n=e.src.split(`#`,2).pop();t=n?document.getElementById(n):null}if(t){if(f(t,`f-html`),e.type===`clone`||t.closest(`.fancybox__carousel`)){t=t.cloneNode(!0);let n=t.dataset.animationName;n&&(t.classList.remove(n),delete t.dataset.animationName);let r=t.getAttribute(`id`);r=r?`${r}--clone`:`clone-${l}-${e.index}`,t.setAttribute(`id`,r)}else if(t.parentNode){let n=document.createElement(`div`);n.inert=!0,t.parentNode.insertBefore(n,t),e.placeholderEl=n}e.htmlEl=t,f(e.el,`has-html`),e.el.prepend(t),t.classList.remove(`hidden`),t.style.display===`none`&&(t.style.display=``),getComputedStyle(t).getPropertyValue(`display`)===`none`&&(t.style.display=t.dataset.display||`flex`),y?.emit(`contentReady`,e)}else y?.showError(e,`{{ELEMENT_NOT_FOUND}}`)}function we(t){let n=t.el;if(!n||t.htmlEl||t.xhr)return;y?.showLoading(t),t.state=0;let r=new XMLHttpRequest;r.onreadystatechange=function(){if(r.readyState===XMLHttpRequest.DONE&&e===Q.Ready){if(y?.hideLoading(t),t.state=1,r.status===200){let e=r.responseText+``,i=null,a=null;if(t.filter){let n=document.createElement(`div`);n.innerHTML=e,a=n.querySelector(t.filter+``)}a&&a instanceof HTMLElement?i=a:(i=document.createElement(`div`),i.innerHTML=e),i.classList.add(`f-html`),t.htmlEl=i,n.classList.add(`has-html`),n.classList.add(`has-ajax`),n.prepend(i),y?.emit(`contentReady`,t)}else y?.showError(t)}};let i=O(`ajax`)||null;r.open(i?`POST`:`GET`,t.src+``),r.setRequestHeader(`Content-Type`,`application/x-www-form-urlencoded`),r.setRequestHeader(`X-Requested-With`,`XMLHttpRequest`),r.send(i),t.xhr=r}function Ee(e){let t=e.htmlEl,n=e.placeholderEl;t&&(getComputedStyle(t).getPropertyValue(`display`)!==`none`&&(t.style.display=`none`),t.offsetHeight),n&&(t&&n.parentNode&&n.parentNode.insertBefore(t,n),n.remove()),e.htmlEl=void 0,e.placeholderEl=void 0}function Oe(){S&&clearTimeout(S),S=void 0,document.removeEventListener(`mousemove`,ue)}function J(){if(C||S)return;let e=O(`idle`);e&&(S=setTimeout(Y,e))}function Y(){_&&(Oe(),f(_,`is-idle`),document.addEventListener(`mousemove`,ue),C=!0)}function ke(){C&&(Ae(),J())}function Ae(){Oe(),_?.classList.remove(`is-idle`),C=!1}function je(){let e=Se();e&&!ft(e)&&!e.closest(`[inert]`)&&e.scrollIntoView({behavior:`instant`,block:`center`,inline:`center`})}function Me(t,n){if(e===Q.Closing||e===Q.Destroyed)return;let r=new Event(`shouldClose`,{bubbles:!0,cancelable:!0});if(j(`shouldClose`,r,t),r.defaultPrevented)return;if(Oe(),t){if(t.defaultPrevented)return;ut(t),t.stopPropagation(),t.stopImmediatePropagation()}if(e=Q.Closing,x?.pause(),b?.destroy(),y){y.getGestures()?.destroy(),y.getTween()?.pause();for(let e of y.getSlides()){let t=e.panzoomRef;t&&(c(t.getOptions(),{clickAction:!1,dblClickAction:!1,wheelAction:!1,bounds:!1,minScale:0,maxScale:1/0}),t.getGestures()?.destroy(),t.getTween()?.pause())}}let i=y?.getPlugins();i?.Autoplay?.stop();let a=i?.Fullscreen;a&&a.inFullscreen()?Promise.resolve(a.exit()).then(()=>{setTimeout(()=>{Pe(t,n)},150)}):Pe(t,n)}function Pe(t,n){if(e!==Q.Closing)return;j(`close`,t),T=!1,document.body.removeEventListener(`click`,fe),document.body.removeEventListener(`pointerdown`,ce,{capture:!0}),document.body.removeEventListener(`keydown`,de,{passive:!1,capture:!0}),D=void 0,O(`placeFocusBack`)&&je();let r=document.activeElement;r&&g?.contains(r)&&r.blur(),O(`fadeEffect`)&&(_?.classList.remove(`is-ready`),_?.classList.add(`is-hiding`)),_?.classList.add(`is-closing`);let i=K(),a=i?.el,o=i?.panzoomRef,s=i?.panzoomRef?.getTween(),c=n||O(`hideClass`),l=!1,u=!1;if(y&&i&&a&&o&&s){let e;if(O(`zoomEffect`)&&i.state===1&&(e=Ce(i)),e){l=!0;let t=()=>{e=Ce(i),e?s.to({...H,...e}):X()};o.on(`refresh`,()=>{t()}),s.easing(ee.Easings.EaseOut).duration(350).from({...o.getTransform()}).to({...H,...e}).start(),a?.getAnimations()&&(a.style.animationPlayState=`paused`,requestAnimationFrame(()=>{t()}))}}let d=i?.htmlEl||i?.panzoomRef?.getWrapper();d&&ht(d),!l&&c&&d&&(u=!0,mt(d,c,()=>{X()})),l||u?setTimeout(()=>{X()},350):X()}function X(){if(e===Q.Destroyed)return;e=Q.Destroyed;let t=Se();j(`destroy`),O(`sync`)?.getPlugins().Autoplay?.resume(),O(`sync`)?.getPlugins().Autoscroll?.resume(),g instanceof HTMLDialogElement&&g.close(),y?.getContainer()?.classList.remove(`is-idle`),y?.destroy();for(let e of Object.values(u))e?.destroy();if(u={},g?.remove(),g=void 0,_=void 0,y=void 0,_t.delete(l),!_t.size&&(s(!1),document.documentElement.classList.remove(yt),O(`placeFocusBack`)&&t&&!t.closest(`[inert]`)))try{t?.focus({preventScroll:!0})}catch{}}let Ie={close:Me,destroy:X,getCarousel:function(){return y},getContainer:function(){return _},getId:function(){return l},getOptions:function(){return a},getPlugins:function(){return u},getSlide:function(){return K()},getState:function(){return e},init:M,isCurrentSlide:function(e){let t=K();return!e||!t?!1:t.index===e.index},isTopMost:function(){return ye()},localize:k,off:function(e,t){return A.has(e)&&A.set(e,A.get(e).filter(e=>e!==t)),Ie},on:function(e,t){return A.set(e,[...A.get(e)||[],t]),Ie},toggleIdle(e){(C||e===!0)&&Y(),(!C||e===!1)&&Ae()}};return Ie};function xt(){for(let e of Object.values($.Plugins)){let t=e.setup;typeof t==`function`&&t($)}}function St(e,t,n,r={}){if(!(e&&e instanceof Element)||!n)return;let i=$.openers.get(e)||new Map,a=i.get(t)||new Map;a.set(n,r),i.set(t,a),$.openers.set(e,i),i.size===1&&e.addEventListener(`click`,$.fromEvent),xt()}function Ct(e,t,n){if(!(e&&e instanceof Element)||!n)return;let r=$.openers.get(e)||new Map,i=r.get(t)||new Map;i&&n&&i.delete(n),(!i.size||!n)&&r.delete(t),r.size||($.openers.delete(e),e.removeEventListener(`click`,$.fromEvent))}function wt(e,t,r,i){if(!l())return;let a=document.body,o=null,s=`[data-fancybox]`,c={};e instanceof Element&&(a=e),n(e)&&n(t)?(o=e,s=t):n(t)&&n(r)?(o=t,s=r):n(t)?s=t:n(e)&&(s=e),typeof t==`object`&&(c=t||{}),typeof r==`object`&&(c=r||{}),typeof i==`object`&&(c=i||{}),St(a,o,s,c)}function Tt(e,t,r){if(!l())return;let i=document.body,a=null,o=`[data-fancybox]`;e instanceof Element&&(i=e),n(e)&&n(t)?(a=e,o=t):n(t)&&n(r)?(a=t,o=r):n(t)?o=t:n(e)&&(o=e),Ct(i,a,o)}function Et(e,t,r,i){if(!l())return;let a=document.body,o=null,s=`[data-fancybox]`,c={};e instanceof Element&&(a=e),n(e)&&n(t)?(o=e,s=t):n(t)&&n(r)?(o=t,s=r):n(t)?s=t:n(e)&&(s=e),typeof t==`object`&&(c=t||{}),typeof r==`object`&&(c=r||{}),typeof i==`object`&&(c=i||{});for(let[e,t]of $.openers)for(let[n,r]of t)for(let[t,i]of r)if(e===a&&n===o){let e=a.querySelector((n?`${n} `:``)+s);if(e&&e.matches(t))return $.fromTriggerEl(e,c)}}function Dt(e){if(e.defaultPrevented||e.button&&e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey)return;let t=e.composedPath()[0],n={triggerEvent:e};if(t.closest(`.fancybox__container.is-hiding`)){ut(e),e.stopPropagation();return}let r=t.closest(`[data-fancybox-delegate]`)||void 0;if(r){let e=r.dataset.fancyboxDelegate||``,i=document.querySelectorAll(`[data-fancybox="${e}"]`),a=parseInt(r.dataset.fancyboxIndex||``,10)||0;t=i[a]||i[0],c(n,{delegateEl:r,startIndex:a})}return Ot(t,n)}function Ot(e,t={}){if(!(e&&e instanceof Element))return;let n,r,i,a,o={};for(let[t,s]of $.openers)if(t.contains(e))for(let[l,u]of s){let s;if(l){for(let n of t.querySelectorAll(l))if(n.contains(e)){s=n;break}if(!s)continue}for(let[l,d]of u){let u=null;try{u=e.closest(l)}catch{}u&&(r=t,i=s,n=u,a=l,c(o,d||{}))}}if(!r||!a||!n)return;let s=c({},gt,t,o,{triggerEl:n}),l=[].slice.call((i||r).querySelectorAll(a)),u=n.closest(`.f-carousel`),d=u?.carousel;if(d&&!(i&&u.contains(i))){let e=[];for(let t of d?.getSlides()){let n=t.el;n&&(n.matches(a)?e.push(n):e.push(...[].slice.call(n.querySelectorAll(a))))}e.length&&(l=[...e],d.getPlugins().Autoplay?.pause(),d.getPlugins().Autoscroll?.pause(),s.sync=d)}if(s.groupAll===!1){let e=s.groupAttr,t=e&&n?n.getAttribute(`${e}`):``;l=e&&t&&t!==`true`?l.filter(n=>n.getAttribute(`${e}`)===t):[n]}if(!l.length)return;s.triggerEvent?.preventDefault();let f=$.getInstance(),p=f?.getState();if(f&&(p===Q.Init||p===Q.Ready)){let e=f.getOptions().triggerEl;if(e&&l.indexOf(e)>-1)return}return{...s.Carousel||{}}.rtl&&(l=l.reverse()),n&&t.startIndex===void 0&&(s.startIndex=l.indexOf(n)),$.fromNodes(l,s)}function kt(e,t){t=c({},gt,t||{});let n=[],r=e=>e instanceof HTMLImageElement?e:e instanceof HTMLElement?e.querySelector(`img:not([aria-hidden])`):void 0;for(let i of e){let a=i.dataset||{},o=t.delegateEl&&e.indexOf(i)===t.startIndex?t.delegateEl:void 0,s=r(i),c=r(o)||s||void 0,l=a.src||i.getAttribute(`href`)||i.getAttribute(`currentSrc`)||i.getAttribute(`src`)||void 0,u=a.thumb||a.thumbSrc||c?.getAttribute(`currentSrc`)||c?.getAttribute(`src`)||c?.dataset.lazySrc||void 0,d={src:l,alt:a.alt||s?.getAttribute(`alt`)||c?.getAttribute(`alt`)||void 0,thumbSrc:u,thumbEl:c,triggerEl:i,delegateEl:o};for(let e in a){let t=a[e]+``;d[e]=t===`true`?e!==`fancybox`||``:t!==`false`&&t}n.push(d)}return $.show(n,t)}let $={Plugins:{Hash:ct},version:`6.1.15`,openers:new Map,bind:wt,close:function(e=!0,...t){if(e)for(let e of _t.values())e.close(...t);else{let e=$.getInstance();e&&e.close(...t)}},destroy:function(){let e;for(;e=$.getInstance();)e.destroy();for(let e of $.openers.keys())e.removeEventListener(`click`,$.fromEvent);$.openers.clear()},fromEvent:Dt,fromNodes:kt,fromSelector:Et,fromTriggerEl:Ot,getCarousel:function(){return $.getInstance()?.getCarousel()||void 0},getDefaults:function(){return gt},getInstance:function(e){if(e){let t=_t.get(e);return t&&t.getState()!==Q.Destroyed?t:void 0}return Array.from(_t.values()).reverse().find(e=>{if(e.getState()!==Q.Destroyed)return e})||void 0},getSlide:function(){return $.getInstance()?.getSlide()||void 0},show:function(e=[],t={}){return xt(),bt().init(e,t)},unbind:Tt};e.Arrows=De,e.Autoplay=Fe,e.Carousel=_e,Object.defineProperty(e,"CarouselSlideContentState",{enumerable:!0,get:function(){return ue}}),Object.defineProperty(e,"CarouselState",{enumerable:!0,get:function(){return le}}),e.Fancybox=$,Object.defineProperty(e,"FancyboxState",{enumerable:!0,get:function(){return Q}}),e.Fullscreen=Ge,e.Html=ze,e.Lazyload=Te,e.PANZOOM_DEFAULT_POS=H,e.Panzoom=se,Object.defineProperty(e,"PanzoomAction",{enumerable:!0,get:function(){return B}}),Object.defineProperty(e,"PanzoomState",{enumerable:!0,get:function(){return U}}),Object.defineProperty(e,"PanzoomZoomLevel",{enumerable:!0,get:function(){return V}}),e.Sync=xe,e.Thumbs=Le,e.Toolbar=Ne,Object.defineProperty(e,"ToolbarColumn",{enumerable:!0,get:function(){return Ae}}),e.Video=He,e.Zoomable=be});


jQuery(document).ready(function () {
  $('.j-toggle-nav').on('click', function (e) {
    e.preventDefault();
    $('html').toggleClass('open-nav');
  });
  $('.js-btn-filters-toggler').on('click', function () {
    $(this).closest('.js-filters-wrap').find('.js-filters-content').slideToggle(250);
  });
  Fancybox.bind('[data-fancybox]', {
    groupAll: false
  });
  function initMobileSubMenu() {
    var $menuItems = $('.main-menu .menu-item-has-children > a');
    var $subMenus = $('.main-menu .sub-menu');
    if ($(window).width() < 1200) {
      $menuItems.removeClass('active');
      $subMenus.stop(true).slideUp('fast');
      $menuItems.off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);
        var $submenu = $this.closest('.menu-item').find('.sub-menu').first();
        $this.toggleClass('active');
        $submenu.stop(true).slideToggle('slow');
      });
    } else {
      $menuItems.removeClass('active');
      $subMenus.stop(true).slideDown('fast');
      $menuItems.off('click');
    }
  }
  initMobileSubMenu();
  $(window).resize(function () {
    initMobileSubMenu();
  });
  function setVH() {
    document.documentElement.style.setProperty('--vh', "".concat(window.innerHeight * 0.01, "px"));
  }
  setVH();
  window.addEventListener('resize', setVH);

  if ($('.reveal').length) {
    var fades = document.querySelectorAll('.fade-in');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('show');
      });
    }, {
      threshold: 0.1
    });
    fades.forEach(function (el) {
      return observer.observe(el);
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('show');
          obs.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.18
    });
    document.querySelectorAll('.reveal').forEach(function (el) {
      return obs.observe(el);
    });
  }
  function flashBrochure() {
    var lead = document.querySelector('#lead');
    if (!lead) return;

    var overlay = document.createElement('div');
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.zIndex = '5';
    overlay.style.backgroundColor = '#000';
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.6s ease';
    overlay.style.pointerEvents = 'none';

    lead.style.position = 'relative';
    lead.appendChild(overlay);

    requestAnimationFrame(function () {
      overlay.style.opacity = '0.2';
      lead.querySelectorAll('*').forEach(function (el) {
        return el.style.color = '#ffff';
      });
    });

    setTimeout(function () {
      overlay.style.opacity = '0.2';
      lead.querySelectorAll('*').forEach(function (el) {
        return el.style.color = '';
      });
    }, 800);

    setTimeout(function () {
      return overlay.remove();
    }, 1400);
  }
  ['heroBrochure', 'stickyGetBrochure', 'scrollToBrochure'].forEach(function (id) {
    var btn = document.getElementById(id);
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector('#lead');
      if (!target) return;

      var rect = target.getBoundingClientRect();
      var targetTop = rect.top + window.scrollY;
      var scrollTo = targetTop - window.innerHeight / 2 + rect.height / 2;
      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });

      setTimeout(flashBrochure, 800);
    });
  });
  if ($('#sticky-cta').length) {
    var stickyBar = document.getElementById('sticky-cta');
    window.addEventListener('scroll', function () {
      var trigger = window.scrollY > window.innerHeight * 0.5;
      stickyBar.classList.toggle('hidden', !trigger);
    });
  }
  if ($('#callModal').length) {
    var callModal = document.getElementById('callModal');
    var closeModal = document.getElementById('closeModal');
    ['callButtonHero', 'callButtonSticky'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', function () {
        callModal.classList.remove('hidden');
        callModal.classList.add('flex');
        document.body.classList.add('overflow-y-hidden');
      });
    });
    if (closeModal) {
      closeModal.addEventListener('click', function () {
        callModal.classList.add('hidden');
        callModal.classList.remove('flex');
        document.body.classList.remove('overflow-y-hidden');
      });
    }
    callModal.addEventListener('click', function (e) {
      if (e.target === callModal) closeModal.click();
    });
  }
  function setVH() {
    document.documentElement.style.setProperty('--vh', "".concat(window.innerHeight * 0.01, "px"));
  }
  setVH();
  window.addEventListener('resize', setVH);
  $('.js-gallery-carousel').each(function () {
    var $carousel = $(this);
    var $nav = $carousel.next('.gallery-nav');
    $carousel.slick({
      slidesToShow: 1,
      infinite: true,
      variableWidth: true,
      nextArrow: '<div class="next cursor-pointer hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[50px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      prevArrow: '<div class="prev cursor-pointer transform rotate-180 hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[50px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      appendArrows: $nav
    });
  });
  $('.js-testimonials-carousel').slick({
    slidesToShow: 3,
    nextArrow: '<div class="next cursor-pointer hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[50px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#fff" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#fff"></polyline><line stroke="#fff" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
    prevArrow: '<div class="prev cursor-pointer transform rotate-180 hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[50px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#fff" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#fff"></polyline><line stroke="#fff" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
    appendArrows: '.testimonials-nav',
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $('.js-caravans-carousel').each(function () {
    var $carousel = $(this);
    var $nav = $carousel.next('.caravans-nav');
    $carousel.slick({
      slidesToShow: 4,
      nextArrow: '<div class="next cursor-pointer hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[50px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      prevArrow: '<div class="prev cursor-pointer transform rotate-180 hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[50px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      appendArrows: $nav,
      responsive: [{
        breakpoint: 1199,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  });
  $('.js-highlights-slider').each(function () {
    var $carousel = $(this);
    var $thumbnails = $(this).closest('.highlights-slider-holder').find('.js-highlights-thumbnails-slider');
    var $nav = $carousel.next('.highlights-nav');
    $carousel.slick({
      infinite: false,
      nextArrow: '<div class="next cursor-pointer hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] md:w-[40px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      prevArrow: '<div class="prev cursor-pointer transform rotate-180 hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] md:w-[40px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      appendArrows: $nav,
      lazyLoad: 'ondemand',
      asNavFor: $thumbnails
    });
    $thumbnails.slick({
      infinite: false,
      slidesToShow: 3,
      arrows: false,
      slidesToScroll: 1,
      asNavFor: $carousel,
      focusOnSelect: true
    });
  });
  $('.js-plan-carousel').each(function () {
    var $carousel = $(this);
    var $thumbnails = $(this).closest('.plan-slider-holder').find('.js-plan-thumbnails-slider');
    var $nav = $carousel.next('.plan-nav');
    $carousel.slick({
      infinite: false,
      nextArrow: '<div class="next cursor-pointer hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] md:w-[40px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      prevArrow: '<div class="prev cursor-pointer transform rotate-180 hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] md:w-[40px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      appendArrows: $nav,
      lazyLoad: 'ondemand',
      asNavFor: $thumbnails
    });
    $thumbnails.slick({
      infinite: false,
      slidesToShow: 7,
      arrows: false,
      slidesToScroll: 1,
      asNavFor: $carousel,
      focusOnSelect: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }]
    });
  });
  $('.js-model-carousel').each(function () {
    var $carousel = $(this);
    var $thumbnails = $(this).closest('.model-slider-holder').find('.js-model-thumbnails-slider');
    var $nav = $carousel.next('.model-nav');
    $carousel.slick({
      infinite: true,
      nextArrow: '<div class="next cursor-pointer hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] md:w-[40px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      prevArrow: '<div class="prev cursor-pointer transform rotate-180 hover:opacity-70"><svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] md:w-[40px]"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle stroke="#171717" cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8" stroke="#171717"></polyline><line stroke="#171717" x1="8" y1="12" x2="16" y2="12"></line></svg></div>',
      appendArrows: $nav,
      lazyLoad: 'ondemand',
      asNavFor: $thumbnails
    });
    $thumbnails.slick({
      infinite: true,
      slidesToShow: 4,
      arrows: false,
      asNavFor: $carousel,
      focusOnSelect: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }]
    });
  });
  $('.js-show-more-text').on('click', function () {
    $(this).closest('.read-more-text-holder').addClass('active');
  });
  $('.js-show-less-text').on('click', function () {
    $(this).closest('.read-more-text-holder').removeClass('active');
  });
});

;
(function (factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    module.exports = function (root, jQuery) {
      if (jQuery === undefined) {
        if (typeof window !== 'undefined') {
          jQuery = require('jquery');
        } else {
          jQuery = require('jquery')(root);
        }
      }
      factory(jQuery);
      return jQuery;
    };
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var Slick = window.Slick || {};
  Slick = function () {
    var instanceUid = 0;
    function Slick(element, settings) {
      var _ = this,
        dataSettings;
      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(slider, i) {
          return $('<button type="button"></button>').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        focusOnChange: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: false,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        swiping: false,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;
      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++;

      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
      _.registerBreakpoints();
      _.init(true);
    }
    return Slick;
  }();
  Slick.prototype.activateADA = function () {
    var _ = this;
    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false',
      'tabindex': '0'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });
  };
  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
    var _ = this;
    if (typeof index === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || index >= _.slideCount) {
      return false;
    }
    _.unload();
    if (typeof index === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.animateHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };
  Slick.prototype.animateSlide = function (targetLeft, callback) {
    var animProps = {},
      _ = this;
    _.animateHeight();
    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -_.currentLeft;
        }
        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function step(now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function complete() {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);
        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);
        if (callback) {
          setTimeout(function () {
            _.disableTransition();
            callback.call();
          }, _.options.speed);
        }
      }
    }
  };
  Slick.prototype.getNavTarget = function () {
    var _ = this,
      asNavFor = _.options.asNavFor;
    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }
    return asNavFor;
  };
  Slick.prototype.asNavFor = function (index) {
    var _ = this,
      asNavFor = _.getNavTarget();
    if (asNavFor !== null && _typeof(asNavFor) === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };
  Slick.prototype.applyTransition = function (slide) {
    var _ = this,
      transition = {};
    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.autoPlay = function () {
    var _ = this;
    _.autoPlayClear();
    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };
  Slick.prototype.autoPlayClear = function () {
    var _ = this;
    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };
  Slick.prototype.autoPlayIterator = function () {
    var _ = this,
      slideTo = _.currentSlide + _.options.slidesToScroll;
    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;
          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }
      _.slideHandler(slideTo);
    }
  };
  Slick.prototype.buildArrows = function () {
    var _ = this;
    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }
        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };
  Slick.prototype.buildDots = function () {
    var _ = this,
      i,
      dot;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');
      dot = $('<ul></ul>').addClass(_.options.dotsClass);
      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li></li>').append(_.options.customPaging.call(this, _, i)));
      }
      _.$dots = dot.appendTo(_.options.appendDots);
      _.$dots.find('li').first().addClass('slick-active');
    }
  };
  Slick.prototype.buildOut = function () {
    var _ = this;
    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });
    _.$slider.addClass('slick-slider');
    _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"></div>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"></div>').parent();
    _.$list = _.$slideTrack.wrap('<div class="slick-list"></div>').parent();
    _.$slideTrack.css('opacity', 0);
    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }
    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
    _.setupInfinite();
    _.buildArrows();
    _.buildDots();
    _.updateDots();
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };
  Slick.prototype.buildRows = function () {
    var _ = this,
      a,
      b,
      c,
      newSlides,
      numOfSlides,
      originalSlides,
      slidesPerSection;
    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();
    if (_.options.rows > 0) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('div');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }
      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children().css({
        'width': 100 / _.options.slidesPerRow + '%',
        'display': 'inline-block'
      });
    }
  };
  Slick.prototype.checkResponsive = function (initial, forceUpdate) {
    var _ = this,
      breakpoint,
      targetBreakpoint,
      respondToWidth,
      triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();
    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }
    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;
      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }
      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }

      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };
  Slick.prototype.changeSlide = function (event, dontAnimate) {
    var _ = this,
      $target = $(event.currentTarget),
      indexOffset,
      slideOffset,
      unevenOffset;

    if ($target.is('a')) {
      event.preventDefault();
    }

    if (!$target.is('li')) {
      $target = $target.closest('li');
    }
    unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;
      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;
      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;
      default:
        return;
    }
  };
  Slick.prototype.checkNavigable = function (index) {
    var _ = this,
      navigables,
      prevNavigable;
    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index;
  };
  Slick.prototype.cleanUpEvents = function () {
    var _ = this;
    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      if (_.options.accessibility === true) {
        _.$dots.off('keydown.slick', _.keyHandler);
      }
    }
    _.$slider.off('focus.slick blur.slick');
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
      }
    }
    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
    _.$list.off('click.slick', _.clickHandler);
    $(document).off(_.visibilityChange, _.visibility);
    _.cleanUpSlideEvents();
    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }
    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
  };
  Slick.prototype.cleanUpSlideEvents = function () {
    var _ = this;
    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };
  Slick.prototype.cleanUpRows = function () {
    var _ = this,
      originalSlides;
    if (_.options.rows > 0) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');
      _.$slider.empty().append(originalSlides);
    }
  };
  Slick.prototype.clickHandler = function (event) {
    var _ = this;
    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };
  Slick.prototype.destroy = function (refresh) {
    var _ = this;
    _.autoPlayClear();
    _.touchObject = {};
    _.cleanUpEvents();
    $('.slick-cloned', _.$slider).detach();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }
    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }
    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
        $(this).attr('style', $(this).data('originalStyling'));
      });
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.detach();
      _.$list.detach();
      _.$slider.append(_.$slides);
    }
    _.cleanUpRows();
    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');
    _.unslicked = true;
    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };
  Slick.prototype.disableTransition = function (slide) {
    var _ = this,
      transition = {};
    transition[_.transitionType] = '';
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.fadeSlide = function (slideIndex, callback) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });
      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });
      if (callback) {
        setTimeout(function () {
          _.disableTransition(slideIndex);
          callback.call();
        }, _.options.speed);
      }
    }
  };
  Slick.prototype.fadeSlideOut = function (slideIndex) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };
  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
    var _ = this;
    if (filter !== null) {
      _.$slidesCache = _.$slides;
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.focusHandler = function () {
    var _ = this;

    _.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (event) {
      var $sf = $(this);
      setTimeout(function () {
        if (_.options.pauseOnFocus) {
          if ($sf.is(':focus')) {
            _.focussed = true;
            _.autoPlay();
          }
        }
      }, 0);
    }).on('blur.slick', '*', function (event) {
      var $sf = $(this);

      if (_.options.pauseOnFocus) {
        _.focussed = false;
        _.autoPlay();
      }
    });
  };
  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
    var _ = this;
    return _.currentSlide;
  };
  Slick.prototype.getDotCount = function () {
    var _ = this;
    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;
    if (_.options.infinite === true) {
      if (_.slideCount <= _.options.slidesToShow) {
        ++pagerQty;
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }
    return pagerQty - 1;
  };
  Slick.prototype.getLeft = function (slideIndex) {
    var _ = this,
      targetLeft,
      verticalHeight,
      verticalOffset = 0,
      targetSlide,
      coef;
    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);
    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
        coef = -1;
        if (_.options.vertical === true && _.options.centerMode === true) {
          if (_.options.slidesToShow === 2) {
            coef = -1.5;
          } else if (_.options.slidesToShow === 1) {
            coef = -2;
          }
        }
        verticalOffset = verticalHeight * _.options.slidesToShow * coef;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
            verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
          } else {
            _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
            verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
        verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
      }
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }
    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }
    if (_.options.vertical === false) {
      targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
    } else {
      targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
    }
    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }
      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }
      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }
    return targetLeft;
  };
  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
    var _ = this;
    return _.options[option];
  };
  Slick.prototype.getNavigableIndexes = function () {
    var _ = this,
      breakPoint = 0,
      counter = 0,
      indexes = [],
      max;
    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }
    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }
    return indexes;
  };
  Slick.prototype.getSlick = function () {
    return this;
  };
  Slick.prototype.getSlideCount = function () {
    var _ = this,
      slidesTraversed,
      swipedSlide,
      swipeTarget,
      centerOffset;
    centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
    swipeTarget = _.swipeLeft * -1 + centerOffset;
    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        var slideOuterWidth, slideOffset, slideRightBoundary;
        slideOuterWidth = $(slide).outerWidth();
        slideOffset = slide.offsetLeft;
        if (_.options.centerMode !== true) {
          slideOffset += slideOuterWidth / 2;
        }
        slideRightBoundary = slideOffset + slideOuterWidth;
        if (swipeTarget < slideRightBoundary) {
          swipedSlide = slide;
          return false;
        }
      });
      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };
  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);
  };
  Slick.prototype.init = function (creation) {
    var _ = this;
    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');
      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();
    }
    if (creation) {
      _.$slider.trigger('init', [_]);
    }
    if (_.options.accessibility === true) {
      _.initADA();
    }
    if (_.options.autoplay) {
      _.paused = false;
      _.autoPlay();
    }
  };
  Slick.prototype.initADA = function () {
    var _ = this,
      numDotGroups = Math.ceil(_.slideCount / _.options.slidesToScroll),
      tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
        return val >= 0 && val < _.slideCount;
      });
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });
    if (_.$dots !== null) {
      _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
        var slideControlIndex = tabControlIndexes.indexOf(i);
        $(this).attr({
          'role': 'tabpanel',
          'id': 'slick-slide' + _.instanceUid + i,
          'tabindex': -1
        });
        if (slideControlIndex !== -1) {
          var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
          if ($('#' + ariaButtonControl).length) {
            $(this).attr({
              'aria-describedby': ariaButtonControl
            });
          }
        }
      });
      _.$dots.attr('role', 'tablist').find('li').each(function (i) {
        var mappedSlideIndex = tabControlIndexes[i];
        $(this).attr({
          'role': 'presentation'
        });
        $(this).find('button').first().attr({
          'role': 'tab',
          'id': 'slick-slide-control' + _.instanceUid + i,
          'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
          'aria-label': i + 1 + ' / ' + numDotGroups,
          'aria-selected': null,
          'tabindex': '-1'
        });
      }).eq(_.currentSlide).find('button').attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).end();
    }
    for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
      if (_.options.focusOnChange) {
        _.$slides.eq(i).attr({
          'tabindex': '0'
        });
      } else {
        _.$slides.eq(i).removeAttr('tabindex');
      }
    }
    _.activateADA();
  };
  Slick.prototype.initArrowEvents = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {
        message: 'previous'
      }, _.changeSlide);
      _.$nextArrow.off('click.slick').on('click.slick', {
        message: 'next'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow.on('keydown.slick', _.keyHandler);
        _.$nextArrow.on('keydown.slick', _.keyHandler);
      }
    }
  };
  Slick.prototype.initDotEvents = function () {
    var _ = this;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$dots.on('keydown.slick', _.keyHandler);
      }
    }
    if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initSlideEvents = function () {
    var _ = this;
    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initializeEvents = function () {
    var _ = this;
    _.initArrowEvents();
    _.initDotEvents();
    _.initSlideEvents();
    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('click.slick', _.clickHandler);
    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(_.setPosition);
  };
  Slick.prototype.initUI = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();
      _.$nextArrow.show();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };
  Slick.prototype.keyHandler = function (event) {
    var _ = this;
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }
  };
  Slick.prototype.lazyLoad = function () {
    var _ = this,
      loadRange,
      cloneRange,
      rangeStart,
      rangeEnd;
    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function () {
        var image = $(this),
          imageSource = $(this).attr('data-lazy'),
          imageSrcSet = $(this).attr('data-srcset'),
          imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
          imageToLoad = document.createElement('img');
        imageToLoad.onload = function () {
          image.animate({
            opacity: 0
          }, 100, function () {
            if (imageSrcSet) {
              image.attr('srcset', imageSrcSet);
              if (imageSizes) {
                image.attr('sizes', imageSizes);
              }
            }
            image.attr('src', imageSource).animate({
              opacity: 1
            }, 200, function () {
              image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            });
            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };
        imageToLoad.onerror = function () {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };
        imageToLoad.src = imageSource;
      });
    }
    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }
    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
        nextSlide = rangeEnd,
        $slides = _.$slider.find('.slick-slide');
      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0) prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }
    loadImages(loadRange);
    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };
  Slick.prototype.loadSlider = function () {
    var _ = this;
    _.setPosition();
    _.$slideTrack.css({
      opacity: '1'
    });
    _.$slider.removeClass('slick-loading');
    _.initUI();
    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };
  Slick.prototype.next = Slick.prototype.slickNext = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'next'
      }
    });
  };
  Slick.prototype.orientationChange = function () {
    var _ = this;
    _.checkResponsive();
    _.setPosition();
  };
  Slick.prototype.pause = Slick.prototype.slickPause = function () {
    var _ = this;
    _.autoPlayClear();
    _.paused = true;
  };
  Slick.prototype.play = Slick.prototype.slickPlay = function () {
    var _ = this;
    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };
  Slick.prototype.postSlide = function (index) {
    var _ = this;
    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);
      _.animating = false;
      if (_.slideCount > _.options.slidesToShow) {
        _.setPosition();
      }
      _.swipeLeft = null;
      if (_.options.autoplay) {
        _.autoPlay();
      }
      if (_.options.accessibility === true) {
        _.initADA();
        if (_.options.focusOnChange) {
          var $currentSlide = $(_.$slides.get(_.currentSlide));
          $currentSlide.attr('tabindex', 0).trigger('focus');
        }
      }
    }
  };
  Slick.prototype.prev = Slick.prototype.slickPrev = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'previous'
      }
    });
  };
  Slick.prototype.preventDefault = function (event) {
    event.preventDefault();
  };
  Slick.prototype.progressiveLazyLoad = function (tryCount) {
    tryCount = tryCount || 1;
    var _ = this,
      $imgsToLoad = $('img[data-lazy]', _.$slider),
      image,
      imageSource,
      imageSrcSet,
      imageSizes,
      imageToLoad;
    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageSrcSet = image.attr('data-srcset');
      imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
      imageToLoad = document.createElement('img');
      imageToLoad.onload = function () {
        if (imageSrcSet) {
          image.attr('srcset', imageSrcSet);
          if (imageSizes) {
            image.attr('sizes', imageSizes);
          }
        }
        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }
        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();
      };
      imageToLoad.onerror = function () {
        if (tryCount < 3) {
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
          _.progressiveLazyLoad();
        }
      };
      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };
  Slick.prototype.refresh = function (initializing) {
    var _ = this,
      currentSlide,
      lastVisibleIndex;
    lastVisibleIndex = _.slideCount - _.options.slidesToShow;

    if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
      _.currentSlide = lastVisibleIndex;
    }

    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    currentSlide = _.currentSlide;
    _.destroy(true);
    $.extend(_, _.initials, {
      currentSlide: currentSlide
    });
    _.init();
    if (!initializing) {
      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);
    }
  };
  Slick.prototype.registerBreakpoints = function () {
    var _ = this,
      breakpoint,
      currentBreakpoint,
      l,
      responsiveSettings = _.options.responsive || null;
    if (Array.isArray(responsiveSettings) && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';
      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }
          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }
      _.breakpoints.sort(function (a, b) {
        return _.options.mobileFirst ? a - b : b - a;
      });
    }
  };
  Slick.prototype.reinit = function () {
    var _ = this;
    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;
    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    _.registerBreakpoints();
    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();
    _.checkResponsive(false, true);
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    _.setPosition();
    _.focusHandler();
    _.paused = !_.options.autoplay;
    _.autoPlay();
    _.$slider.trigger('reInit', [_]);
  };
  Slick.prototype.resize = function () {
    var _ = this;
    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };
  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
    var _ = this;
    if (typeof index === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }
    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }
    _.unload();
    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.setCSS = function (position) {
    var _ = this,
      positionProps = {},
      x,
      y;
    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;
    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }
  };
  Slick.prototype.setDimensions = function () {
    var _ = this;
    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: '0px ' + _.options.centerPadding
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: _.options.centerPadding + ' 0px'
        });
      }
    }
    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();
    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
    }
    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };
  Slick.prototype.setFade = function () {
    var _ = this,
      targetLeft;
    _.$slides.each(function (index, element) {
      targetLeft = _.slideWidth * index * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: '0',
          zIndex: _.options.zIndex - 2,
          opacity: '0'
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: '0',
          zIndex: _.options.zIndex - 2,
          opacity: '0'
        });
      }
    });
    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: '1'
    });
  };
  Slick.prototype.setHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight + 'px');
    }
  };
  Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

    var _ = this,
      l,
      item,
      option,
      value,
      refresh = false,
      type;
    if ($.isPlainObject(arguments[0])) {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if (typeof arguments[0] === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];
      if (arguments[0] === 'responsive' && Array.isArray(arguments[1])) {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }
    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function (opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if (!Array.isArray(_.options.responsive)) {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1;

          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }
            l--;
          }
          _.options.responsive.push(value[item]);
        }
      }
    }
    if (refresh) {
      _.unload();
      _.reinit();
    }
  };
  Slick.prototype.setPosition = function () {
    var _ = this;
    _.setDimensions();
    _.setHeight();
    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }
    _.$slider.trigger('setPosition', [_]);
  };
  Slick.prototype.setProps = function () {
    var _ = this,
      bodyStyle = document.body.style;
    _.positionProp = _.options.vertical === true ? 'top' : 'left';
    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }
    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }
    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }
    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
  };
  Slick.prototype.setSlideClasses = function (index) {
    var _ = this,
      centerOffset,
      allSlides,
      indexOffset,
      remainder;
    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
    _.$slides.eq(index).addClass('slick-current');
    if (_.options.centerMode === true) {
      var evenCoef;
      if (_.options.slidesToShow >= _.$slides.length) {
        evenCoef = -1;
        centerOffset = _.options.slidesToShow = _.$slides.length;
      } else {
        evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
      }
      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
          _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }
        if (index === 0) {
          allSlides.eq(_.options.slidesToShow + _.slideCount + 1).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }
      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
        if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }
    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };
  Slick.prototype.setupInfinite = function () {
    var _ = this,
      i,
      slideIndex,
      infiniteCount;
    if (_.options.fade === true) {
      _.options.centerMode = false;
    }
    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;
      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }
        for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).removeAttr('id').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).removeAttr('id').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).removeAttr('id');
        });
      }
    }
  };
  Slick.prototype.interrupt = function (toggle) {
    var _ = this;
    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;
  };
  Slick.prototype.selectHandler = function (event) {
    var _ = this;
    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index) index = 0;
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideHandler(index, false, true);
      return;
    }
    _.slideHandler(index);
  };
  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
    var targetSlide,
      animSlide,
      oldSlide,
      slideLeft,
      targetLeft = null,
      _ = this,
      navTarget;
    sync = sync || false;
    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }
    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }
    if (sync === false) {
      _.asNavFor(index);
    }
    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }
    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }
    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }
    _.animating = true;
    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;
    _.setSlideClasses(_.currentSlide);
    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');
      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }
    _.updateDots();
    _.updateArrows();
    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);
        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }
    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };
  Slick.prototype.startLoad = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();
      _.$nextArrow.hide();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }
    _.$slider.addClass('slick-loading');
  };
  Slick.prototype.swipeDirection = function () {
    var xDist,
      yDist,
      r,
      swipeAngle,
      _ = this;
    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return _.options.rtl === false ? 'right' : 'left';
    }
    if (_.options.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }
    return 'vertical';
  };
  Slick.prototype.swipeEnd = function (event) {
    var _ = this,
      slideCount,
      direction;
    _.dragging = false;
    _.swiping = false;
    if (_.scrolling) {
      _.scrolling = false;
      return false;
    }
    _.interrupted = false;
    _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
    if (_.touchObject.curX === undefined) {
      return false;
    }
    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }
    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();
      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;
        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;
        default:
      }
      if (direction != 'vertical') {
        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);
        _.touchObject = {};
      }
    }
  };
  Slick.prototype.swipeHandler = function (event) {
    var _ = this;
    if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }
    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }
    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);
        break;
      case 'move':
        _.swipeMove(event);
        break;
      case 'end':
        _.swipeEnd(event);
        break;
    }
  };
  Slick.prototype.swipeMove = function (event) {
    var _ = this,
      edgeWasHit = false,
      curLeft,
      swipeDirection,
      swipeLength,
      positionOffset,
      touches,
      verticalSwipeLength;
    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
    if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
      return false;
    }
    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
    verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
      _.scrolling = true;
      return false;
    }
    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = verticalSwipeLength;
    }
    swipeDirection = _.swipeDirection();
    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      _.swiping = true;
      event.preventDefault();
    }
    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }
    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;
    if (_.options.infinite === false) {
      if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }
    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }
    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }
    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }
    _.setCSS(_.swipeLeft);
  };
  Slick.prototype.swipeStart = function (event) {
    var _ = this,
      touches;
    _.interrupted = true;
    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }
    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }
    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };
  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
    var _ = this;
    if (_.$slidesCache !== null) {
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.unload = function () {
    var _ = this;
    $('.slick-cloned', _.$slider).remove();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }
    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }
    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };
  Slick.prototype.unslick = function (fromBreakpoint) {
    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();
  };
  Slick.prototype.updateArrows = function () {
    var _ = this,
      centerOffset;
    centerOffset = Math.floor(_.options.slidesToShow / 2);
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };
  Slick.prototype.updateDots = function () {
    var _ = this;
    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').end();
      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
    }
  };
  Slick.prototype.visibility = function () {
    var _ = this;
    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };
  $.fn.slick = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (_typeof(opt) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };
});